import { DateTime } from 'luxon';
import { BasicSelectOption, DefaultValueDict } from '../Interfaces/IApplicationForm';
import { DashboardItems, IMarginTiles, IMessage, PushNotification, SubIBs, TreePathDefaultProfile, TierClass, UserPermissionOBjectClass, DMSessionsResult, ProfileSesssions, AccExpSesssions, AccSecTypeClass, EMARKET_EQUITY_POOLS, MARKET_EQUITY_PAYMENT_POOLS } from '../Interfaces/Interfaces';
import { ActionMessage, IPerms, PushNotificationStatus } from '../redux/constants';
import store from '../redux/store';
import { ExternalRoutes } from '../Routes';

declare var window: any;
const $ = require("jquery");
const _ = require('lodash');
const cloneDeep = require('lodash/cloneDeep');
declare var require: any
const timezones: any = require("compact-timezone-list");
const luxonIgnoredTimezones: any = {
    'Antarctica/DumontDUrville': true
};
const moment: any = require('moment');
export function perOptFunction() {
    var perOpt = [
        { value: "hour", label: "Per Hour" },
        { value: "day", label: "Per Day" },
        { value: "mnth", label: "Per Month" },
        { value: "yr", label: "Per Year" }
    ];

    return perOpt;
}
export function ActionTypeOptFunction() {
    var ActionTypeOpt = [
        { value: "-1", label: "Choose Action Type" },
        { value: "Full", label: "Full" },
        { value: "Close Master Trades", label: "Close Master Trades" },
        { value: "Close Slave Trades", label: "Close Slave Trades" },
        { value: "Manage Investors Status", label: "Manage Investors Status" },
        { value: "Manage Allocation Rule Amount", label: "Manage Allocation Rule Amount" },
        { value: "Manage Allocation Rule", label: "Manage Allocation Rule" }
    ];
    return ActionTypeOpt;
}

export function RequestStatusOpFunction() {
    var RequestStatusOp = [
        { value: "1", label: "Approved" },
        { value: "-1", label: "Declined" }
    ];
    return RequestStatusOp;
}
export function RequestStatusOp2Function() {
    var RequestStatusOp = [
        { value: "0", label: "Queued Requests" },
        { value: "1", label: "Delayed Requests" }
    ];
    return RequestStatusOp;
}
export function RequestTypeOpFunction() {
    var RequestTypeOp = [
        { value: "Auto Copy", label: "Auto Copy" },
        { value: "Admin Account", label: "Admin Account" },
        { value: "Account Info", label: "Account Info" },
        { value: "Delete Account", label: "Delete Account" },
        { value: "Deposit", label: "Deposit" },
        { value: "External Transfer", label: "External Transfer" },
        { value: "Internal Transfer", label: "Internal Transfer" },
        { value: "Withdrawal", label: "Withdrawal" },
        { value: "New Account", label: "New Account" }];
    return RequestTypeOp;
}

export function CommisionOptionsFunction() {
    var CommisionOptions = [
        { value: "1", label: "Commission Trade Lot-CTL" },
        { value: "2", label: "Commission Trade Perc-CTP" },
        { value: "0", label: "Both" }
    ];
    return CommisionOptions;
}

export function AllMonthsOptionsFunction() {
    var monthOpt = [
        { value: "01", label: "January" },
        { value: "02", label: "February" },
        { value: "03", label: "March" },
        { value: "04", label: "April" },
        { value: "05", label: "May" },
        { value: "06", label: "June" },
        { value: "07", label: "July" },
        { value: "08", label: "August" },
        { value: "09", label: "September" },
        { value: "10", label: "October" },
        { value: "11", label: "November" },
        { value: "12", label: "December" },
    ];
    return monthOpt;
}
//translation add here 
export const MaritalStatusOpt = [
    { value: "Single", label: "Single" },
    { value: "Engaged", label: "Engaged" },
    { value: "Married", label: "Married" }
]
//#region Investor Options
export const EducationOptions = [
    { value: "-1", label: "Select" },
    { value: "High school", label: "High school" },
    { value: "College", label: "College" },
    { value: "Graduate", label: "Graduate" },
    { value: "Doctorate", label: "Doctorate" }
]
export const PreviousPositionOptions = [
    { value: "-1", label: "-Choose Position-" },
    { value: "Assistant", label: "Assistant" },
    { value: "Administrator", label: "Administrator" },
    { value: "Advisor", label: "Advisor" },
    { value: "Chairman", label: "Chairman" },
    { value: "Clerk", label: "Clerk" },
    { value: "Coordinator", label: "Coordinator" },
    { value: "Director", label: "Coordinator" },
    { value: "Executive", label: "Coordinator" },
    { value: "Head of Department", label: "Head of Department" },
    { value: "Manager", label: "Manager" },
    { value: "Supervisor", label: "Supervisor" },
]
export const IndustryCurrentEmploymentOptions = [
    { value: "-1", label: " -Choose Industry-" },
    { value: "AccountingAudit", label: "Accounting/audit" },
    { value: "Administrative", label: "Administrative" },
    { value: "Agriculture &amp; Agribusiness", label: "Agriculture &amp; Agribusiness" },
    { value: "Banking", label: "Banking" },
    { value: "Beauty &amp; Cosmetics", label: "Beauty &amp; Cosmetics" },
    { value: "Catering", label: "Catering" },
    { value: "Construction", label: "Construction" },
    { value: "Education", label: "Education" },
    { value: "Engineering", label: "Engineering" },
    { value: "Financial Services", label: "Financial Services" },
    { value: "Government", label: "Government" },
    { value: "Healthcare", label: "Healthcare" },
    { value: "Hospitality", label: "Hospitality" },
    { value: "HR", label: "HR" },
    { value: "IT", label: "IT" },
    { value: "Legal Services", label: "Legal Services" },
    { value: "Leisure", label: "Leisure" },
    { value: "Marketing", label: "Marketing" },
    { value: "Media &amp; Broadcasting", label: "Media &amp; Broadcasting" },
    { value: "Pharmaceuticals", label: "Pharmaceuticals" },
    { value: "Real Estate", label: "Real Estate" },
    { value: "Retail", label: "Retail" },
    { value: "Sales", label: "Sales" },
    { value: "SocialCare", label: "Social Care" },
    { value: "Telecommunications", label: "Telecommunications" },
    { value: "Travel and Tourism", label: "Travel and Tourism" },
    { value: "Other", label: "Other" }
]
export const unavailableTINtOptions = [
    { value: "-1", label: " -ChooseAnswer-" },
    { value: "CountryNotIssueTINToResidents", label: "CountryNotIssueTINToResidents" },
    { value: "NoTINRequiredInRegion", label: "NoTINRequiredInRegion" },
    { value: "Other", label: "Other" },

]
export const EmploymentStatusOptions = [
    { value: "-1", label: 'ChooseStatus' },
    { value: "EmployedPartTime", label: 'EmployedPartTime' },
    { value: "Employed", label: 'EmployedFullTimeNotSenior' },
    { value: "EmployedFullTimeSenior", label: 'EmployedFullTimeSenior' },
    { value: "Property owner", label: 'PropertyOwner' },
    { value: "Self-Employed", label: 'SelfEmployed' },
    { value: "Student", label: 'Student' },
    { value: "Retired", label: 'Retired' },
    { value: "Unemployed", label: 'Unemployed' },
]

//#endregion

// #region Trading Experience Options

export const MonthlyAverageVolumeOptions = [
    { value: "-1", label: 'ChooseAverage' },
    { value: "Less than 1 Million", label: 'LessThanOneMillion' },
    { value: "1-5 Million", label: 'OneToFiveMillion' },
    { value: "5-50 Million", label: 'FiveToFiftyMillion' },
    { value: "Over 50 Million", label: 'OverFiftyMillion' }
];

export const PurposeAndNatureOfTradingOptions = [
    { value: "-1", label: 'ChoosePurpose' },
    { value: "Speculative", label: 'Speculative' },
    { value: "Hedging", label: 'Hedging' },
    { value: "Investment", label: 'Investment' },
    { value: "Income", label: 'Income' },
    { value: "Other", label: 'Other' },
];

export const PurposeOfOpeningTheAccountOptions = [
    { value: "-1", label: 'ChoosePurpose' },
    { value: "Speculation", label: 'Speculation' },
    { value: "Hedging", label: 'Hedging' },
];

export const CurrentLevelOfKnowledgeOptions = [
    { value: "-1", label: 'ChooseLevel' },
    { value: "None/ Limited/ Basic experience", label: 'NoneLimitedBasicExperience' },
    { value: "Experience in mainstream financial products", label: 'ExperienceInMainstreamFinancialProducts' },
    { value: "Experience in most financial products", label: 'ExperienceInMostFinancialProducts' },
    { value: "Professional Investor or frequent traders", label: 'ProfessionalInvestorOrFrequentTraders' }
];

export const HowLongHaveYouTradedForexOptions = [
    { value: "-1", label: 'ChoosePeriod' },
    { value: "No experience", label: 'NoExperience' },
    { value: "Less than 1 Year", label: 'LessThanOneYear' },
    { value: "1-5 years", label: 'OneToFiveYears' },
    { value: "Greater than 5 years", label: 'GreaterThanFiveYears' }
];

export const HowManyTradesDoYouPlaceEachMonthOptions = [
    { value: "-1", label: 'ChoosePlacements' },
    { value: "0-3", label: "0 - 3 " },
    { value: "4-10", label: " 4 - 10 " },
    { value: "11-50", label: " 11 - 50" },
    { value: "greater than 50", label: 'GreaterThanFifty' }
];

export const OverWhatTimeframeHaveYouHeldPositionsOptions = [
    { value: "-1", label: 'ChooseTimeframe' },
    { value: "Always less than 1 month", label: 'AlwaysLessThanOneMonth' },
    { value: "Both less and more than 1 month", label: 'BothLessAndMoreThanOneMonth' },
    { value: "I have never traded before", label: 'IHaveNeverTradedBefore' }
];

export const StocksMutualFundsBondsEquitiesOptions = [
    { value: "-1", label: 'ChooseExtent' },
    { value: "Never or rarely", label: 'NeverOrRarely' },
    { value: "Occasionally (up to 25 trades per year)", label: 'Occasionally' },
    { value: "Regularly (between 25 to 100 trades per year)", label: 'Regularly' },
    { value: "Frequently (over 100 trades per year)", label: 'Frequently' },
];

export const DerivativesSuchAsFuturesOptionsSwapsOptions = [
    { value: "-1", label: 'ChooseExtent' },
    { value: "Never or rarely", label: 'NeverOrRarely' },
    { value: "Occasionally (up to 25 trades per year)", label: 'Occasionally' },
    { value: "Regularly (between 25 to 100 trades per year)", label: 'Regularly' },
    { value: "Frequently (over 100 trades per year)", label: 'Frequently' },
];

export const ForexRollingSpotFXSpreadBetsOptions = [
    { value: "-1", label: 'ChooseExtent' },
    { value: "Never or rarely", label: 'NeverOrRarely' },
    { value: "Occasionally(up to 25 trades per year)", label: 'Occasionally' },
    { value: "Regularly(between 25 to 100 trades per year)", label: 'Regularly' },
    { value: "Frequently (over 100 trades per year)", label: 'Frequently' },
];

export const WhatWasTheAverageYearlyVolumeOptions = [
    { value: "-1", label: 'ChooseAverage' },
    { value: "I never invested", label: 'I never invested' },
    { value: "Less than €1000", label: 'Less than €1000' },
    { value: "Between €1000 to €5,000", label: 'Between €1000 to €5, 000' },
    { value: "Between €5,000 to €25,000", label: 'Between €5, 000 to €25, 000' },
    { value: "Over €25,000", label: ' Over €25, 000' }

];

export const WhatWasTheAverageLevelOfLeverageOptions = [
    { value: "-1", label: 'ChooseAverage' },
    { value: 'I never used leverage', label: 'INeverUsedLeverage' },
    { value: 'Lower than 1:10', label: 'Lower than 1: 10' },
    { value: 'Between 1:10 - 1:25', label: ' Between 1: 10 - 1: 25' },
    { value: 'Between 1:25 - 1:50', label: ' Between 1: 25 - 1: 50' },
    { value: 'Between 1:50 - 1:100', label: ' Between 1: 50 - 1: 100' },
    { value: 'Higher than 1:100', label: ' Higher than 1: 100' }
];

export const MaximumLeverageUsedOptions = [
    { value: '-1', label: 'ChooseAverage' },
    { value: 'I have never used leverage', label: 'INeverUsedLeverage' },
    { value: 'Up to 5:1', label: ' Up to 5:1' },
    { value: 'Up to 30:1', label: ' Up to 30:1' },
    { value: 'Up to 100:1', label: ' Up to 100:1' },
    { value: '>100:1', label: '>100:1 ' },
];
// #endregion
//#region trading knowledge selects
export const EducationalQualificationOptions = [
    { value: '-1', label: 'ChooseQualification' },
    { value: 'University Degree or post graduate', label: 'UniversityDegreeOrPostGraduate' },
    { value: 'Seminars relevant to the CFDs leverage products', label: 'SeminarsRelevantToTheCFDs' },
    { value: 'Other', label: 'Other' },
    { value: 'Up to 100:1', label: 'Up to 100:1' },
    { value: 'None', label: 'None' },
];
export const TheStopLossOrderIsUsedToOptions = [
    { value: '-1', label: 'ChooseUsage' },
    { value: 'Reduce / Limit the loss', label: 'ReduceLimitTheLoss' },
    { value: 'Increase Loss', label: 'IncreaseLoss' },
];
export const InvestmentOptions = [
    { value: '-1', label: 'ChooseInvestment' },
    { value: 'CFDs', label: 'CFDs' },
    { value: 'ETFs', label: 'ETFs' },
    { value: 'Shares', label: 'Shares' },
    { value: 'Real estate', label: 'Realestate' },
    { value: 'Bank Bonds', label: 'BankBonds' },
];
export const HowMuchMarginIsRequiredOptions = [
    { value: '-1', label: 'ChooseMargin' },
    { value: '1,000 EUR', label: '1,000 EUR' },
    { value: '100 EUR', label: '100 EUR' },
    { value: '5,000 EUR', label: '5,000 EUR' },
    { value: '1,000 USD', label: '1,000 USD' }
];
export const TheMarketIsMovingAgainstYouOptions = [
    { value: '-1', label: 'ChooseSituation' },
    { value: 'The account equity reaches 50% of the used margin', label: 'The account equity reaches 50% of the used margin' },
    { value: 'The account equity reaches zero', label: 'The account equity reaches zero' },
    { value: 'The account equity reaches 50% of the account balance', label: 'The account equity reaches 50% of the account balance' },
    { value: 'None of the above', label: 'None of the above' }
];
export const WhenTradingWithHigherLeverageOptions = [
    { value: '-1', label: 'ChooseAnswer' },
    { value: 'Risk is reduced', label: 'RiskIsReduced' },
    { value: 'The profit and loss of a 1.00 lot position is multiplied', label: 'PositionIsMultiplied' },
    { value: 'Positions can be opened with more national exposure than available balance', label: 'PositionsCanBeOpened' }
];
export const StopOutBeTriggeredOptions = [
    { value: '-1', label: 'ChooseAnswer' },
    { value: 'When the equity reaches 500 USD', label: 'EquityReaches500' },
    { value: 'When the equity reaches 250 USD', label: 'EquityReaches250' },
    { value: 'When the equity goes negative', label: 'EquityGoesNegative' },
    { value: 'When the equity reaches 50 USD', label: 'EquityReaches50' }
];
export const KnowledgeLVLOptions = [
    { value: '-1', label: 'ChooseAnswer' },
    { value: 'None', label: 'None' },
    { value: 'Beginner', label: 'Beginner' },
    { value: 'Experienced', label: 'Experienced' }
];
export const HowManyTradesHaveYouExecutedOptions = [
    { value: '-1', label: 'ChooseRange' },
    { value: 'None', label: 'None' },
    { value: '1-25', label: '1-25' },
    { value: '26-50', label: '26-50' },
    { value: '51-75', label: '51-75' },
    { value: '100+', label: '100+' },
];
export const HowHaveYouTradedProductsOptions = [
    { value: '-1', label: 'ChooseAnswer' },
    { value: 'Not Applicable', label: 'NotApplicable' },
    { value: 'I made my own trading decisions', label: 'IMadeMyOwnTradingDecisions' },
    { value: 'My funds were managed and/or I took advice', label: 'MyFundsWereManaged' },
    { value: 'A combination of my own trading decisions and funds being managed', label: 'ACombinationOfMyOwnTradingDecisions' }
];
export const WhySpreadFloatingQnsOptions = [
    { value: "-1", label: ' -Choose Answer -' },
    { value: "The best bid and ask prices available on an ECN are streamed", label: ' The best bid and ask prices available on an ECN are streamed' },
    { value: "Multiple price feeds are aggregated", label: ' Multiple price feeds are aggregated' },
    { value: "The available liquidity in a security constantly changes", label: ' The available liquidity in a security constantly changes' },
    { value: "All of the above", label: 'All of the above' }
];
//#endregion
//#region ProfessionalClientStatusTab
export const RoleHoldWithEmployerOptions = [
    { value: '-1', label: 'SelectRole' },
    { value: 'Account Manager', label: 'AccountManager' },
    { value: 'Senior Manager', label: 'SeniorManager' },
    { value: 'Analyst/Researcher', label: 'Analyst/Researcher' },
    { value: 'Educator', label: 'Educator' },
    { value: 'Operational Manager', label: 'OperationalManager ' },
    { value: 'Risk Manager', label: 'RiskManager ' },
    { value: 'Other', label: 'Other ' },
];
export const ProvideAverageNumberOptions = [
    { value: '-1', label: 'SelectAverage' },
    { value: '30+', label: '30 +' },
    { value: '20-29', label: ' 20 - 29' },
    { value: '10-19', label: ' 10 - 19' },
    { value: '0-9', label: '0-9' },
];
//#endregion
//function to translate labels
export function translateSelectOptions(list: Array<BasicSelectOption>, t: Function) {//add the render to fixed 

    for (let i = 0; i < list.length; i++) {
        try {
            if (t(list[i].label)) {
                list[i].label = t(list[i].label)
            }
        }
        catch (e) {
            console.error(e)
            //list[i].label = list[i].label /*+ " -- Translation needed "*/;
        }
    }
    return list;
}
//#region client page
export const clientPageType = [ // check add Name attribute
    { value: 1, label: 1 },
    { value: 2, label: 2 },
    { value: 3, label: 3 },
    { value: 4, label: 4 },
    { value: 5, label: 5 },
];
//#endregion

export const RequestTypeOp = [
    { value: "Auto Copy", label: "Auto Copy" },
    { value: "Deposit", label: "Deposit" },
    { value: "Account Info", label: "Account Info" },
    { value: "Wallet Deposit", label: "Wallet Deposit" },
    { value: "Delete Account", label: "Delete Account" },
    { value: "Change Leverage", label: "Change Leverage" },
    { value: "Withdrawal", label: "Withdrawal" },
    { value: "Wallet Withdrawal", label: "Wallet Withdrawal" },
    { value: "External Transfer", label: "External Transfer" },
    { value: "Internal Transfer", label: "Internal Transfer" },
    { value: "External Wallet Transfer", label: "External Wallet Transfer" },
    { value: "Internal Wallet Transfer", label: "Internal Wallet Transfer" },
    { value: "New Account", label: "New Account" }
];
export const AccountRequestTypeOp = [
    { value: "Auto Copy", label: "Auto Copy" },
    { value: "Account Info", label: "Account Info" },
    { value: "Delete Account", label: "Delete Account" },
    { value: "Change Leverage", label: "Change Leverage" },
    { value: "New Account", label: "New Account" }
];

export const TransactionRequestTypeOp = [
    { value: "Deposit", label: "Deposit" },
    { value: "Wallet Deposit", label: "Wallet Deposit" },
    { value: "Withdrawal", label: "Withdrawal" },
    { value: "Wallet Withdrawal", label: "Wallet Withdrawal" },
    { value: "External Transfer", label: "External Transfer" },
    { value: "Internal Transfer", label: "Internal Transfer" },
    { value: "External Wallet Transfer", label: "External Wallet Transfer" },
    { value: "Internal Wallet Transfer", label: "Internal Wallet Transfer" },
];
export const RequestStatusOption = [
    { value: "1", label: "Approved" },
    { value: "-1", label: "Declined" }
]
export const PrivilegesOption = [
    { value: "-1", label: "-Select Privilege" },
    { value: "1", label: "Client" },
    { value: "2", label: "Back Office" },
    { value: "3", label: "Both" },
];
export function ValidateSelect(selected: any) {
    if (selected === null) return false;
    if (selected === undefined || selected.label === undefined || selected.value === undefined) return false;
    if (String(selected.value) === "-1") return false;
    return selected.value !== -1;
}
export function LogMessage(...allArgs: any) {
    try {
        let args: any = Array.prototype.slice.call(arguments);
        console.log.apply(console, args);
    }
    catch (e) {
        console.error(e);
    }
}
export function ValidateMultiSelect(selected: any[]) {
    if (selected === undefined || selected === null || selected.length === 0) return false;
    return true;
}
export function ValidateInput(value: string): boolean {//as !value can't check number
    return (value !== null && value !== undefined && value !== "");
}
export function validateCheckBoxIsTrue(value: boolean): boolean {
    return (value !== null && value !== undefined && value === true);
}
export function returnSelect(value: any): string {
    if (!value || String(value) === "-1" || String(value) === "undefined")
        return "Select"
    return value;
}
export function returnZero(value: any): string {
    if (String(value) === "-1")
        return "0"
    return value;
}
export function CastOptionsToScore(FieldID: string, BasicSelectOptions: BasicSelectOption[]) {
    let _castedObject: any[] = [...BasicSelectOptions];
    _castedObject = _castedObject
        .filter((item: BasicSelectOption) => String(item.value) !== "-1")
        .map((item: BasicSelectOption, index: number) => {
            return {
                SID: parseInt(String(index + 1), 10),
                FieldID: FieldID,
                Value: item.label,
                Score: 0,
                FieldIndex: String(index + 1),
            }
        })
    return _castedObject;
}
export function CastCheckBoxesToScore(FieldID: string, BasicSelectOptions: string[]) {
    let _castedObject: any[] = [...BasicSelectOptions];
    _castedObject = _castedObject.map((item: string, index: number) => {
        return {
            SID: parseInt(String(index + 1), 10),
            FieldID: FieldID,
            Value: item,
            Score: 0,
            FieldIndex: String(index + 1),
        }
    })
    return _castedObject;
}
export function isDate(date: string) {
    if (!date) return "2000-01-01";
    let dateReg: any = /^\d{4}([./-])\d{2}\1\d{2}$/;
    if (date.match(dateReg))//return null if not match 
        return date;
    return "2000-01-01";
}
export function validateDate(date: any): boolean {
    if (!date) return false;
    if (date === "0001-01-01T00:00:00") return false;
    if (date)
        date = date.split("T")[0];
    let dateReg: any = /^\d{4}([./-])\d{2}\1\d{2}$/;
    return date.match(dateReg) ? true : false;
}
export function validateDateAndInternval(date: Date, interval: any): boolean {
    if (!date) console.debug("error date");
    if (interval === undefined || interval === null) console.debug("error max");
    //console.log(typeof date);
    //console.log(typeof max);
    if (!date || (interval === undefined || interval === null)) return false;
    if (interval !== 0)
        return validateDateInterval(new Date(String(date)), interval);
    else
        return validateDateInterval(new Date(), new Date(String(date)));
}
export function validateDateIsValid(_date: Date, Start: Date, End: Date, isStart: boolean): boolean {
    // IsStart disabled as data not hardcoden now
    return _date >= Start && _date <= End;
}
export function validateDateAndReturnDate(date: any): string {//dont split date so it can be used
    return validateDate(date) ? moment(new Date(date.toString())).format('MM/DD/YY h:mm:ss A') : ' - ';
}
export function validateDateInterval(Start: Date, End: Date): boolean {
    return Start <= End;
}
export function validateDateRange(date: any): boolean {
    let fromDate: any = '';
    let toDate: any = '';
    if (date) {
        fromDate = date.split(',')[0];
        toDate = date.split(',')[1];
    }
    let dateReg: any = /^\d{4}([./-])\d{2}\1\d{2}$/;
    let from = fromDate.match(dateReg) ? true : false;
    let to = toDate.match(dateReg) ? true : false;
    return from && to;
}
export function SetUSAFirstCounty(CountryLists: any[]) {
    try {
        if (!CountryLists) return [];
        let _finalList: any = [];
        let _newList: any = [...CountryLists];
        let _USACountry: any = [];
        _USACountry = [..._newList.filter((item: any) => item.CountryName === "United States")];
        _newList = _newList.filter((item: any) => item.CountryName !== "United States");
        _finalList.push(..._USACountry);
        _finalList.push(..._newList);
        return _finalList;
    } catch (e) {
        console.error('SetUSAFirstCounty: ', e);
        return CountryLists;
    }
}
export function SetFirstCounty(CountryName: string, CountryLists: any[]) {
    try {
        if (!CountryLists) return [];
        let _finalList: any = [];
        let _newList: any = [...CountryLists];
        let _USACountry: any = [];
        _USACountry = [..._newList.filter((item: any) => item.CountryName === CountryName)];
        _newList = _newList.filter((item: any) => item.CountryName !== CountryName);
        _finalList.push(..._USACountry);
        _finalList.push(..._newList);
        return _finalList;
    } catch (e) {
        console.error('SetUSAFirstCounty: ', e);
        return CountryLists;
    }
}
export function validateEmail(email: any) {
    if (!email) return false;
    let regex = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}/igm;
    return regex.test(email);
}
export function GetPushNoticationifOn(name: string, list: PushNotification[]) {
    try {
        if (!list) return false;
        let _allNotification: PushNotification[] = [...list];
        let _nameExist: boolean = [..._allNotification].some((item: PushNotification) => ((item && item.PNDescription) && (item.PNDescription.toLowerCase() === name.toLowerCase())));
        return _nameExist;
    } catch (e) {
        console.error(e);
        return true;
    }
}
export function GetPermValName(name: string, list: IPerms[]) {
    try {
        if (!list) return "Deny"
        let _allpermsList: IPerms[] = [...list];
        let _parentList: any[] = [..._allpermsList].filter((item: IPerms) => (item && item.PermName) && (item.PermName.toLowerCase() === name.toLowerCase()));
        let _name = _parentList.length === 0 ? "Deny" : _parentList[0].PermValName;
        return _name;
    } catch (e) {
        console.error(e);
        return "Deny"
    }
}
export function GetPermissionDetailsByName(name: string, list: IPerms[]) {
    try {
        if (!list)
            return {
                Allowed: false,
                Perms: []
            };
        let _allpermsList: IPerms[] = [...list];
        let _parentList: any[] = [..._allpermsList].filter((item: IPerms) => (item && item.PermName) && (item.PermName.toLowerCase() === name.toLowerCase()));
        let _parentID = _parentList.length === 0 ? 0 : _parentList[0].PermID;
        let _allowed = _parentList.length === 0 ? false : ((_parentList[0].PermValID ? true : false) && (_parentList[0].PermValID !== EPermissionValue.Deny) ? true : false);
        let _children = [...list].filter((item: IPerms) => item.ParentPermID === _parentID);
        return {
            Allowed: _allowed,
            Perms: _allowed ? [..._parentList, ..._children] : [] //as if deny no perm should be allowed 
        };
    } catch (e) {
        console.error(e);
        return {
            Allowed: false,
            Perms: []
        };
    }
}
export function CheckIfPermAlllowedByName(name: string, list: IPerms[]) {
    try {
        let _allpermsList: IPerms[] = [...list];
        let _nameList: any[] = [..._allpermsList].filter((item: IPerms) => (item && item.PermName) && item.PermName.toLowerCase() === name.toLowerCase());
        let _allowed = _nameList.length === 0 ? false : ((_nameList[0].PermValID ? true : false) && (_nameList[0].PermValID !== EPermissionValue.Deny) ? true : false);//if Null false && any is false //2 is deny
        return _allowed
    } catch (e) {
        console.error(e);
        return false;
    }
}
export function GetPermIDByPermName(name: string, list: IPerms[]) {
    try {
        let _allpermsList: IPerms[] = [...list];
        let _nameList: any[] = [..._allpermsList].filter((item: IPerms) => (item && item.PermName) && item.PermName.toLowerCase() === name.toLowerCase());
        let _allowed = _nameList.length === 0 ? false : ((_nameList[0].PermValID ? true : false) && (_nameList[0].PermValID !== EPermissionValue.Deny) ? true : false);
        return (_allowed && _nameList && _nameList[0]?.PermID) ? +(_nameList[0]?.PermID) : 0;
    } catch (e) {
        console.error(e);
        return 0;
    }
}
export function GetPermissionDetailsByNameAndID(name: string, list: IPerms[], PermID: number) {
    try {
        if (!list)
            return {
                Allowed: false,
                Perms: []
            };
        let _allpermsList: IPerms[] = [...list];
        let _parentList: any[] = [..._allpermsList].filter((item: IPerms) => ((item && item.PermName) && (item.PermName.toLowerCase() === name.toLowerCase()))
            && (String(item.PermID) === String(PermID))
        );
        let _parentID = _parentList.length === 0 ? 0 : _parentList[0].PermID;
        let _allowed = _parentList.length === 0 ? false : ((_parentList[0].PermValID ? true : false) && (_parentList[0].PermValID !== EPermissionValue.Deny) ? true : false);
        let _children = [...list].filter((item: IPerms) => item.ParentPermID === _parentID);
        return {
            Allowed: _allowed,
            Perms: _allowed ? [..._parentList, ..._children] : [] //as if deny no perm should be allowed 
        };
    } catch (e) {
        console.error(e);
        return {
            Allowed: false,
            Perms: []
        };
    }
}
export function TempGetPermissionDetailsByName(name: string, list: IPerms[]) {
    return {
        Allowed: true,
        Perms: []
    }
}
export function TempCheckIfPermAlllowedByName(name: string, list: IPerms[]) { return true }
export function deepCopyFunction(inObject: any) {
    let outObject: any, value: any, key: any;

    if (typeof inObject !== "object" || inObject === null) {
        return inObject // Return the value if inObject is not an object
    }

    // Create an array or object to hold the values
    outObject = Array.isArray(inObject) ? [] : {}

    for (key in inObject) {
        value = inObject[key]

        // Recursively (deep) copy for nested objects, including arrays
        outObject[key] = deepCopyFunction(value)
    }

    return outObject
}
export const ValidationTXT: any = ["error", "success", "validating", "warning", ""];
export function validateCommaSeparatedStrings(text: string) {
    //var regex = /[!@#$%^&*\-\_(),.? ":{}|<>1234567890]/g
    if (!text || text === "") return false;
    if (text === "*") return true;
    //var _regexComma = /^\w(,?\w)*$/;
    /* var _regexComma = /^[^,\s]\S*$/;//as special characters allowed*/
    if (text.startsWith(" ") || text.endsWith(" ")) return false;
    const allArray = text.split(",");
    return !allArray.some((item: string) => item.startsWith(" ") || item.endsWith(" "))
    //return text.match(_regexComma) ? true : false;
}
export function validateCommaSeparatedStringsSecuirties(text: string) {
    if (!text || text === "") return false;
    if (text === "*") return true;
    //var _regexComma = /^[^,\s].*$/;//all special and space
    //return text.match(_regexComma) ? true : false;
    if (text.startsWith(" ") || text.endsWith(" ")) return false;
    const allArray = text.split(",");
    return !allArray.some((item: string) => item.startsWith(" ") || item.endsWith(" "))
}
export function validateCommaSeparatedStringsTrue(text: string) {
    //var regex = /[!@#$%^&*\-\_(),.? ":{}|<>1234567890]/g
    if (!text || text === "") return true;
    if (text === "*") return true;
    /*only check is on spaces as special characters are different*/
    const list = text.split(',');
    for (let element of list) {
        if (element.startsWith(" ") || element.endsWith(" ")) {
            return false;
        }
    }
    return true;
    //var _regexComma = /^\w(,?\w)*$/;
    //var _regexComma = /^[^,\s]\S*$/;//as special characters allowed
    //return text.match(_regexComma) ? true : false;
}
export function validateCommaSeparatedNumberTrue(text: string) {
    if (!text || text === "") return true;
    if (text === "*") return true;
    var _regexComma = /^\d+(,\d+)*$/;
    return text.match(_regexComma) ? true : false;
}
export function validateCommaSeparatedTextTrue(text: string) {
    if (!text || text === "") return true;
    if (text === "*") return true;
    var _regexComma = /^[a-zA-z]+(,[a-zA-z]+)*$/;
    return text.match(_regexComma) ? true : false;
}

export function DisplayAllocationRules(list: any, Allowed: boolean, UserAllocationPermissions: IPerms[]): any[] {
    if (!Allowed) return [{ value: -1, label: "No Allocations" }];
    if (!list) return [];
    let ELS: string = CheckIfPermAlllowedByName('ELS', UserAllocationPermissions) ? 'ELS' : '';
    let ECS: string = CheckIfPermAlllowedByName('ECS', UserAllocationPermissions) ? 'ECS' : '';
    let EV: string = CheckIfPermAlllowedByName('EV', UserAllocationPermissions) ? 'EV' : '';
    let Percentage: string = CheckIfPermAlllowedByName('Percentage', UserAllocationPermissions) ? 'Percentage' : '';
    let Multiplier: string = CheckIfPermAlllowedByName('Multiplier', UserAllocationPermissions) ? 'Multiplier' : '';
    let BLS: string = CheckIfPermAlllowedByName('BLS', UserAllocationPermissions) ? 'BLS' : '';
    let FixedLot: string = CheckIfPermAlllowedByName('Fixed Lot', UserAllocationPermissions) ? 'Fixed Lot' : '';
    let Equity: string = CheckIfPermAlllowedByName('% of Equity', UserAllocationPermissions) ? '% of Equity' : '';
    //console.log({ list, Allowed, UserAllocationPermissions })
    //console.log(ELS || ECS || EV || Percentage || Multiplier || BLS || FixedLot || Equity)
    let _newAllocationRuleList: any[] = [...list];
    _newAllocationRuleList = _newAllocationRuleList.filter((item: any) => (item && item.aRuleName && (item.aRuleName === ELS || item.aRuleName === ECS || item.aRuleName === EV
        || item.aRuleName === Percentage || item.aRuleName === Multiplier || item.aRuleName === BLS || item.aRuleName === FixedLot || item.aRuleName === Equity)));
    return _newAllocationRuleList;

}

export function DisplaySignalsAllocation(list: any) {
    if (!list) return [];
    let ELS: string = '';
    let ECS: string = '';
    let EV: string = 'EV';
    let Percentage: string = '';
    let Multiplier: string = '';
    let BLS: string = '';
    let FixedLot: string = 'Fixed Lot';
    let Equity: string = '% of Equity';
    let _newAllocationRuleList: any[] = [...list];
    _newAllocationRuleList = _newAllocationRuleList.filter((item: any) => (item && item.aRuleName && (item.aRuleName === ELS || item.aRuleName === ECS || item.aRuleName === EV
        || item.aRuleName === Percentage || item.aRuleName === Multiplier || item.aRuleName === BLS || item.aRuleName === FixedLot || item.aRuleName === Equity)));
    return _newAllocationRuleList;

}

export function dynamicSort(property: any) {
    var sortOrder = 1;
    if (property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
    }
    return function (a: any, b: any) {
        var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
        return result * sortOrder;
    }
}
export function ConvertIntoDictionary(list: any[], key: any) {
    let _newDict: any = [...list].reduce((obj: any, item: any, index: number) => {
        obj[item[key]] = item
        return obj
    }, {});
    return _newDict;
}
export function ConvertIntoDictionaryWithSpecificValue(list: any[], key: any, value: any) {
    let _newDict: any = [...list].reduce((obj: any, item: any, index: number) => {
        obj[item[key]] = value
        return obj
    }, {});
    return _newDict;
}
export function checkIfTemplateExistInBothClientAdmin(emailTEmplateName: string) {
    let _list: any = [
        'User Reset Password ', // DB it includes sapce   
        'Demo Trading account added',
        'Live Trading Account added',
        'New Live Account Request',
        'Close Live Account Request',
        'Leverage Live Account Change Request',
        'Deposit Live Account request',
        'withdrawal Live Account request',
        'Internal Transfer Live Account request',
        'External Transfer Live Account request',
        'Application Requests',
        'Documents expired',
        'Subscribe/Unsubscribe To Signal Request',
        'Client Claimed Bonus']
    try {
        return _list.includes(emailTEmplateName);
    } catch (e) {
        console.error(e);
        return false;
    }

}
export function StringTemp(ServerType: any) {
    if (String(ServerType) === "MT4") return 'MT4';
    if (String(ServerType) === "MT5") return 'MT5';
    try {
        return String(ServerType) === "4" ? "MT4" : "MT5";
    } catch (e) {
        console.error(e);
        return 'MT4';
    }

}
export function isNumber(value: any) {
    return typeof value === 'number' && isFinite(value);
}
export function validateNumber(_number: any) {
    return _number !== undefined && _number !== null && isNumber(_number);
}
export const levelofeducationList =
    [{ value: "-1", label: "Select" },
    { value: "IHoldProfessionalQualification", label: "I HoldProfessional Qualification" },
    { value: "IReceivedHigherEducation", label: "I Received Higher Education" },
    { value: "IHoldABachelor", label: "I Hold A Bachelor" },
    { value: "InTheLastThreeYears", label: "In The Last Three Years" },
    { value: "NoneOfTheAbove", label: "None Of The Above" }];
export const SourceOfFundsList =
    [{ value: "BusinessOwnership", label: "Business Owner ship" },
    { value: "PropertyLandInvestments", label: "Property Land Investments" },
    { value: "FamilyIncomeRelationship", label: "Family Income Relationship" },
    { value: "PersonalSaving", label: "Personal Saving" },
    { value: "InsurancePayout", label: "Insurance Payout" },
    { value: "IncomeFromEmployment", label: "Income From Employment" },
    { value: "CommissionsRevenuesBonuses", label: "Commissions Revenues Bonuses" },
    { value: "ReturnOnInvestmentsSharesDividends", label: "Return OnInvestments Shares Dividends" },
    { value: "BankingFacilities", label: "Banking Facilities" },
    { value: "Inheritance", label: "Inheritance" },
    { value: "Other", label: "Other" },
    ];
export function ValidateAndReturnInput(input: string): string {
    if (!input) return "";
    return input;
}
export function CheckIfNotificationIsEnabledByID(PNID: number, list: PushNotificationStatus[]): boolean {
    let _list: any[] = [...list];
    let _isEnabled: boolean = _list.some((item: PushNotificationStatus) => +(item.PNID) === +(PNID));
    return _isEnabled;
}
export function CheckIfNotificationIsEnabledByName(PNDescription: string, list: PushNotificationStatus[]): boolean {
    let _list: any[] = [...list];
    let _isEnabled: boolean = _list.some((item: PushNotificationStatus) => String(item.PNDescription) === String(PNDescription));
    return _isEnabled;
}
export function password_generator(len: any) {
    let length = (len) ? (len) : (10);
    let string = "abcdefghijklmnopqrstuvwxyz"; //to upper
    let numeric = '0123456789';
    let punctuation = '!@#$%^&';
    let password = "";
    let character = "";
    while (password.length < length) {
        let _string = Math.ceil(string.length * Math.random() * Math.random());
        let _numbers = Math.ceil(numeric.length * Math.random() * Math.random());
        let _specialCharacters = Math.ceil(punctuation.length * Math.random() * Math.random());
        let _captialLetter = string.charAt(_string);//captial letter
        _captialLetter = (password.length % 2 === 0) ? (_captialLetter.toUpperCase()) : (_captialLetter);
        character += _captialLetter;
        character += numeric.charAt(_numbers);
        character += punctuation.charAt(_specialCharacters);
        password = character;
    }
    password = password.split('').sort(function () { return 0.5 - Math.random() }).join('');
    return password.substr(0, len);
}
export function UpperCaseExists(password: string): boolean {
    let UpperCase = /^(?=.*[A-Z])/;
    if (password.match(UpperCase)) {
        return true;
    }
    return false;
}
export function LowerCaseExists(password: string): boolean {
    let lowerCase = /^(?=.*[a-z])/;
    if (password.match(lowerCase)) {
        return true;
    }
    return false;
}
export function NumberExists(password: string): boolean {
    let numbers = /^(?=.*[0-9])/;
    if (password.match(numbers)) {
        return true;
    }
    return false;
}
export function SpecialCharacterExists(password: string): boolean {
    let special = /^(?=.*[$@$!%*#?&])/;
    if (password.match(special)) {
        return true;
    }
    return false;
}
export function CheckPasswordStrength(password: string) {
    ////if textBox is empty
    //if (password.length === 0) {
    //    return -1;
    //}
    ////Regular Expressions
    //var regex: any[] = [];
    //regex.push("[A-Z]"); //For Uppercase Alphabet
    //regex.push("[a-z]"); //For Lowercase Alphabet
    //regex.push("[0-9]"); //For Numeric Digits
    //regex.push("[$@$!%*#?&]"); //For Special Characters
    //var passed = 0;
    ////Validation for each Regular Expression
    //for (var i = 0; i < regex.length; i++) {
    //    if ((new RegExp(regex[i])).test(password)) {
    //        passed++;
    //    }
    //}
    ////Validation for Length of Password
    //if (passed > 2 && password.length > 8) {
    //    passed++;
    //}
    //return passed;
    if (!password || password.length === 0) {
        return -1;
    }
    let passed = 0;
    if (UpperCaseExists(password)) {//TODO replace match with reusable methods
        passed++;//1
    }
    if (NumberExists(password)) {
        passed++;//2
    }
    if (SpecialCharacterExists(password)) {
        passed++;//3
    }
    if (password.length > 7) {
        passed++;//4
    }
    if (LowerCaseExists(password)) {
        passed++;//5
    }
    return passed;
}
export function ReturnActionMessage(Message: ActionMessage, t: Function): IMessage {
    console.log("🚀 ReturnActionMessage");
    if (Message.actionType === "Task assigned to you") {
        Message.messageTitle = t('NewTask');
        Message.messageContent = Message.task + t('Task') + " " + t('WasAssignedToYouBy') + " " + Message.admin + ".";
    }
    else if (Message.actionType === "Client claimed Bonus added") {
        Message.messageTitle = t('BonusAdded');
        Message.messageContent = t('ClientID') + ": " + Message.clientID + ", " + Message.clientName + t('BonusAddedTo') + t('Login') + ": " + Message.login + "-" + Message.server + t('Login') + Message.amount + " " + Message.currency + ".";
    }
    else if (Message.actionType === "Subscribe/unSubscribe to Strategy MAM") {
        if (Message.subType === "Subscribe") {
            Message.messageTitle = t('Subscription');
            Message.messageContent = "to be filled";
        }
        else if (Message.subType === "unSubscribe") {
            Message.messageTitle = "Unsubscription";
            Message.messageContent = "to be filled";
        }
    }
    else if (Message.actionType === "Client Auto-linked to IB") {
        Message.messageTitle = t('AutoLinkedToIb');
        Message.messageContent = t('ClientID') + ": " + Message.clientID + " , " + Message.clientName + " , " + t('Login') + ": " + Message.login + " , " + Message.server + " " + t('AutoLinkedToIb') + " " + Message.ibName + " , " + Message.ibCode + ".";
    }
    else if (Message.actionType === "Application Requests") {
        if (Message.subType === "Request Application") {
            Message.messageTitle = t('ApplicationRequests');
            Message.messageContent = t('ClientID') + ": " + Message.clientID + " , " + Message.clientName + " " + t('SubmittedApplicationForm');
        }
        else if (Message.subType === "Decline Application Request") {
            Message.messageTitle = t('DeclineApplicationRequest');
            Message.messageContent = Message.admin + t('DeclinedApplicationFormSubmittedBy') + t('ClientID') + ": " + Message.clientID + ".";
        }
        else if (Message.subType === "Approve Application Request") {
            Message.messageTitle = t('ApproveApplicationRequest');
            Message.messageContent = Message.admin + + t('AprrovedApplicationFormSubmittedBy') + t('ClientID') + ": " + Message.clientID + ".";
        }

    }
    else if (Message.subType === "Application Changes") {
        Message.messageTitle = t('ApplicationChanges');
        Message.messageContent = t('ClientID') + ": " + Message.clientID + " , " + Message.clientName + t('MadeChangesToApplicationForm');
    }
    else if (Message.actionType === "Clients assigned to you") {
        Message.messageTitle = t('NewClient');
        Message.messageContent = Message.clientName + " " + t('WasAssignedToYouBy') + " " + Message.admin + ".";
    }
    else if (Message.actionType === "Ticket assigned to you") {
        Message.messageTitle = t('NewTicket');
        Message.messageContent = Message.ticket + "  " + t('TicketAssignedToYouBy') + " " + Message.admin + ".";
    }
    else if (Message.actionType === "Task reminder") {
        Message.messageTitle = t('Reminder');
        Message.messageContent = Message.ticket + t('Reminder') + ".";
    }
    else if (Message.actionType === "Expired Documents") {
        Message.messageTitle = t('ExpiredDocuments');
        Message.messageContent = Message.listEmails + " " + t('ExpiredDocumentsIn') + " " + Message.date + ".";
    }
    else if (Message.actionType === "Lead assiged to you") {
        Message.messageTitle = t('NewLead');
        Message.messageContent = Message.lead + " " + t('WasAssignedToYouBy') + " " + Message.admin + ".";
    }
    else if (Message.actionType === "Contact assigned to you") {
        Message.messageTitle = t('NewContact');
        Message.messageContent = Message.contact + " " + t('WasAssignedToYouBy') + " " + Message.admin + ".";
    }
    else if (Message.actionType === "Deposits/Withdrawals/Transfers") {
        if (Message.subType === "Request Deposit") {
            Message.messageTitle = t('NewDeposits');
            Message.messageContent = t('ClientID') + ": " + Message.clientID + " , " + Message.clientName + " " + t('RequestedToDeposit') + " " + Message.amount + "-" + Message.currency + " " + t('OnThrePreposition') + t('Login') + ": " + Message.login + " , " + Message.server + ".";
        }
        else if (Message.subType === "Decline Deposit Request") {
            Message.messageTitle = t('DeclineDeposit');
            Message.messageContent = Message.admin + " " + t('DeclinedToDeposit') + " " + Message.amount + "-" + Message.currency + " " + t('OnThrePreposition') + t('Login') + ": " + Message.login + ", " + Message.server + " " + t('SubmittedBy') + " " + t('ClientID') + ": " + Message.clientID + ", " + Message.clientName + ".";
        }
        else if (Message.subType === "Approve Deposit Request") {
            Message.messageTitle = t('ApproveDeposit');
            Message.messageContent = Message.admin + " " + t('ApprovedToDeposit') + " " + Message.amount + "-" + Message.currency + " " + t('OnThrePreposition') + " " + t('Login') + ": " + Message.login + ", " + Message.server + " " + t('SubmittedBy') + " " + t('ClientID') + ": " + Message.clientID + ", " + Message.clientName + ".";
        }
        else if (Message.subType === "Request Withdrawal") {
            Message.messageTitle = t('NewWithdrawal');
            Message.messageContent = t('ClientID') + ": " + Message.clientID + " , " + Message.clientName + " " + t('RequestedToWithdraw') + " " + Message.amount + "-" + Message.currency + " " + t('OnThrePreposition') + t('Login') + ": " + Message.login + " , " + Message.server + ".";
        }
        else if (Message.subType === "Decline Withdrawal Request") {
            Message.messageTitle = t('DeclineWithdrawal');
            Message.messageContent = Message.admin + " " + t('DeclinedToWithdraw') + " " + Message.amount + "-" + Message.currency + " " + t('OnThrePreposition') + t('Login') + ": " + Message.login + ", " + Message.server + " " + t('SubmittedBy') + " " + t('ClientID') + ": " + Message.clientID + ", " + Message.clientName + ".";
        }
        else if (Message.subType === "Approve Withdrawal Request") {
            Message.messageTitle = t('ApproveWithdrawal');
            Message.messageContent = Message.admin + " " + t('ApprovedToWithdraw') + " " + Message.amount + "-" + Message.currency + " " + t('OnThrePreposition') + t('Login') + ": " + Message.login + ", " + Message.server + " " + t('SubmittedBy') + " " + t('ClientID') + ": " + Message.clientID + ", " + Message.clientName + ".";
        }
        else if (Message.subType === "Request Transfer") {
            Message.messageTitle = t('NewTransfer');
            Message.messageContent = t('ClientID') + ": " + Message.clientID + " , " + Message.clientName + " " + t('RequestedToTransfer') + " " + Message.amount + "-" + Message.currency + " " + t('From') + t('Login') + ": " + Message.fromLogin + " , " + Message.fromServer + " " + t('ToPreposition') + t('Login') + ": " + Message.toLogin + " , " + Message.toServer + ".";
        }
        else if (Message.subType === "Decline Transfer Request") {
            Message.messageTitle = t('DeclineTransfer');
            Message.messageContent = Message.admin + " " + t('DeclinedToTransfer') + " " + Message.amount + "-" + Message.currency + " " + t('From') + t('Login') + ": " + Message.fromLogin + " , " + Message.fromServer + " " + t('ToPreposition') + t('Login') + ": " + Message.toLogin + " , " + Message.toServer + " " + t('SubmittedBy') + " " + t('ClientID') + ": " + Message.clientID + ", " + Message.clientName + ".";
        }
        else if (Message.subType === "Approve Transfer Request") {
            Message.messageTitle = t('ApproveTransfer');
            Message.messageContent = Message.admin + " " + t('ApprovedToTransfer') + " " + Message.amount + "-" + Message.currency + " " + t('From') + t('Login') + ": " + Message.fromLogin + " , " + Message.fromServer + " " + t('ToPreposition') + t('Login') + ": " + Message.toLogin + " , " + Message.toServer + " " + t('SubmittedBy') + " " + t('ClientID') + ": " + Message.clientID + ", " + Message.clientName + ".";
        }
    }
    else if (Message.actionType === "Trading Accounts added or Closed") {
        if (Message.subType === "Request Live Account") {
            Message.messageTitle = t('NewAccountRequest');
            Message.messageContent = t('ClientID') + ": " + Message.clientID + ", " + Message.clientName + " " + t('RequestedToOpenANewLiveTradingAccount');
        }
        else if (Message.subType === "Approve New Account") {
            Message.messageTitle = t('ApproveNewAccount');
            Message.messageContent = Message.admin + " " + t('ApprovedOpeningANewLiveTradingAccountTo') + " " + t('ClientID') + ": " + Message.clientID + ", " + Message.clientName + ".";
        }
        else if (Message.subType === "Decline New Account") {
            Message.messageTitle = t('DeclinedNewAccount');
            Message.messageContent = Message.admin + " " + t('DeclinedOpeningANewLiveTradingAccountTo') + " " + t('ClientID') + ": " + Message.clientID + ", " + Message.clientName + ".";
        }
        else if (Message.subType === "Add Live Account") {
            Message.messageTitle = t('NewLiveAccountAdded');
            Message.messageContent = t('ClientID') + ": " + Message.clientID + ", " + Message.clientName + " " + t('NewLiveTradingAccountAdded') + " " + t('Login') + ": " + Message.login + ", " + Message.server + ".";
        }
        else if (Message.subType === "Add Demo Account") {
            Message.messageTitle = t('NewDemoAccountAdded');
            Message.messageContent = (Message.clientID === "" ? Message.clientName : (t('ClientID') + ": " + Message.clientID + ", " + Message.clientName)) + " " + t('NewDemoTradingAccountAdded') + " " + t('Login') + ": " + Message.login + ", " + Message.server + ".";
        }
        else if (Message.subType === "Request Close Account") {
            Message.messageTitle = t('CloseAccountRequest');
            Message.messageContent = t('ClientID') + ": " + Message.clientID + ", " + Message.clientName + " " + t('RequestedToCloseLiveTradingAccount') + " " + t('Login') + ": " + Message.login + ", " + Message.server + ".";
        }
        else if (Message.subType === "Decline close Account") {
            Message.messageTitle = t('DeclinedCloseAccount');
            Message.messageContent = Message.admin + " " + t('DeclinedToCloseLiveTradingAccountTo') + " " + t('ClientID') + ": " + Message.clientID + ", " + Message.clientName + ".";
        }
        else if (Message.subType === "Approve Close Account") {
            Message.messageTitle = t('ApprovedCloseAccount');
            Message.messageContent = Message.admin + " " + t('ApproveToCloseLiveTradingAccountTo') + " " + t('ClientID') + ": " + Message.clientID + ", " + Message.clientName + ".";
        }
    }
    else if (Message.actionType === "Client Bonus to balance reached") {
        Message.messageTitle = t('ClaimBonus');
        Message.messageContent = t('ClientID') + ": " + Message.clientID + ", " + Message.clientName + t('ReachedCashBonusonLogin') + " " + Message.login + Message.server + " Lots reached: " + Message.lots + ".";
    }
    else if (Message.actionType === "Trading Accounts Request Changes") {
        if (Message.subType === "Request Change Leverage") {
            Message.messageTitle = t('RequestChangeLeverage');
            Message.messageContent = t('ClientID') + ": " + Message.clientID + ", " + Message.clientName + " " + t('RequestedToChangeLevergeOnLiveTradingAccount') + " " + t('OnLowerCase') + " " + t('Login') + ": " + Message.login + ", " + Message.server + ".";
        }
        else if (Message.subType === "Decline Leverage Request") {
            Message.messageTitle = t('DeclineLeverageRequest');
            Message.messageContent = Message.admin + " " + t('DeclinedToChangeLeverageOn') + " " + t('Login') + ": " + Message.login + ", " + Message.server + " " + t('SubmittedBy') + " " + t('ClientID') + ": " + Message.clientID + ", " + Message.clientName + ".";
        }
        else if (Message.subType === "Approve Leverage Request") {
            Message.messageTitle = t('ApproveLeverageRequest');
            Message.messageContent = Message.admin + " " + t('ApprovedToChangeLeverageOn') + " " + t('Login') + ": " + Message.login + ", " + Message.server + " " + t('SubmittedBy') + " " + t('ClientID') + ": " + Message.clientID + ", " + Message.clientName + ".";
        }
        else if (Message.subType === "Request Change Account Info") {
            Message.messageTitle = t('RequestChangeAccountInfo');
            Message.messageContent = t('ClientID') + ": " + Message.clientID + ", " + Message.clientName + " " + t('RequestedToChangeAccountInfoOnLiveTradingAccount') + " " + t('Login') + ": " + Message.login + ", " + Message.server + ".";
        }
        else if (Message.subType === "Decline Account Info Request") {
            Message.messageTitle = t('Decline') + t('AccountInfo') + t('Request');
            Message.messageContent = Message.admin + " " + t('DeclinedToChangeAccountInfoSubmittedBy') + " " + t('ClientID') + ": " + Message.clientID + ", " + Message.clientName + ".";
        }
        else if (Message.subType === "Approve Account Info Request") {
            Message.messageTitle = t('ApproveAccountInfoRequest');
            Message.messageContent = Message.admin + " " + t('ApprovedToChangeAccountInfoSubmittedBy') + " " + t('ClientID') + ": " + Message.clientID + ", " + Message.clientName + ".";
        }
    }
    else if (Message.actionType === "Ticket Request Changes") {
        Message.messageTitle = t('TicketUpdate');
        Message.messageContent = Message.ticket + t('TicketUpdate') + ".";
    }
    else if (Message.actionType === "Ticket assigned to you") {
        Message.messageTitle = t('NewTicket');
        Message.messageContent = Message.ticket + " " + t('TicketAssignedToYouBy') + " " + Message.admin + ".";
    }
    else if (Message.actionType === "Subscribe/unSubscribe to Strategy Signal") {
        if (Message.subType === "Request Autocopy") {
            Message.messageTitle = t('RequestAutocopy');
            Message.messageContent = t('ClientID') + ": " + Message.clientID + ", " + Message.clientName + ", " + t('From') + " " + t('Login') + ": " + Message.fromLogin + ", " + Message.fromServer + " " + t('RequestedToCopyTradingAccount') + " " + t('ToPreposition') + " " + t('Login') + ": " + Message.toLogin + ", " + Message.toServer + ".";
        }
        else if (Message.subType === "Decline Autocopy Request") {
            Message.messageTitle = t('DeclineAutocopyRequest');
            Message.messageContent = Message.admin + " " + t('DeclinedToCopyTradingAccount') + " " + t('From') + " " + t('Login') + ": " + Message.fromLogin + ", " + Message.fromServer + " " + t('SubmittedBy') + " " + t('ClientID') + ": " + Message.clientID + ", " + Message.clientName + ".";
        }
        else if (Message.subType === "Approve Autocopy Request") {
            Message.messageTitle = t('ApproveAutocopyRequest');
            Message.messageContent = Message.admin + " " + t('ApprovedToCopyTradingAccount') + " " + t('From') + " " + t('Login') + ": " + Message.fromLogin + ", " + Message.fromServer + " " + t('SubmittedBy') + " " + t('ClientID') + ": " + Message.clientID + ", " + Message.clientName + ".";
        }
    }
    else if (Message.actionType === "Client Auto-linked to MAM") {
        Message.messageTitle = t('ClientAutoLinkedToMam');
        Message.messageContent = t('ClientID') + ": " + Message.clientID + ", " + Message.clientName + " ," + t('Login') + ": " + Message.login + ", " + Message.server + "  " + t('AutoLinkedUnderStrategyName') + " " + Message.name + ", " + t('MAMName') + ": " + Message.mamName + t('MAMLogin') + ": " + Message.mamLogin + ", " + Message.server + ".";
    }
    else if (Message.actionType === "Add symbol profile") {
        Message.messageTitle = t('AddSymbolProfile');
        Message.messageContent = `${t('SymbolProfile')} ${Message?.profileName || ""} of ${t('ID')} ${Message?.profileID || ""} ${t('WasSuccessfullyAdded')}`;
    }
    else if (Message.actionType === "Update symbol profile") {
        Message.messageTitle = t('UpdateSymbolProfile');
        Message.messageContent = `${t('SymbolProfile')} ${Message?.profileName || ""} of ${t('ID')} ${Message?.profileID || ""} ${t('WasSuccessfullyUpdated')}`;
    }
    else if (Message.actionType === "Delete symbol profile") {
        Message.messageTitle = t('DeleteSymbolProfile');
        Message.messageContent = `${t('SymbolProfile')} ${Message?.profileName || ""} of ${t('ID')} ${Message?.profileID || ""} ${t('WasSuccessfullyDeleted')}`;
    }
    else if (Message.actionType === "Add account exposure profile") {
        Message.messageTitle = t('AddAccountExposureProfile');
        Message.messageContent = `${t('AccountProfile')} ${Message?.profileName || ""} of ${t('ID')} ${Message?.profileID || ""} ${t('WasSuccessfullyAdded')}`;
    }
    else if (Message.actionType === "Update account exposure profile") {
        Message.messageTitle = t('UpdateAccountExposureProfile');
        Message.messageContent = `${t('AccountProfile')} ${Message?.profileName || ""} of ${t('ID')} ${Message?.profileID || ""} ${t('WasSuccessfullyUpdated')}`;
    }
    else if (Message.actionType === "Delete account exposure profile") {
        Message.messageTitle = t('DeleteAccountExposureProfile');
        Message.messageContent = `${t('AccountProfile')} ${Message?.profileName || ""} of ${t('ID')} ${Message?.profileID || ""} ${t('WasSuccessfullyDeleted')}`;
    }
    return {
        title: Message.messageTitle,
        content: Message.messageContent
    }

}
export function ReturnTranslation(key: string, t: Function) {
    return t(key);
}
export function CheckIfAUIDIsEnabled(AUID: string, AUIDs: string[] | any) {
    if (!AUID || !AUIDs || AUIDs.length === 0) return false;
    try {
        return AUIDs.includes(AUID) ? true : false;
    } catch (e) {
        console.error(e);
        return false;
    }
}
export function checkifPdf(_type: any) {
    try {
        if (!_type) return false;
        _type = _type !== null && _type !== "" ? _type.split(".").pop() : "-1";
        if (_type === "pdf")
            return true;
    }
    catch (e) {
        console.error("checkifPdf", _type, e)
    }
    return false;
}
export function isPDF_Binary(binary: string) {//as here it is sent as binary
    try {
        if (binary?.split(";")[0]?.toLowerCase()?.endsWith("pdf"))
            return true;
    }
    catch (e) {
        console.error("isPDF_Binary", binary, e)
    }
    return false;
}
export function GetDashboardItemByName(name: string, list: DashboardItems[]) {
    try {
        if (!list)
            return new DashboardItems();
        let _item: any[] = [...list].filter((item: DashboardItems) => (item && item.ItemName) && (item.ItemName.toLowerCase() === name.toLowerCase()));
        return _item && _item.length > 0 ? _item[0] : new DashboardItems();
    } catch (e) {
        console.error(e);
        return new DashboardItems();
    }
}
export function ReturnDistinctList(list: any[], PropertyName: string) {
    if (!list || list.length === 0) return [];
    return list.filter((thing: any, i: number, arr: any) => {
        return arr.indexOf(arr.find((t: any) => t[PropertyName] === thing[PropertyName])) === i;
    });
}
export function ReturnActivity(Type: string, t: Function) {
    if (!Type) return ' - ';//if want to add transation add language or return key of lang
    switch (Type) {
        case "Trader": {
            return t('CreatedTraderAccount');
        }
        case "Client": {
            return t('CreatedClient');
        }
        case "Contact": {
            return t('CreatedContactAccount');
        }
        case "Lead": {
            return t('CreatedLead');
        }
        case "Task": {
            return t('CreatedNewTask');
        }
        case "Note": {
            return t('CreatedNewNote');
        }
        case "ConvertContact": {
            return t('ConvertedContactToClient');
        }
        case "ConvertLead": {
            return t('ConvertedLeadToContact');
        }
        default: {
            return ' - '
        }
    }
}
export function escapeRegExp(text: string) {
    return text.replace(/[-[\]{}()*+?.,!%^$|\s~]/g, '\\$&');
}
export function ValidateMultiSelectwithOther(selected: any[], input: string) {
    if (!selected || selected.length === 0) return false
    let _list: any = selected ? selected.map((item: any) => item.value).toString() : "";
    if (_list.includes("Other"))//case sensitive
        return ValidateInput(input);
    return true;
}

export function ReturnAllocationsLabel(AruleName: string, signal?: boolean) {
    if (!AruleName) return ' - ';
    switch (AruleName) {
        case "ELS": {
            return "ELS (Equity Lot Share)";
        }
        case "ECS": {
            return "ECS (Equity Cash Share)";
        }
        case "EV": {
            return "EV  (Equal Volume)";
        }
        case "Percentage": {
            return "Percentage";
        }
        case "Multiplier": {
            return "Multiplier";
        }
        case "BLS": {
            return "BLS (Balance Lot Share)";
        }
        case "Fixed Lot": {
            return "Fixed Lot";
        }
        case "% of Equity": {
            if (signal) {
                return "Percentage of Equity";
            }
            return "% of Equity (Percentage of Equity)";
        }
        default: {
            return AruleName;
        }
    }
}
export function ReturnValuesForMultiSelect(list: any[]) {
    if (!list || list.length === 0) return [];
    return list.map((item: any) => item.value);
}
export function ReturnValuesForMultiSelectAsString(list: any[]) {
    if (!list || list.length === 0) return [];
    return list.map((item: any) => String(item.value));
}
export function ReturnValuesForMultiSelectAsExcluded(list: any[]) {
    if (!list || list.length === 0) return [];
    return list.map((item: any) => `!${item.value}`);
}
export function ReturnLabelsForMultiSelectAsExcluded(list: any[]) {
    if (!list || list.length === 0) return [];
    return list.map((item: any) => `!${item.label}`);
}
export function ReturnExcludedIncludedOptions(includelist: BasicSelectOption[], excludedList: BasicSelectOption[]) {
    try {
        if (!ValidateMultiSelect(includelist) && !ValidateMultiSelect(excludedList)) return null;
        let _included = ValidateMultiSelect(includelist) ? ReturnValuesForMultiSelect(includelist).toString() : "";
        let _excluded = ValidateMultiSelect(excludedList) ? ReturnValuesForMultiSelectAsExcluded(excludedList).toString() : "";
        return `${_included}${_included ? ',' : ''}${_excluded}`;

    } catch (e) {
        console.error(e);
        return null;
    }
}
export function ReturnExcludedIncludedOptionsLabels(includelist: BasicSelectOption[], excludedList: BasicSelectOption[]) {
    try {
        if (!ValidateMultiSelect(includelist) && !ValidateMultiSelect(excludedList)) return null;
        let _included = ValidateMultiSelect(includelist) ? ReturnLabelsForMultiSelect(includelist).toString() : "";
        let _excluded = ValidateMultiSelect(excludedList) ? ReturnLabelsForMultiSelectAsExcluded(excludedList).toString() : "";
        return `${_included}${_included ? ',' : ''}${_excluded}`;

    } catch (e) {
        console.error(e);
        return null;
    }
}
export function ValidateOneOfOptionsExists(visibleIfkey: string, list: any, ActionParams: any) {
    try {
        let _dict: any = { ...ActionParams };
        if (!_dict[visibleIfkey]?.Data?.isVisible) return false;//edit check if main element is visible 
        if (!CheckIfVisibleIF(_dict[visibleIfkey]?.Data, ActionParams)) return false;//check parent is visible /recurive
        let _selectedOption: string = String(_dict[visibleIfkey].value.value);
        //console.log({ _selectedOption, list })
        return list.includes(_selectedOption);
    } catch (e) {
        console.error(e);
        return false;
    }
}
export function ValidateOneOfElementsIsVisible(visibleIfKeys: string[], ActionParams: any) {
    try {
        let _dict: any = { ...ActionParams };
        //console.log({ visibleIfKeys });
        for (let i: number = 0; i < visibleIfKeys.length; i++) {
            if (_dict[visibleIfKeys[i]]?.Data?.isVisible && CheckIfVisibleIF(_dict[visibleIfKeys[i]]?.Data, ActionParams)) {
                return true;
            }
        }
        return false;
    } catch (e) {
        console.error(e);
        return false;
    }
}
export function ValidateAndReturnDataAsType(value: any, type: string) {
    try {
        switch (type) {
            case 'input':
            case 'radiogroup':
                {
                    if (typeof value === "string")
                        return value;
                    return DefaultValueDict[type];
                }
            case 'date':
                {
                    if (value instanceof Date || typeof value === "string")
                        return value;
                    return DefaultValueDict[type];
                }
            case 'dropdown':
            case 'dynamicDropdown': {
                if (value.value)
                    return value;
                return DefaultValueDict[type];
            }
            case 'multiDropdown': {
                if (value)
                    return value;
                return DefaultValueDict[type];
            }
            case 'boolean': {
                //console.log("boolean", { value });
                return value ? true : false;
            }
            //case 'file': {
            //    if (value typeof FileType)
            //    return value;
            //    return DefaultValueDict[type];
            //}
            default: {
                return value;
            }
        }
    } catch (e) {
        console.error(e);
        return;
    }
}
export function ValidateOneOfOptionsExistsInMultiSelect(visibleIfkey: string, list: any, ActionParams: any) {
    try {
        let _dict: any = { ...ActionParams };//.Data as need Value
        if (!_dict[visibleIfkey]?.Data?.isVisible) return false;//edit check if main element is visible 
        if (!CheckIfVisibleIF(_dict[visibleIfkey]?.Data, ActionParams)) return false;
        let _selectedOptions: string[] = ReturnValuesForMultiSelectAsString(_dict[visibleIfkey].value);
        //console.log({ _selectedOptions, list })
        for (let i = 0; i < _selectedOptions.length; i++) {
            if (list.includes(_selectedOptions[i]))
                return true;
        }
        return false;
    } catch (e) {
        console.error(e);
        return false;
    }
}
export function ValidateRadioGroupSelectedAsStatus(visibleIfkey: string, Status: any, ActionParams: any) {
    //console.log("📓 📓 📓 📓 📓📓 📓 ", visibleIfkey);
    try {
        let _dict: any = { ...ActionParams };
        //console.log("📘 ", _dict[visibleIfkey]);
        let _selectedOption: string = String(_dict[visibleIfkey].value);
        //console.log("📓 📘 ", String(_dict[visibleIfkey].value));
        if (!_dict[visibleIfkey] || !_dict[visibleIfkey].Data || !_dict[visibleIfkey].Data.isVisible) return false;
        if (!CheckIfVisibleIF(_dict[visibleIfkey]?.Data, ActionParams)) return false;
        //console.log("!_dict[visibleIfkey] || !_dict[visibleIfkey].Data || !_dict[visibleIfkey].Data.isVisible");
        try {
            if (_dict[visibleIfkey].type === "radiogroup") {
                //console.log("_dict[visibleIfkey].type === radiogroup");
                let _choices: any = _dict[visibleIfkey].Data && _dict[visibleIfkey].Data.choices ? _dict[visibleIfkey].Data.choices : [];
                _choices = _choices.filter((item: any) => item.isVisible).map((item: any) => item.value);
                //if (visibleIfkey && visibleIfkey === "IDType" /*&& element.key === "CountryOfIssuancePassport"*/) {
                //    console.log("📘 _choices", _choices);
                //    console.log("📘 Status", Status);
                //    console.log("📓 _selectedOption", _selectedOption);
                //}
                return (Status.includes(_selectedOption) && _choices.includes(_selectedOption));
            }
            //if (visibleIfkey && visibleIfkey === "IDType" /*&& element.key === "CountryOfIssuancePassport"*/) {
            //    console.log("📘 bot radio  waht Status", Status);
            //    console.log("📓 _selectedOption", _selectedOption);
            //}
        } catch (e) {
            console.error(e);
        }
        //if (visibleIfkey && visibleIfkey === "IDType" /*&& element.key === "CountryOfIssuancePassport"*/) {
        //    console.log("📘at z End Status", Status);
        //    console.log("📓 _selectedOption", _selectedOption);
        //}
        return Status.includes(_selectedOption);
    } catch (e) {
        console.error(e);
        return false;
    }
}
export function ValidateRadioGroupisVisibleAsStatus(visibleIfkey: string, Status: any, ActionParams: any) {
    try {
        let _dict: any = { ...ActionParams };
        if (!_dict[visibleIfkey] || !_dict[visibleIfkey].Data || !_dict[visibleIfkey].Data.isVisible) return false;
        try {
            if (_dict[visibleIfkey].type === "radiogroup") {
                let _choices: any = _dict[visibleIfkey].Data && _dict[visibleIfkey].Data.choices ? _dict[visibleIfkey].Data.choices : [];
                _choices = _choices.filter((item: any) => item.isVisible).map((item: any) => item.value);
                return _choices.length > 0;
            }
        } catch (e) {
            console.error(e);
        }
        return false;
    } catch (e) {
        console.error(e);
        return false;
    }
}
export function ValidateBooleanSelectedAsStatus(visibleIfkey: string, Status: boolean, ActionParams: any) {
    try {
        let _dict: any = { ...ActionParams };
        //console.log('**enter _dict[visibleIfkey]', visibleIfkey, _dict[visibleIfkey])
        if (!_dict[visibleIfkey] || !_dict[visibleIfkey].Data || !_dict[visibleIfkey]?.Data?.isVisible) return false;
        if (!CheckIfVisibleIF(_dict[visibleIfkey]?.Data, ActionParams)) return false;
        //console.log(_dict[visibleIfkey].value, Status)
        //console.log('**passed _dict[visibleIfkey]', visibleIfkey, _dict[visibleIfkey])
        return _dict[visibleIfkey].value === Status;
    } catch (e) {
        //console.error(visibleIfkey, e);
        return false;
    }
}
/**
 * 
 * @param element
 * @param ActionParams
 * @param choices
 * @param settings allow settings to appear even it element is not visible
 */
export function CheckIfVisibleIF(element: any, ActionParams: any, choices?: any, settings?: any) {
    try {
        //not required , not optional , isVisible and option selected
        if (!settings && (!element || !element.isVisible)) return false;
        if (!element.visibleIfKey) return true;//have no condition  
        switch (element.visibleIfType) {//visibleIfType ,not the type
            case "dropdown": {
                //console.log("dropdown");
                return ValidateOneOfOptionsExists(element.visibleIfKey, element.visibleIfList, ActionParams);
            }
            case "label": {//just for dsiplay
                return ValidateOneOfElementsIsVisible(element.visibleIfKey, ActionParams);
            }
            case "multiDropdown": {
                //console.log("multiDropdown");
                return ValidateOneOfOptionsExistsInMultiSelect(element.visibleIfKey, element.visibleIfList, ActionParams);
            }
            case "boolean": {
                //console.log("boolean");

                return ValidateBooleanSelectedAsStatus(element.visibleIfKey, element.visibleIfStatus, ActionParams);
            }
            case "radiogroup": {
                //console.log("radiogroup");
                return ValidateRadioGroupSelectedAsStatus(element.visibleIfKey, element.visibleIfStatus, ActionParams);
            }
            //case "radiogroupCardElement": {//TODO check ifnot needed anymore 
            //    console.log("radiogroupCardElement");
            //    return ValidateRadioGroupisVisibleAsStatus(element.visibleIfKey, element.visibleIfStatus, ActionParams);
            //}
            default: {
                return false;
            }
        }

    } catch (e) {
        console.error(e);
        return false;
    }
}
export function CheckIfSubElement(element: any) {
    try {
        if (element.visibleIfKey) return true;
    } catch (e) {
        console.error(e);
        return false;
    }
}
export function ValidateByType(value: any, type: string) {//new fields must be added
    try {
        switch (type) {
            case "dropdown": {
                return ValidateSelect(value);
            }
            case "dynamicDropdown": {
                //must check All must have values dynaimic by default and check on manage 
                return ValidateSelect(value);
            }
            case "multiDropdown": {
                return ValidateMultiSelect(value);
            }
            case "date": {
                return validateDateAndInternval(value.date, value.Interval);
            }
            case "input":
            case "file":
                {
                    return ValidateInput(value);
                }
            case "radiogroup":
                {
                    return ValidateInput(value);
                }
            case "boolean"://TODO add all cases need no validation
            case "html":
                //case "radiogroupCardElement":
                {
                    return true;
                }
            case "inputDescription":
                {
                    return true;
                }
            case "checkbox": {
                return validateCheckBoxIsTrue(value);
            }
            default: {
                return false;
            }
        }

    } catch (e) {
        console.error(e);
        return false;
    }
}
export function ReturnLabelsForMultiSelect(list: any[]) {
    if (!list || list.length === 0) return [];
    return list.map((item: any) => item.label);
}
export function ValidateSelectAndReturnValue(selected: any) {
    if (!ValidateSelect(selected)) return " _ ";
    return selected.value;
}
export function ValidateSelectAndReturnValueID(selected: any) {
    if (!ValidateSelect(selected)) return null;
    return selected.value;
}
export const dictStatus: any = {
    '0': "Pending",
    '1': "Completed",
    '-1': "Rejected",
    '2': "Not Completed",
};
export function ReturnPlaceHolderStatement(title: string, multiSelectValue: any[], Options: any[]) {
    try {
        if (Options?.length === 0) return `No ${title} options`;
        if (multiSelectValue?.length === Options?.length) return `All ${title} selected`;
        else if (multiSelectValue && multiSelectValue.length > 0)
            return `${multiSelectValue.length} ${title} selected`;
        else
            return title;
    } catch (e) {
        return title;
    }
}
export function CheckList(list: any) {
    return list && list.length > 0;
}
export function CastTreePathForAction(list: any) {
    let _newlist: any = [...list];
    _newlist = _newlist.map((item: TreePathDefaultProfile) => {
        return {
            Depth: +(item.Depth),
            ClientID: item.ClientID,
        }
    })
    return _newlist;
}
export function CheckIflastNode(PathIndex: string, Path: any, value: string) {
    return Path.length !== 0 && String(PathIndex) !== String(Path.length - 1) ? value : "";
}
export function ReturnIBTreePaths(SelectOpt: any) {
    let _options: any = [];
    //console.log({ SelectOpt })
    for (let Opt of SelectOpt) {
        //Path PathID
        if (Opt.Path) {
            let _IBCodes = '', _clientIDs = '';
            let _maxDepth = Opt.Path.length ? Opt.Path.length : 0;
            //console.log('Opt.Path', Opt.Path)
            for (let PathIndex in Opt.Path) {
                //console.log('SelectOpt:', Opt.Path[PathIndex])
                if (Opt.Path[PathIndex]) {
                    _clientIDs += `${Opt.Path[PathIndex].ClientID}${CheckIflastNode(PathIndex, Opt.Path, '-')}`;
                    _IBCodes += `${Opt.Path[PathIndex].IBCode ? Opt.Path[PathIndex].IBCode : "None"}${CheckIflastNode(PathIndex, Opt.Path, '>')}`;
                }
                //console.log({ _IBCodes, _maxDepth, _clientIDs });
            }
            _options.push({
                value: _clientIDs,
                label: _IBCodes,
                maxDepth: _maxDepth,
                Data: Opt.Path
            });
            //console.log({ _options });
        }
    }
    if (_options.length > 0)
        return _options;
    return [];
};
export function ReturnIBTreePathKey(Path: any) {
    if (Path) {
        let _clientIDs = '';
        for (let PathIndex in Path) {
            if (Path[PathIndex]) {
                _clientIDs += `${Path[PathIndex].ClientID}${CheckIflastNode(PathIndex, Path, '-')}`;
            }
        }
        //console.log({ _clientIDs });
        return _clientIDs;
    }
}
export const OptionNone = { value: -1, label: "None" };
export function TranslateSelectOptionsAndReturnKey(list: Array<BasicSelectOption | any>, t: Function) {//add the render to fixed 
    try {
        let _list = [...list];
        for (let i = 0; i < _list.length; i++) {

            //_list[i].translationKey = String(list[i].label);//order before chnage
            //_list[i].label = t(_list[i].label);//it changes value as clone deep

            _list[i] = {
                ...list[i],
                translationKey: String(list[i].label),
                label: t(_list[i].label)
            }
        }
        //console.log({ _list })
        return _list;
    }
    catch (e) {
        console.error(e)
        return [];//or orginal
    }
}
export function TranslateSelectOption(value: BasicSelectOption | any, t: Function) {//add the render to fixed 
    try {
        //console.log("TranslateSelectOption", { value });

        let _value = {
            ...value,
            label: t(value.translationKey ? value.translationKey : value.label) //as old didnt have 
        };
        return _value;
    }
    catch (e) {
        console.error('TranslateSelectOption', e)
        return {};
    }
}
export function TranslateSelectOptions(list: Array<BasicSelectOption | any>, t: Function) {//add the didmount to fixed 
    try {
        let _list = [...list];
        for (let i = 0; i < _list.length; i++) {

            _list[i] = {
                ...list[i],
                label: t(_list[i].translationKey ? _list[i].translationKey : _list[i].label)
            }
        }
        return _list;
    }
    catch (e) {
        console.error(e)
        return [];//or orginal
    }
}
export function RevertTranslateSelectOptions(list: Array<BasicSelectOption | any>) {//lib now support option for transaltion
    try {
        if (!list || list.length === 0) return [];
        let _list = [...list];
        for (let i = 0; i < _list.length; i++) {

            _list[i] = {
                ...list[i],///TODO urgent check this 
                label: _list[i].translationKey ? _list[i].translationKey : _list[i].label
            }
        }
        return _list;
    }
    catch (e) {
        console.error(e)
        return [];//or orginal
    }
}
//#region payments
export const bankwirePayment = `${store?.getState()?.CompanyData?.CDNURL}imgs/bankwirePayment.png`;
export const cashPayment = `${store?.getState()?.CompanyData?.CDNURL}imgs/cashPayment.png`;
export const cashuPayment = `${store?.getState()?.CompanyData?.CDNURL}imgs/cashuPayment.png`;
export const NetellerPayment = `${store?.getState()?.CompanyData?.CDNURL}imgs/netellerPayment.png`;
export const rpncupPayment = `${store?.getState()?.CompanyData?.CDNURL}imgs/rpnPay.png`;
export const rpnp2pPayment = `${store?.getState()?.CompanyData?.CDNURL}imgs/rpnPay.png`;
export const skrillEURPayment = `${store?.getState()?.CompanyData?.CDNURL}imgs/skrillPayment.png`;
export const skrillGBPPayment = `${store?.getState()?.CompanyData?.CDNURL}imgs/skrillPayment.png`;
export const skrillJPYPayment = `${store?.getState()?.CompanyData?.CDNURL}imgs/skrillPayment.png`;
export const skrillPayment = `${store?.getState()?.CompanyData?.CDNURL}imgs/skrillPayment.png`;
export const sticpayPayment = `${store?.getState()?.CompanyData?.CDNURL}imgs/sticpayPayment.png`;
export const tapUSDPayment = `${store?.getState()?.CompanyData?.CDNURL}imgs/tappay.png`;
export const tapKWDPayment = `${store?.getState()?.CompanyData?.CDNURL}imgs/tappay.png`;
export const tapKnetPayment = `${store?.getState()?.CompanyData?.CDNURL}imgs/tappay.png`;;


export const DepositClientUniquePayments: string[] = ['BankWire', 'Bankwire2', 'SKRILL', 'SKRILL-USD', 'SKRILL-GBP', 'SKRILL-EUR', 'SKRILL-JPY', 'SticPay', 'TapPay-CreditCard-USD', 'TapPay-CreditCard-USD-WG', 'TapPay-CreditCard-KWD', 'TapPay-CreditCard-KWD-WG', 'NETELLER', 'TapPay-KNET', 'TapPay-KNET-WG', 'CashU', 'RPN-P2P', 'RPN-CUP', 'Cash', 'ECOMMPay', 'PaySafeNeteller', 'FasaPay', 'BridgerPay', 'Alogateway', 'Powercash', 'VaultsPay', 'CryptoPay', 'GBPrimePay', 'Paystack', 'IBFSkrill', 'IBFBitcoin', 'Espiral', 'Hayvn', 'B2BinPay', 'Zain Cash', 'AsiaHawala', 'Switch', 'Local Transfer', 'Easypay', 'TrustPayments', 'Zaha', 'VirtualPay', 'Dusupay', 'Surepay', 'Stripe', 'Fast2pays', 'NowPayments', "Match2Pay", "Help2Pay", "Match2payCreditCard", "CapitalWallet", "Ozow", "GateToPay", "NACE","MyFatoorah"];//BigPay not unique
export const ClientWithdrawalUniquePayments: string[] = ['Cash', 'BankWire', 'Bankwire2', 'EcommPay', 'RPN-P2P', 'Skrill', 'Sticpay', 'Neteller', 'Alogateway', 'UnionPay', 'FXBit', 'ThunderPay', 'GlobePay', 'GBPrimePay', 'IBFSkrill', 'IBFBitcoin', 'PerfectMoney', 'CryptoPay', 'B2BinPay', 'EasyWire', 'Zain Cash', 'AsiaHawala', 'Switch', 'Local Transfer', 'Easypay', 'Zaha', 'Surepay', 'Fast2pays', 'NinePay', 'Match2Pay', "BigPay", "Ozow", "NowPayments", "GateToPay", "CapitalWallet", "BridgerPay"];
//#region IB images 
export const IBFSkrill = require("../../src/Assets/imgs/Skrill.png") as string;
export const IBFBitcoin = require("../../src/Assets/imgs/BitCoin.png") as string;
export const BitCoinWallet = '1NihS7yo31Ly14C63G2eNynvbCb4EwnXTX';
//#endregion
//#region Alogateway withdrawal
export const ChineseBankNames: any = [
    {
        "BankCode": "BJRCB",
        "BankNameEN": "Beijing Rural Commerical Bank",
        "BankNameCN": "北京农商银行"
    },
    {
        "BankCode": "CBHB",
        "BankNameEN": "China Bohai Bank",
        "BankNameCN": "渤海银行"
    },
    {
        "BankCode": "SJBANK",
        "BankNameEN": "Shengjing Bank",
        "BankNameCN": "盛京银行"
    },
    {
        "BankCode": "FUDIAN",
        "BankNameEN": "Fudian Bank",
        "BankNameCN": "富滇银行"
    },
    {
        "BankCode": "CQC",
        "BankNameEN": "Bank Of Chongqing",
        "BankNameCN": "重庆银行"
    },
    {
        "BankCode": "NCB",
        "BankNameEN": "Nanyang Commerical bank (CHINA) Limited",
        "BankNameCN": "南洋商业银行"
    },
    {
        "BankCode": "BOD",
        "BankNameEN": "Bank Of Dongguan",
        "BankNameCN": "东莞银行"
    },
    {
        "BankCode": "TZB",
        "BankNameEN": "Bank Of Taizhou",
        "BankNameCN": "台州银行"
    },
    {
        "BankCode": "HFB",
        "BankNameEN": "Evergrowing Bank",
        "BankNameCN": "恒丰银行"
    },
    {
        "BankCode": "HSBC",
        "BankNameEN": "HSBC China",
        "BankNameCN": "汇丰银行"
    },
    {
        "BankCode": "ZJTLCB",
        "BankNameEN": "ZhejiangTailong Commercial Bank",
        "BankNameCN": "浙江泰隆商业银行"
    },
    {
        "BankCode": "URCB",
        "BankNameEN": "Hangzhou United Bank",
        "BankNameCN": "杭州联合银行"
    },
    {
        "BankCode": "YKRS",
        "BankNameEN": "Yingkou Rongsheng Rural Commercial Bank",
        "BankNameCN": "营口融生农村商业银行"
    },
    {
        "BankCode": "LZB",
        "BankNameEN": "Bank of Lanzhou",
        "BankNameCN": "兰州银行"
    },
    {
        "BankCode": "UCCB",
        "BankNameEN": "Urumqi City Commercial Bank",
        "BankNameCN": "乌鲁木齐市商业银行"
    },
    {
        "BankCode": "CITIBANK",
        "BankNameEN": "Citibank China",
        "BankNameCN": "花旗银行"
    },
    {
        "BankCode": "BSB",
        "BankNameEN": "Baoshang Bank",
        "BankNameCN": "包商银行"
    },
    {
        "BankCode": "HZB",
        "BankNameEN": "Bank of Hangzhou",
        "BankNameCN": "杭州银行"
    },
    {
        "BankCode": "MIZUHO",
        "BankNameEN": "Mizuho Financial Group",
        "BankNameCN": "瑞穗实业银行(中国)有限公司"
    },
    {
        "BankCode": "GZCB",
        "BankNameEN": "Bank of Guangzhou",
        "BankNameCN": "广州银行"
    },
    {
        "BankCode": "SZRUCOMM",
        "BankNameEN": "Shenzhen Rural Commercial Bank",
        "BankNameCN": "深圳农村商业银行"
    },
    {
        "BankCode": "SRCB",
        "BankNameEN": "Shanghai Rural Commercial Bank",
        "BankNameCN": "上海农商银行"
    },
    {
        "BankCode": "HSB",
        "BankNameEN": "Huishang Bank",
        "BankNameCN": "徽商银行"
    },
    {
        "BankCode": "SHB",
        "BankNameEN": "Bank of Shanghai",
        "BankNameCN": "上海银行"
    },
    {
        "BankCode": "CZCB",
        "BankNameEN": "Zhejiang Chouzhou Commercial Bank",
        "BankNameCN": "浙江稠州商业银行"
    },
    {
        "BankCode": "CQRCB",
        "BankNameEN": "Chongqing Rural Commercial Bank",
        "BankNameCN": "重庆农村商业银行"
    },
    {
        "BankCode": "BOFS",
        "BankNameEN": "Bank of Fushun",
        "BankNameCN": "抚顺银行"
    },
    {
        "BankCode": "ICBC",
        "BankNameEN": "Industry and Commercial Bank of China",
        "BankNameCN": "中国工商银行"
    },
    {
        "BankCode": "ABC",
        "BankNameEN": "Agricultural Bank of China",
        "BankNameCN": "中国农业银行"
    },
    {
        "BankCode": "BOC",
        "BankNameEN": "Bank of China",
        "BankNameCN": "中国银行"
    },
    {
        "BankCode": "CCB",
        "BankNameEN": "China ConstructionBank",
        "BankNameCN": "中国建设银行"
    },
    {
        "BankCode": "BCOM",
        "BankNameEN": "Bank of Communications",
        "BankNameCN": "交通银行"
    },
    {
        "BankCode": "CMB",
        "BankNameEN": "China Merchants Bank",
        "BankNameCN": "招商银行"
    },
    {
        "BankCode": "CMBC",
        "BankNameEN": "China Mingsheng Banking",
        "BankNameCN": "中国民生银行"
    },
    {
        "BankCode": "CIB",
        "BankNameEN": "Industrial Bank",
        "BankNameCN": "兴业银行"
    },
    {
        "BankCode": "China Debit Card Processing – API Specification"
    },
    {
        "BankCode": "13"
    },
    {
        "BankCode": "SPDB",
        "BankNameEN": "Shanghai Pudong Development Bank",
        "BankNameCN": "浦发银行"
    },
    {
        "BankCode": "PSBC",
        "BankNameEN": "Postal Savings Bank of China",
        "BankNameCN": "中国邮政储蓄银行"
    },
    {
        "BankCode": "BEA",
        "BankNameEN": "The Bank of East Asia(China) Limited",
        "BankNameCN": "东亚银行"
    },
    {
        "BankCode": "HXB",
        "BankNameEN": "Huaxia Bank",
        "BankNameCN": "华夏银行"
    },
    {
        "BankCode": "CITIC",
        "BankNameEN": "China CITIC Bank",
        "BankNameCN": "中信银行"
    },
    {
        "BankCode": "CEB",
        "BankNameEN": "China Everbright Bank",
        "BankNameCN": "中国光大银行"
    },
    {
        "BankCode": "CGB",
        "BankNameEN": "China Guangfa Bank",
        "BankNameCN": "广发银行"
    },
    {
        "BankCode": "PINGAN",
        "BankNameEN": "Ping An Bank",
        "BankNameCN": "平安银行"
    },
    {
        "BankCode": "NBCB",
        "BankNameEN": "Bank of Ningbo",
        "BankNameCN": "宁波银行"
    },
    {
        "BankCode": "BOB",
        "BankNameEN": "Bank of Beijing",
        "BankNameCN": "北京银行"
    },
    {
        "BankCode": "CDRCB",
        "BankNameEN": "Chengdu Rural Commercial Bank",
        "BankNameCN": "成都农商银行"
    },
    {
        "BankCode": "BHB",
        "BankNameEN": "Bank of Hebei",
        "BankNameCN": "河北银行"
    },
    {
        "BankCode": "BYK",
        "BankNameEN": "Bank of Yingkou",
        "BankNameCN": "营口银行"
    },
    {
        "BankCode": "BOT",
        "BankNameEN": "Bank of Tianjin",
        "BankNameCN": "天津银行"
    },
    {
        "BankCode": "BNC",
        "BankNameEN": "Bank of Nanchang",
        "BankNameCN": "南昌银行"
    },
    {
        "BankCode": "FJHX",
        "BankNameEN": "Fujian Haixia Bank",
        "BankNameCN": "福建海峡银行"
    },
    {
        "BankCode": "BOJZ",
        "BankNameEN": "Bank of Jinzhou",
        "BankNameCN": "锦州银行"
    },
    {
        "BankCode": "ZSBANK",
        "BankNameEN": "China Zheshang Bank",
        "BankNameCN": "浙商银行"
    },
    {
        "BankCode": "WZCB",
        "BankNameEN": "Bank of Wenzhou",
        "BankNameCN": "温州银行"
    },
    {
        "BankCode": "WHCCB",
        "BankNameEN": "Weihai City CommercialBank",
        "BankNameCN": "威海市商业银行"
    },
    {
        "BankCode": "SXCCB",
        "BankNameEN": "Bank of Shaoxing",
        "BankNameCN": "绍兴银行"
    },
    {
        "BankCode": "CABANK",
        "BankNameEN": "Chang'an Bank",
        "BankNameCN": "长安银行"
    },
    {
        "BankCode": "ZJMTCOMM",
        "BankNameEN": "Zhejiang Mintai Commercial Bank",
        "BankNameCN": "浙江民泰商业银行"
    },
    {
        "BankCode": "QDCCB",
        "BankNameEN": "Bank of Qingdao",
        "BankNameCN": "青岛银行"
    },
    {
        "BankCode": "BOXI",
        "BankNameEN": "Bank of Xi'an",
        "BankNameCN": "西安银行"
    },
    {
        "BankCode": "ADBC",
        "BankNameEN": "Agricultural Development Bank of China",
        "BankNameCN": "中国农业发展银行"
    },
    {
        "BankCode": "KEB",
        "BankNameEN": "KEB Bank(China)",
        "BankNameCN": "外换银行（中国）有限公司"
    },
    {
        "BankCode": "BODL",
        "BankNameEN": "Bank of Dalian",
        "BankNameCN": "大连银行"
    },
    {
        "BankCode": "NJCB",
        "BankNameEN": "Bank of Nanjing",
        "BankNameCN": "南京银行"
    }

]
export const CNProvince: any = {
    "110000": "北京市",
    "120000": "天津市",
    "130000": "河北省",
    "140000": "山西省",
    "150000": "内蒙古自治区",
    "210000": "辽宁省",
    "220000": "吉林省",
    "230000": "黑龙江省",
    "310000": "上海市",
    "320000": "江苏省",
    "330000": "浙江省",
    "340000": "安徽省",
    "350000": "福建省",
    "360000": "江西省",
    "370000": "山东省",
    "410000": "河南省",
    "420000": "湖北省",
    "430000": "湖南省",
    "440000": "广东省",
    "450000": "广西壮族自治区",
    "460000": "海南省",
    "500000": "重庆市",
    "510000": "四川省",
    "520000": "贵州省",
    "530000": "云南省",
    "540000": "西藏自治区",
    "610000": "陕西省",
    "620000": "甘肃省",
    "630000": "青海省",
    "640000": "宁夏回族自治区",
    "650000": "新疆维吾尔自治区"
}
export const CNCity: any = {
    "110100": "北京市",
    "120100": "天津市",
    "130100": "石家庄市",
    "130200": "唐山市",
    "130300": "秦皇岛市",
    "130400": "邯郸市",
    "130500": "邢台市",
    "130600": "保定市",
    "130700": "张家口市",
    "130800": "承德市",
    "130900": "沧州市",
    "131000": "廊坊市",
    "131100": "衡水市",
    "140100": "太原市",
    "140200": "大同市",
    "140300": "阳泉市",
    "140400": "长治市",
    "140500": "晋城市",
    "140600": "朔州市",
    "140700": "晋中市",
    "140800": "运城市",
    "140900": "忻州市",
    "141000": "临汾市",
    "141100": "吕梁市",
    "150100": "呼和浩特市",
    "150200": "包头市",
    "150300": "乌海市",
    "150400": "赤峰市",
    "150500": "通辽市",
    "150600": "鄂尔多斯市",
    "150700": "呼伦贝尔市",
    "150800": "巴彦淖尔市",
    "150900": "乌兰察布市",
    "152200": "兴安盟",
    "152500": "锡林郭勒盟",
    "152900": "阿拉善盟",
    "210100": "沈阳市",
    "210200": "大连市",
    "210300": "鞍山市",
    "210400": "抚顺市",
    "210500": "本溪市",
    "210600": "丹东市",
    "210700": "锦州市",
    "210800": "营口市",
    "210900": "阜新市",
    "211000": "辽阳市",
    "211100": "盘锦市",
    "211200": "铁岭市",
    "211300": "朝阳市",
    "211400": "葫芦岛市",
    "220100": "长春市",
    "220200": "吉林市",
    "220300": "四平市",
    "220400": "辽源市",
    "220500": "通化市",
    "220600": "白山市",
    "220700": "松原市",
    "220800": "白城市",
    "222400": "延边朝鲜族自治州",
    "230100": "哈尔滨市",
    "230200": "齐齐哈尔市",
    "230300": "鸡西市",
    "230400": "鹤岗市",
    "230500": "双鸭山市",
    "230600": "大庆市",
    "230700": "伊春市",
    "230800": "佳木斯市",
    "230900": "七台河市",
    "231000": "牡丹江市",
    "231100": "黑河市",
    "231200": "绥化市",
    "232700": "大兴安岭地区",
    "310100": "上海市",
    "320100": "南京市",
    "320200": "无锡市",
    "320300": "徐州市",
    "320400": "常州市",
    "320500": "苏州市",
    "320600": "南通市",
    "320700": "连云港市",
    "320800": "淮安市",
    "320900": "盐城市",
    "321000": "扬州市",
    "321100": "镇江市",
    "321200": "泰州市",
    "321300": "宿迁市",
    "330100": "杭州市",
    "330200": "宁波市",
    "330300": "温州市",
    "330400": "嘉兴市",
    "330500": "湖州市",
    "330600": "绍兴市",
    "330700": "金华市",
    "330800": "衢州市",
    "330900": "舟山市",
    "331000": "台州市",
    "331100": "丽水市",
    "340100": "合肥市",
    "340200": "芜湖市",
    "340300": "蚌埠市",
    "340400": "淮南市",
    "340500": "马鞍山市",
    "340600": "淮北市",
    "340700": "铜陵市",
    "340800": "安庆市",
    "341000": "黄山市",
    "341100": "滁州市",
    "341200": "阜阳市",
    "341300": "宿州市",
    "341500": "六安市",
    "341600": "亳州市",
    "341700": "池州市",
    "341800": "宣城市",
    "350100": "福州市",
    "350200": "厦门市",
    "350300": "莆田市",
    "350400": "三明市",
    "350500": "泉州市",
    "350600": "漳州市",
    "350700": "南平市",
    "350800": "龙岩市",
    "350900": "宁德市",
    "360100": "南昌市",
    "360200": "景德镇市",
    "360300": "萍乡市",
    "360400": "九江市",
    "360500": "新余市",
    "360600": "鹰潭市",
    "360700": "赣州市",
    "360800": "吉安市",
    "360900": "宜春市",
    "361000": "抚州市",
    "361100": "上饶市",
    "370100": "济南市",
    "370200": "青岛市",
    "370300": "淄博市",
    "370400": "枣庄市",
    "370500": "东营市",
    "370600": "烟台市",
    "370700": "潍坊市",
    "370800": "济宁市",
    "370900": "泰安市",
    "371000": "威海市",
    "371100": "日照市",
    "371200": "莱芜市",
    "371300": "临沂市",
    "371400": "德州市",
    "371500": "聊城市",
    "371600": "滨州市",
    "371700": "菏泽市",
    "410100": "郑州市",
    "410200": "开封市",
    "410300": "洛阳市",
    "410400": "平顶山市",
    "410500": "安阳市",
    "410600": "鹤壁市",
    "410700": "新乡市",
    "410800": "焦作市",
    "410900": "濮阳市",
    "411000": "许昌市",
    "411100": "漯河市",
    "411200": "三门峡市",
    "411300": "南阳市",
    "411400": "商丘市",
    "411500": "信阳市",
    "411600": "周口市",
    "411700": "驻马店市",
    "420100": "武汉市",
    "420200": "黄石市",
    "420300": "十堰市",
    "420500": "宜昌市",
    "420600": "襄阳市",
    "420700": "鄂州市",
    "420800": "荆门市",
    "420900": "孝感市",
    "421000": "荆州市",
    "421100": "黄冈市",
    "421200": "咸宁市",
    "421300": "随州市",
    "422800": "恩施土家族苗族自治州",
    "429006": "天门市",
    "430100": "长沙市",
    "430200": "株洲市",
    "430300": "湘潭市",
    "430400": "衡阳市",
    "430500": "邵阳市",
    "430600": "岳阳市",
    "430700": "常德市",
    "430800": "张家界市",
    "430900": "益阳市",
    "431000": "郴州市",
    "431100": "永州市",
    "431200": "怀化市",
    "431300": "娄底市",
    "433100": "湘西土家族苗族自治州",
    "440100": "广州市",
    "440200": "韶关市",
    "440300": "深圳市",
    "440400": "珠海市",
    "440500": "汕头市",
    "440600": "佛山市",
    "440700": "江门市",
    "440800": "湛江市",
    "440900": "茂名市",
    "441200": "肇庆市",
    "441300": "惠州市",
    "441400": "梅州市",
    "441500": "汕尾市",
    "441600": "河源市",
    "441700": "阳江市",
    "441800": "清远市",
    "441900": "东莞市",
    "442000": "中山市",
    "445100": "潮州市",
    "445200": "揭阳市",
    "445300": "云浮市",
    "450100": "南宁市",
    "450200": "柳州市",
    "450300": "桂林市",
    "450400": "梧州市",
    "450500": "北海市",
    "450600": "防城港市",
    "450700": "钦州市",
    "450800": "贵港市",
    "450900": "玉林市",
    "451000": "百色市",
    "451100": "贺州市",
    "451200": "河池市",
    "451300": "来宾市",
    "451400": "崇左市",
    "460100": "海口市",
    "460200": "三亚市",
    "460300": "三沙市",
    "469000": "省直辖县级行政区划",
    "500100": "重庆市",
    "510100": "成都市",
    "510300": "自贡市",
    "510400": "攀枝花市",
    "510500": "泸州市",
    "510600": "德阳市",
    "510700": "绵阳市",
    "510800": "广元市",
    "510900": "遂宁市",
    "511000": "内江市",
    "511100": "乐山市",
    "511300": "南充市",
    "511400": "眉山市",
    "511500": "宜宾市",
    "511600": "广安市",
    "511700": "达州市",
    "511800": "雅安市",
    "511900": "巴中市",
    "512000": "资阳市",
    "513200": "阿坝藏族羌族自治州",
    "513300": "甘孜藏族自治州",
    "513400": "凉山彝族自治州",
    "520100": "贵阳市",
    "520200": "六盘水市",
    "520300": "遵义市",
    "520400": "安顺市",
    "520500": "毕节市",
    "520600": "铜仁市",
    "522300": "黔西南布依族苗族自治州",
    "522600": "黔东南苗族侗族自治州",
    "522700": "黔南布依族苗族自治州",
    "530100": "昆明市",
    "530300": "曲靖市",
    "530400": "玉溪市",
    "530500": "保山市",
    "530600": "昭通市",
    "530700": "丽江市",
    "530800": "普洱市",
    "530900": "临沧市",
    "532300": "楚雄彝族自治州",
    "532500": "红河哈尼族彝族自治州",
    "532600": "文山壮族苗族自治州",
    "532800": "西双版纳傣族自治州",
    "532900": "大理白族自治州",
    "533100": "德宏傣族景颇族自治州",
    "533300": "怒江傈僳族自治州",
    "533400": "迪庆藏族自治州",
    "540100": "拉萨市",
    "542100": "昌都地区",
    "542200": "山南地区",
    "542300": "日喀则地区",
    "542400": "那曲地区",
    "542500": "阿里地区",
    "542600": "林芝地区",
    "610100": "西安市",
    "610200": "铜川市",
    "610300": "宝鸡市",
    "610400": "咸阳市",
    "610500": "渭南市",
    "610600": "延安市",
    "610700": "汉中市",
    "610800": "榆林市",
    "610900": "安康市",
    "611000": "商洛市",
    "620100": "兰州市",
    "620200": "嘉峪关市",
    "620300": "金昌市",
    "620400": "白银市",
    "620500": "天水市",
    "620600": "武威市",
    "620700": "张掖市",
    "620800": "平凉市",
    "620900": "酒泉市",
    "621000": "庆阳市",
    "621100": "定西市",
    "621200": "陇南市",
    "622900": "临夏回族自治州",
    "623000": "甘南藏族自治州",
    "630100": "西宁市",
    "632100": "海东地区",
    "632200": "海北藏族自治州",
    "632300": "黄南藏族自治州",
    "632500": "海南藏族自治州",
    "632600": "果洛藏族自治州",
    "632700": "玉树藏族自治州",
    "632800": "海西蒙古族藏族自治州",
    "640100": "银川市",
    "640200": "石嘴山市",
    "640300": "吴忠市",
    "640400": "固原市",
    "640500": "中卫市",
    "650100": "乌鲁木齐市",
    "650200": "克拉玛依市",
    "652100": "吐鲁番地区",
    "652200": "哈密地区",
    "652300": "昌吉回族自治州",
    "652700": "博尔塔拉蒙古自治州",
    "652800": "巴音郭楞蒙古自治州",
    "652900": "阿克苏地区",
    "653000": "克孜勒苏柯尔克孜自治州",
    "653100": "喀什地区",
    "653200": "和田地区",
    "654000": "伊犁哈萨克自治州",
    "654200": "塔城地区",
    "654300": "阿勒泰地区"
}
//#endregion
//#region GBPrime withdrawal
export const GBPRIME_BANK_CODES = [
    { value: "001", label: "Bank of Thailand" },
    { value: "002", label: "Bangkok Bank Public Company Limited" },
    { value: "004", label: "Kasikornbank Public CompanyLimited" },
    { value: "005", label: "The Royal Bank of Scotland N.V." },
    { value: "006", label: "Krung Thai Bank Public Company Limited" },
    { value: "008", label: "JP Morgan Chase Bank" },
    { value: "011", label: "TTB Bank" },
    { value: "014", label: "Siam Commercial Bank Public Company Limited" },
    { value: "017", label: "Citibank N.A." },
    { value: "018", label: "Sumitomo Mitsui Banking Corporation" },
    { value: "020", label: "Standard Chartered Bank (Thai) Public Company Limited" },
    { value: "022", label: "CIMB Thai Bank Public Company Limited" },
    { value: "024", label: "United Overseas Bank (Thai) PCL" },
    { value: "025", label: "Bank of Ayudhya Public Company Limited" },
    { value: "026", label: "Mega International Commercial Bank PCL" },
    { value: "027", label: "Bank of America National Association" },
    { value: "030", label: "Government Saving Bank" },
    { value: "031", label: "Hong Kong & Shanghai Corporation Limited" },
    { value: "032", label: "Deutsche Bank Aktiengesellschaft" },
    { value: "033", label: "Government Housing Bank" },
    { value: "034", label: "Bank for Agriculture and Agricultural Cooperatives" },
    { value: "039", label: "Mizuho Corporate Bank Limited" },
    { value: "045", label: "BNP Paribas Bank" },
    { value: "052", label: "Bank of China ( Thai ) Public Company Limited" },
    { value: "066", label: "Islamic Bank of Thailand" },
    { value: "067", label: "Tisco Bank Public Company Limited" },
    { value: "069", label: "Kiatnakin Bank Public Company Limited" },
    { value: "070", label: "ICBC Thai Commercial Bank" },
    { value: "071", label: "The Thai Credit Retail Bank Public Company Limited" },
    { value: "073", label: "Land and Houses Bank Public Company Limited" },
    { value: "079", label: "ANZ Bank (Thai) Public Company Limited" },
]
//#endregion
export function CheckTextIsSimplifiedChinese(inputText: string) {
    let reqChinese = /^[\u4E00-\u9FCC]+$/;
    return reqChinese.test(inputText);
}
export function toDataUrl(url: any, callback: any) {
    var xhr: any = new XMLHttpRequest();
    xhr.onload = function () {
        var reader = new FileReader();
        reader.onloadend = function () {
            callback(reader.result);
        }
        reader.readAsDataURL(xhr.response);
    };
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.send();
}
export function ReturnPaymentIndexsGroupedBy3(list: any) {
    let _paymentIndexs: any = [];
    if (!list || list.length === 0) return _paymentIndexs;
    if (list.length <= 3) {
        _paymentIndexs.push({ start: 0, end: list.length });
        return _paymentIndexs;
    }
    let _count = 0;
    for (let i = 0; i < list.length; i++) {
        if (++_count === 3 || (i === list.length - 1)) {
            _paymentIndexs.push({ start: _paymentIndexs.length * 3, end: i });//_paymentIndexs.length is each round 3
            _count = 0;
        }
    }
    return _paymentIndexs;
}
export const IBGroupingOptionsDict: any = {
    "ib": 'IB',
    "account": 'Account',
    "symbol": 'Symbol',
    "all": 'ViewAll'
}
export function getBase64Image(url: any) {
    // Initialize the XMLHttpRequest and wait until file is loaded
    var xhr = new XMLHttpRequest();
    xhr.onload = function () {
        // Create a Uint8Array from ArrayBuffer
        var codes: any = new Uint8Array(xhr.response);

        // Get binary string from UTF-16 code units
        var bin = String.fromCharCode.apply(null, codes);

        // Convert binary to Base64
        var b64 = btoa(bin);
        //console.log(b64); //-> "R0lGODdhAQABAPAAAP8AAAAAACwAAAAAAQABAAACAkQBADs="

    };

    // Send HTTP request and fetch file as ArrayBuffer
    xhr.open('GET', url);
    xhr.responseType = 'arraybuffer';
    xhr.send();
}
export function ReturnSecuirtyTypeTitle(SecuirtyType: string) {
    if (!SecuirtyType) return ' - ';
    switch (SecuirtyType) {
        case "FX": {
            return "FX - Leverage";
        } case "Futures": {
            return "Futures - Multipler";
        } case "CFD": {
            return "CFD - Percentage";
        } case "INX": {
            return "INX - Percentage";
        } case "CFDLEV": {
            return "CFDLEV - Percentage";
        }
        default: {
            return SecuirtyType;
        }
    }
}

export const SecuirtyTypes = {
    "FX - Leverage": "FX",
    "Futures - Multipler": "Futures",
    "CFD - Percentage": "CFD",
    "INX - Percentage": "INX",
    "CFDLEV - Percentage": "CFDLEV"
}
export function parseFloatIfValid(number: any) {
    if (!number) return 0;
    return number;
}
export function getProperty(obj: any, prop: any) {
    try {
        let _prop = prop.replace('?', '');//as in links ? 
        let key;
        for (key in obj) {
            if (key.replace('?', '').toLowerCase() === _prop.toLowerCase()) {
                return obj[key];
            }
        }
        return "";
    } catch (e) {
        return "";
    }
}
export function ReturnLinkName(Type: any, PoolID: any) {
    try {
        switch (Type) {
            case "Demo Account": {
                return `DemoAccountWrapper${PoolID ? '-' + PoolID : ''}`;
            } case "Real Account": {
                return `RealAccountWrapper${PoolID ? '-' + PoolID : ''}`;
            }
            default: {
                return ''
            }
        }
    } catch (e) {
        return "";
    }
}
export function ReturnIframeName(Type: any) {
    try {
        switch (Type) {
            case "Demo Account": {
                return `DemoAccountIFrame`;
            } case "Real Account": {
                return `RealAccountIframe`;
            }
            default: {
                return ''
            }
        }
    } catch (e) {
        return "";
    }
}
export function CheckGUIDisValid(GUIDString: any) {
    if (!GUIDString || GUIDString === "null") return false;
    if (GUIDString !== "00000000-0000-0000-0000-000000000000") return false;
    return true;
}
export function ReturnValuesForMultiSelectWithTranslation(list: any[], t: Function) {
    if (!list || list.length === 0) return [];
    return list.map((item: any) => t(item.value));
}
export function ReturnTitlesWithTranslation(list: any[], t: Function) {
    if (!list || list.length === 0) return [];
    return list.map((item: any) => t(item));
}
export function ReturnValidStock(jsonString: string) {
    if (!jsonString) return [];
    let _result: any = [];
    try { _result = JSON.parse(jsonString) }
    catch (error) {
        console.error('ReturnValidStock', error);
        return [];
    }
    return _result;
}
export function ReturnValidJson(jsonString: string, Default: any) {
    if (!jsonString) return Default;
    let _result: any = Default;
    try { _result = JSON.parse(jsonString) }
    catch (error) {
        console.error('ReturnValidJson', error);
        return Default;
    }
    return _result;
}
export const BIGCHARTS: string[] = ["BestWorstTrade", "NetAssetValue", "ROIChart"];
export const SMALLCHARTS: string[] = ["GainTest", "NetAssetNumber", "AverageLoss", "AverageGain", "ROI", "MeanReturn"];
export const BIGCHARTSDict: any = {
    "BestWorstTrade": true,
    "NetAssetValue": true,
    "ROIChart": true
};
export const SMALLCHARTSDict: any = {
    "GainTest": true,
    "NetAssetNumber": true,
    "AverageLoss": true,
    "AverageGain": true,
    "ROI": true,
    "MeanReturn": true,
    //"AccountSummaryStatus1": true,
    //"AccountSummaryStatus2": true,
};
//#region Logs 
export const ActionNames: any = [
    { value: "Full", label: "Full", ModuleName: "Full", PermissionType: "Full" },
    { value: "Register New Client", label: "Register New Client", ModuleName: "Clients", PermissionType: "Client" },
    { value: "Manage Client", label: "Manage Client", ModuleName: "Clients", PermissionType: "Client" },
    { value: "Upload Clients CSV", label: "Upload Clients CSV", ModuleName: "Clients", PermissionType: "Client" },
    { value: "Register Demo Account", label: "Register Demo Account", ModuleName: "Clients", PermissionType: "Client" },
    { value: "Manage Wallet", label: "Manage Wallet", ModuleName: "Clients", PermissionType: "Client" },
    { value: "Manage Contact", label: "Manage Contact", ModuleName: "Clients", PermissionType: "Client" },
    { value: "Assign Contact to Client", label: "Assign Contact to Client", ModuleName: "Clients", PermissionType: "Client" },
    { value: "Convert Contact to Client", label: "Convert Contact to Client", ModuleName: "Clients", PermissionType: "Client" },
    { value: "Manage Lead", label: "Manage Lead", ModuleName: "Clients", PermissionType: "Client" },
    { value: "Convert Lead to Contact", label: "Convert Lead to Contact", ModuleName: "Clients", PermissionType: "Client" },
    { value: "Manage Task", label: "Manage Task", ModuleName: "Clients", PermissionType: "Client" },
    { value: "Manage Note", label: "Manage Note", ModuleName: "Clients", PermissionType: "Client" },
    { value: "Manage Wallet Currencies", label: "Manage Wallet Currencies", ModuleName: "Clients", PermissionType: "Client" },
    { value: "Manage IBCode Range", label: "Manage IBCode Range", ModuleName: "Clients", PermissionType: "Client" },
    { value: "Manage App Form", label: "Manage App Form", ModuleName: "Clients", PermissionType: "Client" },
    { value: "Manage User", label: "Manage User", ModuleName: "Clients", PermissionType: "Client" },
    { value: "Manage Pool", label: "Manage Pool", ModuleName: "Clients", PermissionType: "Client" },
    { value: "Manage ClientID Range", label: "Manage ClientID Range", ModuleName: "Clients", PermissionType: "Client" },
    { value: "Manage Countries", label: "Manage Countries", ModuleName: "Clients", PermissionType: "Client" },
    { value: "Request Reset Password", label: "Request Reset Password", ModuleName: "Users/Configuration", PermissionType: "Full" },
    { value: "Confirm Reset Password", label: "Confirm Reset Password", ModuleName: "Users/Configuration", PermissionType: "Full" },
    { value: "Validate User Email", label: "Validate User Email", ModuleName: "Users/Configuration", PermissionType: "Full" },
    { value: "Manage User", label: "Manage User", ModuleName: "Users/Configuration", PermissionType: "Full" },
    { value: "Update User Password", label: "Update User Password", ModuleName: "Users/Configuration", PermissionType: "Full" },
    { value: "Block/Unblock User", label: "Block/Unblock User", ModuleName: "Users/Configuration", PermissionType: "Full" },
    { value: "Validate User", label: "Validate User", ModuleName: "Users/Configuration", PermissionType: "Full" },
    { value: "Sync Groups", label: "Sync Groups", ModuleName: "Users/Configuration", PermissionType: "Full" },
    { value: "Manage Company Setting", label: "Manage Company Setting", ModuleName: "Users/Configuration", PermissionType: "Full" },
    { value: "Manage Payment", label: "Manage Payment", ModuleName: "Users/Configuration", PermissionType: "Full" },
    { value: "Manage Affiliate Settings", label: "Manage Affiliate Settings", ModuleName: "Users/Configuration", PermissionType: "Full" },
    { value: "Manage Team", label: "Manage Team", ModuleName: "Users/Configuration", PermissionType: "Full" },
    { value: "Manage Role", label: "Manage Role", ModuleName: "Users/Configuration", PermissionType: "Full" },
    { value: "Manage MAM Profile", label: "Manage MAM Profile", ModuleName: "MAMPortal", PermissionType: "MAM" },
    { value: "Bulk Manage MAM Profile", label: "Bulk Manage MAM Profile", ModuleName: "MAMPortal", PermissionType: "MAM" },
    { value: "Force Performance Fee", label: "Force Performance Fee", ModuleName: "MAMPortal", PermissionType: "MAM" },
    { value: "Sync Groups", label: "Sync Groups", ModuleName: "MAMPortal", PermissionType: "MAM" },
    { value: "Registration Fee", label: "Registration Fee", ModuleName: "MAMPortal", PermissionType: "MAM" },
    { value: "Management Fee", label: "Management Fee", ModuleName: "MAMPortal", PermissionType: "MAM" },
    { value: "Manage Signal Profile", label: "Manage Signal Profile", ModuleName: "Signal", PermissionType: "MAM" },
    { value: "Link IB Accounts", label: "Link IB Accounts", ModuleName: "IBPortal", PermissionType: "IB" },
    { value: "IBDefaultProfile", label: "IB Default Profile", ModuleName: "IBPortal", PermissionType: "IB" },
    { value: "Manage IB Allocation", label: "Manage IB Allocation", ModuleName: "IBPortal", PermissionType: "IB" },
    { value: "Validate App Form", label: "Validate App Form", ModuleName: "OnBoarding", PermissionType: "OnBoarding" },
    { value: "Manage DM Profile", label: "Manage Dynamic Profile", ModuleName: "DMPortal", PermissionType: "DynamicMargin" },
    { value: "Delete DM Profiles", label: "Delete Symbol Profiles", ModuleName: "DMPortal", PermissionType: "DynamicMargin" },
    { value: "Delete DM Exposure", label: "Delete Account Exposure Profiles", ModuleName: "DMPortal", PermissionType: "DynamicMargin" },
    { value: "Upload Bonus CSV", label: "Upload Bonus CSV", ModuleName: "BonusService", PermissionType: "Bonus" },
    { value: "Deposit Bonus", label: "Deposit Bonus", ModuleName: "BonusService", PermissionType: "Bonus" },
    { value: "Withdrawal", label: "Withdrawal", ModuleName: "BonusService", PermissionType: "Bonus" },
    { value: "Add Bonus Credit", label: "Add Bonus Credit", ModuleName: "BonusService", PermissionType: "Bonus" },
    { value: "StopOut", label: "StopOut", ModuleName: "BonusService", PermissionType: "Bonus" },
    { value: "App/Dec App Form Request", label: "App/Dec App Form Request", ModuleName: "BackOffice", PermissionType: "BackOffice" },
    { value: "Manage Compliance Answers", label: "Manage Compliance Answers", ModuleName: "BackOffice", PermissionType: "BackOffice" },
    { value: "Add Demo Account", label: "Add Demo Account", ModuleName: "Trader", PermissionType: "Trader" },
    { value: "Manage Trading Account", label: "Manage Trading Account", ModuleName: "Trader", PermissionType: "Trader" },
    { value: "Manage Trader Request", label: "Manage Trader Request", ModuleName: "Trader", PermissionType: "Trader" },
    { value: "Link Account to Client", label: "Link Account to Client", ModuleName: "Trader", PermissionType: "Trader" },
    { value: "Manage Registration Group", label: "Manage Registration Group", ModuleName: "Trader", PermissionType: "Trader" },
    { value: "Manage Currencies", label: "Manage Currencies", ModuleName: "Trader", PermissionType: "Trader" },
    { value: "Manage Account Type", label: "Manage Account Type", ModuleName: "Trader", PermissionType: "Trader" },
    { value: "Manage Login Range", label: "Manage Login Range", ModuleName: "Trader", PermissionType: "Trader" },
    { value: "Manage Leverage", label: "Manage Leverage", ModuleName: "Trader", PermissionType: "Trader" },
    { value: "Allocate Trading Account", label: "Allocate Trading Account (Bonus)", ModuleName: "BonusPortal", PermissionType: "Bonus" },
    { value: "Allocate Cash Account", label: "Allocate Cash Account", ModuleName: "BonusPortal", PermissionType: "Bonus" },
    { value: "Allocate Client", label: "Allocate Client (Bonus)", ModuleName: "BonusPortal", PermissionType: "Bonus" },
    { value: "Unallocate Client", label: "Unallocate Client", ModuleName: "BonusPortal", PermissionType: "Bonus" },
    { value: "Upload CSV Bonus", label: "Upload CSV Bonus", ModuleName: "BonusPortal", PermissionType: "Bonus" },
    { value: "Claim Bonus", label: "Claim Bonus", ModuleName: "BonusPortal", PermissionType: "Bonus" },
    { value: "Delete Promotion", label: "Delete Promotion", ModuleName: "BonusPortal", PermissionType: "Bonus" },
    { value: "Add Cash Bonus", label: "Add Cash Bonus", ModuleName: "BonusPortal", PermissionType: "Bonus" },
    { value: "Add New Promotion", label: "Add New Promotion", ModuleName: "BonusPortal", PermissionType: "Bonus" },
    { value: "Update Promotion", label: "Update Promotion", ModuleName: "BonusPortal", PermissionType: "Bonus" },
    { value: "Update Cash Bonus", label: "Update Cash Bonus", ModuleName: "BonusPortal", PermissionType: "Bonus" },
    { value: "Add RPConfig", label: "Add RPConfig", ModuleName: "BonusPortal", PermissionType: "Bonus" },
    { value: "Update Bonus Settings", label: "Update Bonus Settings", ModuleName: "BonusPortal", PermissionType: "Bonus" },
    { value: "Generate Bonus Token", label: "Generate Bonus Token", ModuleName: "BonusPortal", PermissionType: "Bonus" },
    { value: "Add Priority Group", label: "Add Priority Group", ModuleName: "BonusPortal", PermissionType: "Bonus" },
    { value: "Update Priority Group", label: "Update Priority Group", ModuleName: "BonusPortal", PermissionType: "Bonus" },
    { value: "Delete Priority Group", label: "Delete Priority Group", ModuleName: "BonusPortal", PermissionType: "Bonus" },
    { value: "Generate Client Promo Code", label: "Generate Client Promo Code", ModuleName: "BonusPortal", PermissionType: "Bonus" },
    { value: "Add Bonus Credit", label: "Add Bonus Credit", ModuleName: "BonusPortal", PermissionType: "Bonus" },
]
export const ModuleNames: any = [
    { value: "Full", label: "Full", PermissionType: "Full" },
    { value: "Clients", label: "Clients", PermissionType: "Client" },
    { value: "OnBoarding", label: "On Boarding", PermissionType: "OnBoarding" },
    { value: "Trader", label: "Trader", PermissionType: "Trader" },
    { value: "IBPortal", label: "Partners", PermissionType: "IB" },
    { value: "MAMPortal", label: "MAM", PermissionType: "MAM" },
    { value: "Signal", label: "Signal", PermissionType: "MAM" },
    { value: "DMPortal", label: "Dyanmic Margin", PermissionType: "DynamicMargin" },
    { value: "BackOffice", label: "Back Office", PermissionType: "BackOffice" },
    { value: "BonusPortal", label: "Bonus", PermissionType: "Bonus" },
    { value: "BonusService", label: "Bonus Service", PermissionType: "Bonus" },
    { value: "Users/Configuration", label: "Users/Configuration", PermissionType: "Full" }]
//#endregion

//#region KYC Json //for testing as some fields nullable//TODO check if add class 
export interface IKYCJson {
    tabs: TabsEntity[];
}
export interface TabsEntity {
    key: string;
    isVisible: boolean;
    title: string;
    picture: string;
    description: string;
    hasScore: boolean;
    TabPermissionTitle: string;
    PermissionTitle: string;
    cards: CardsEntity[];
    IsDocument: boolean;
    IsFillDocumentRequired: boolean;
    ClientCards: (string)[];
}
export interface CardsEntity {
    key: string;
    isVisible: boolean;
    title: string;
    description: string;
    elements: (ElementsEntity)[];
    noSubmit: boolean;
    isAdminElement: boolean;
}
export interface ElementsEntity {
    type: string;
    md: number;
    key: string;
    title: string;
    isRequired: boolean;
    hasSub: boolean;
    hasScore: boolean;
    isVisible: boolean;
    isSearchable: boolean;
    choices: (ChoicesEntity)[];
    min: number;
    visibleIfType: string;
    visibleIfKey: (string)[] | string | string | (string)[];
    visibleIfStatus: boolean | (string)[];
    visibleIfList: (string)[];
    html: string;
    list: (ListEntity | string)[];
    description: string;
    ClientDocuments: boolean;
    Card: string;
    placeholder: string;
    imgsrc: string;
    acceptedTypes: string;
    maxSize: number;
    isOptional: boolean;
} //every element have chocie and vice versa///  3 levels
export interface ChoicesEntity {
    value: string | number | boolean;
    label: string;
    Score: number;
    key: string | number;
    type: string;
    hasSub: boolean;
    status: string;
    description: string;
    isVisible: boolean;
    isRequired: boolean;
    picture: string;
    ClientTitle: string;
    elements: (ElementsEntity1)[];
    isOptional: boolean;
}
export interface ElementsEntity1 {
    type: string;
    Card: string;
    key: string;
    title: string;
    description: string;
    isVisible: boolean;
    isRequired: boolean;
    choices: (ChoicesEntity1)[];
    isOptional: boolean;
    md: number;
    hasScore: boolean;
    placeholder: string;
    imgsrc: string;
    maxSize: number;
    html: string;
    visibleIfType: string;
    visibleIfKey: (string)[];
}
export interface ChoicesEntity1 {
    status: string;
    type: string;
    key: string;
    value: string;
    label: string;
    description: string;
    isVisible: boolean;
    isRequired: boolean;
    picture: string;
    elements: (ElementsEntity2)[];
}
export interface ElementsEntity2 {
    type: string;
    md: number;
    hasScore: boolean;
    key: string;
    title: string;
    isRequired: boolean;
    isVisible: boolean;
    visibleIfType: string;
    visibleIfKey: string;
    isOptional: boolean;
    visibleIfList: (string)[];
    choices: (ChoicesEntity2)[];
    visibleIfStatus: (string)[];
    min: number;
    placeholder: string;
    imgsrc: string;
    acceptedTypes: string;
    maxSize: number;
}
export interface ChoicesEntity2 {
    value: number;
    label: string;
    Score: number;
}
export interface ListEntity {
    type: string;
    md: number;
    hasScore: boolean;
    key: string;
    title: string;
    isRequired: boolean;
    isVisible: boolean;
}
//#endregion
export function ReturnLanguageOptionsHtML(languagesOptions: BasicSelectOption[]) {
    let _languages: string = ''; // can add to props 
    for (let lang of languagesOptions) {
        _languages +=
            `<label class="RadioLabel d-block mt-2 mb-2 ant-radio-wrapper">
                <input name="languageChecked" type="radio" value="${lang.value}">
                    <span class="LabelCreate2 ml-1 font14">${lang.label}
                    </span>
                </label>`;
    }
    return _languages;
}
export function ReturnSelectOptions(SelectOpt: any, value: string, label: string, preview?: any) {
    try {
        if (!SelectOpt) return [];
        let _options: any = [];
        for (var k = 0; k < SelectOpt.length; k++) {
            _options.push({ value: SelectOpt[k][value], label: preview ? preview(SelectOpt[k]) : SelectOpt[k][label], Data: SelectOpt[k], ...SelectOpt[k] });
        }
        if (!_options || _options.length === 0)
            return [];
        else {
            return _options;
        }
    } catch (e) {
        return [];
    }
};
export function ReturnNumberFixedBY(value: number | string, decmialPoints?: number): any {
    if (!value || isNaN(+(value))) return 0.00;
    else {
        try {
            return parseFloat(String(value)).toFixed(decmialPoints ? decmialPoints : 2);
        } catch (e) {
            console.log(e, "ReturnNumberFixedBY")
            return 0.00;
        }
    }
}
export function RenturnSplitedRange(_date: string): { from: any, to: any } {
    try {
        if (!_date) return { from: moment(), to: moment() };
        let _dateRanges = _date.split(',');
        if (!_dateRanges || !_dateRanges[0] || !_dateRanges[1])
            return { from: moment(), to: moment() };
        return { from: moment(_dateRanges[0]), to: moment(_dateRanges[1]) }
    } catch (e) {
        console.log('splitDate', e)
        return { from: moment(), to: moment() };
    }
}
export function disabledDate(current: any) {//rename
    return (current && current > moment().endOf('day'));
}
//#region DM 

export function ReturnSymbolSecType(Type: string) {
    if (!Type) return ' - ';
    switch (Type) {
        case "FX":
        case "CFDLEVERAGE":
            {
                return 'Leverage';
            }
        case "CFD":
        case "INX":
        case "CFDLEV":
            {
                return 'Percentage';
            }
        case "Futures": {
            return 'Multiplier';
        }
        default: {
            return ' - '
        }
    }
}
export function ReturnAccSecType(Type: string) {
    if (!Type) return ' - ';
    switch (Type) {
        case "FX": {
            return 'FX-Leverage';
        }
        case "CFD": {
            return 'CFD-Percentage';
        }
        case "Futures": {
            return 'Futures-Multiplier';
        } case "INX": {
            return 'INX-Percentage';
        } case "CFDLEV": {
            return 'CFDLEV-Percentage';
        }
        case "CFDLEVERAGE": {
            return 'CFDLEVERAGE-Leverage';
        }
        default: {
            return ' - '
        }
    }
}
//#endregion
export function ReturnFilterValue(PageName: string, dict: any) {
    return function (value: any, elementName: string, StaticValue?: any) {
        try {
            if (dict[PageName] && dict[PageName][elementName])
                return dict[PageName][elementName];
        } catch (e) {
            console.error('ReturnFilterValue', e);
        }
        return value;
    }
}
export function ReturnFilterSelectedOptions(PageName: string, dict: any) {
    return function (_options: any, elementName: string, StaticValue?: any) {
        try {
            if (dict[PageName] && dict[PageName][elementName] && dict[PageName][elementName].length > 0)
                return dict[PageName][elementName];
        } catch (e) {
            console.error('ReturnFilterSelectedOptions', e);
        }
        return _options && _options.length > 0 ? (StaticValue ? _options : ReturnValuesForMultiSelect(_options)) : [];
    }
}
export function UpdateSelectedFiltrationValues(dict: any, PageName: string, Values: any, UpdateFiltrationDict: any) {
    try {
        let _TableFiltrationDict = { ...dict }
        if (_TableFiltrationDict[PageName])
            _TableFiltrationDict[PageName] = {
                ..._TableFiltrationDict[PageName],
                ...Values
            };
        else
            _TableFiltrationDict[PageName] = Values;
        UpdateFiltrationDict({ ..._TableFiltrationDict });
    } catch (e) {
        console.error('UpdateSelectedFiltrationValues', e)
    }
}
//#endregion
//#region Auth
//Auth
export enum EPermissionValue {
    Allow = 1,
    Deny = 2,
    Team = 3,
    Owned = 4
}
//#endregion


export function ReturnCountryCode(Code: string) {
    try {
        if (!Code) return "";
        switch (Code) {
            case "ID": {
                return "Indonesia";
            }
            default: {
                return Code
            }
        }
    } catch (e) {
        console.error('ReturnCountryCode', e);
        return "";
    }
}
export function TimeZonesOptions(t: Function) {//@point check if can remove luxon or can benfit from it 
    return timezones.default.filter((t: any) => !luxonIgnoredTimezones[t.tzCode] && t.tzCode !== 'Etc/GMT').map((timezone: any) => {

        //const offset = new Date().getTimezoneOffset();//only will get our cuurent need set time zone 
        const zoneTime = DateTime.local().setZone(timezone.tzCode);
        //const offset = new Date().getTimezoneOffset();
        const offset = zoneTime.offset;
        const offsetSign = offset > 0 ? '+' : offset < 0 ? '-' : '';
        const offsetNormalized = offset !== 0 ? Math.abs(offset / 60) : '';
        const offsetText = `(GMT${offsetSign}${offsetNormalized})`;

        const tzRegion = timezone.tzCode.split('/')[0];
        return {
            //text: `${timezone.label.replace(/\(.*\)/, offsetText)} - ${t(tzRegion)}`,
            text: `${offsetText} ${t(timezone.tzCode)} - ${t(tzRegion)}`,
            offset,
            tzCode: timezone.tzCode
        };
    })
        .sort((a: any, b: any) => a.offset - b.offset || a.text.localeCompare(b.text));
}
export function GetColumWitdh(Dict: any, pageName: any) {
    return function (StaticWidth: string, index: number) {
        try {
            let _TableFiltrationDict: any = { ...Dict };
            let Columns = _TableFiltrationDict[pageName]?.Columns ? _TableFiltrationDict[pageName]?.Columns : [];
            return Columns[index]?.width && (parseInt(Columns[index]?.width?.toLowerCase().replace('px', ''), 10) > 0) ? String(Columns[index]?.width) : (StaticWidth === "auto" ? "100px" : StaticWidth);
        } catch (e) {
            console.error('GetColumWitdh', e);
            return StaticWidth;
        }
    }
}
export function ValidateExpLimit(value: any): boolean {
    return value !== undefined && value !== null && String(value) !== "";
}
export function ReturnMultiSelectedFiltrationValuesToUpdate(selectedValues: any[], Options: any[]) {
    try {
        return ((selectedValues?.length && Options?.length) && selectedValues.length !== Options?.length) ? selectedValues : null;
    } catch (e) {
        console.error('ReturnSelectedOptionsForSaveFiltration', e);
        return selectedValues;
    }
}
export function ReturnOptionByValue(value: any, list: any[]) {
    if (!list || list.length === 0) return { value: -1, label: "No Data" };
    for (let i: number = 0; i < list.length; i++) {
        if (String(value)?.toLowerCase()?.trim() === String(list[i].value)?.toLowerCase()?.trim()) //icons on icon
            return list[i];
    }
    return { value: -1, label: "Select" };
}
export function ReturnOptionByLabel(label: any, list: any[]) {
    if (!list || list.length === 0) return { value: -1, label: "No Data" };
    for (let i: number = 0; i < list.length; i++) {
        if (String(label)?.toLowerCase() === String(list[i].label)?.toLowerCase())
            return list[i];
    }
    return { value: -1, label: "Select" };
}
export function ReturnFirstValue(list: any[]) {
    try {
        if (!!list && list.length !== 0) {
            return list[0];
        }
        else {
            return { value: -1, label: "No Data" };
        }
    } catch (e) {
        console.error(e, 'RETURN_FIRST_VALUE');
    }
}
export function ReturnOptionByField(label: any, list: any, field: string) {
    if (!list || list.length === 0) return { value: -1, label: "No Data" };
    for (let i: number = 0; i < list.length; i++) {
        if (String(label)?.toLowerCase() === String(list?.[i]?.[field])?.toLowerCase())
            return list[i];
    }
    return { value: -1, label: "Select" };
}
export function ReturnValidJsonAppforms(JsonString: any): any {
    if (!JsonString) return {};
    try {
        return JSON.parse(JsonString);//as effect correct ones
    } catch (e) {
        console.error('unvalidJson: ', e);
        try {
            let myEscapedJSONString = JsonString.replace(/\n/g, " ");
            return JSON.parse(myEscapedJSONString) //to remove control character as enter  great
        } catch (e) {
            console.error('Unvalid stringfy: ', e);
            return {};
        }
    }
}
export const NODATA = { value: -1, label: "No Data" };
export const NONESELECTED = { value: -1, label: "Select" };
export function SetValueOfIndex(list: any[], callBack: any, index: number) {
    if (list && list.length >= index && list[index])
        callBack(list[index]);
    else
        callBack(NONESELECTED);
}
export function ReturnValidLink(link: string) {
    if (!link) return '_';
    if (!link.endsWith('/')) {
        return `${link}/`;
    }
    return link;
}
export function ValidateValue(value: any): boolean {
    return value !== undefined && value !== null;
}
export function toFixedNoRounding(num: number) {
    if (!num || !isNumber(num)) return 0;
    return (parseInt(String(num * 100), 10) / 100);
}
export function toFixedNoRoundingDigits(num: number, Digits: number) {
    try {
        if (!num || !isNumber(num)) return 0;
        if (!Digits) return num;
        return (parseInt(String(num * Math.pow(10, Digits)), 10) / Math.pow(10, Digits));
    } catch (e) {
        console.error('toFixedNoRoundingDigits', e);
        return 0;
    }
}
export function RoundingDigit(num: number, Digits: number) {
    try {
        if (!num || !isNumber(num)) return 0;
        if (!Digits) return num;
        return +(num.toFixed(Digits));
    } catch (e) {
        console.error('toFixedNoRoundingDigits', e);
        return 0;
    }
}
export function ReturnParamString(text: any): string {
    return text?.includes('?') ? '&' : '?';
}
export function ReturnSlashString(text: any): string {
    return text?.endsWith('/') ? '' : '/';
}
//#region multibank Payments
export const BeneficiaryBankName: BasicSelectOption[] = [
    { value: "Standard Chartered (Thai)", label: "Standard Chartered (Thai)" },
    { value: "Government Savings Bank", label: "Government Savings Bank" },
    { value: "TMB Bank", label: "TMB Bank" },
    { value: "United Overseas Bank (Thai)", label: "United Overseas Bank (Thai)" },
    { value: "CIMB Thai Bank", label: "CIMB Thai Bank" },
    { value: "Citibank", label: "Citibank" },
    { value: "Thanachart Bank", label: "Thanachart Bank" },
    { value: "Kasikornbank", label: "Kasikornbank" },
    { value: "Siam Commercial Bank", label: "Siam Commercial Bank" },
    { value: "Bangkok Bank", label: "Bangkok Bank" },
    { value: "Bank of Ayudhya (Krungsri)", label: "Bank of Ayudhya (Krungsri)" },
    { value: "ABA Bank (Cambodia)", label: "ABA Bank (Cambodia)" },
    { value: "FNB (South Africa)", label: "FNB (South Africa)" },
    { value: "Kanbawza Bank (Myanmar)", label: "Kanbawza Bank (Myanmar)" },
    { value: "Krungthai Bank", label: "Krungthai Bank" },
    { value: "BCEL", label: "BCEL" }
]
export const ThunderPayPaymentCurrency: BasicSelectOption[] = [
    { value: "KHR", label: "KHR" },
    { value: "LAK", label: "LAK" },
    { value: "THB", label: "THB" },
    { value: "MMK", label: "MMK" }]
export const FXBitPaymentCurrency: BasicSelectOption[] = [
    { value: "BTC", label: "BTC" },
    { value: "USDT", label: "USDT" },
    { value: "ETH", label: "ETH" }]
//Endregion
export function ReturnNameAfterDash(str: string): string {
    try {
        return str.split("-")[1];
    } catch (e) {
        console.log("ReturnNameAfterDash", e);
        return str ? str : "";
    }
}
export function ReturnAllocationFormula(str: string): string {
    try {
        switch (str) {
            case "EV": {
                return "CopierAccountWiilBeFollowingTheSignalAccountAccordingToTheDefinedPercentageSetByEachCopierAccount";
            }
            case "Fixed Lot": {
                return "CopierAccountWillBeFollowingTheSignalAccountAccordingToTheDefinedFixedLotAmount";
            }
            case "% of Equity": {
                return "CopierAccountWillBeFollowingTheSignalAccountToEquity";
            }
            default: {
                return ' - '
            }
        }
    } catch (e) {
        console.log("Return Allocation Formula", e);
        return ' - '
    }
}
export function validateRef(ref: string): boolean {
    if (!ref) return false;
    let regex = /^[\w-]+$/;
    return ref.match(regex) ? true : false;
}
//#region Layout
export function RemoveSpacesNLastSemicolon(emails: string) {
    return emails?.replace(/\s/g, '')?.replace(/;$/g, '');
}
export function ValidateEmailList(emails: string): boolean {
    try {
        if (emails == "") return false;
        let _emailList: string[] = RemoveSpacesNLastSemicolon(emails)?.split(";");//TODO add in 1 replace
        for (let email of _emailList) {
            if (email == "" || !validateEmail(email)) {
                return false;
            }
        }
        return true;
    } catch (e) {
        console.log(e, "ValidateEmailList");
        return false;
    };
}
//#endregion

export function ReturnOptionByComma_Separated_Values(Comma_Separated_Values: any, list: any[]) {
    let _finallist: any[] = [];
    if (!Comma_Separated_Values) return _finallist;
    for (let item of list) {
        if (Comma_Separated_Values.includes(`${item?.value}`)) {
            _finallist.push(item);
        }
    }
    return _finallist;
}
export function ConvertListToTree(data: any, parent: any) { //recursive
    const result =
        data.filter((d: SubIBs) => (d.ParentClientID === parent));

    if (!result || !result.length) {
        return null;
    }

    return result.map(({ ClientID, ClientName, IBCode }: any) =>
        ({ ClientID, label: ` ${ClientName} - ${IBCode}`, children: ConvertListToTree(data, ClientID), expanded: true }))
}
//#region Document Expiration
enum EDocumentTypes {
    IDType = "IDType",
    IDType2 = "IDType2",
}
export function GetDocuments(_dict: any) {
    try {
        let _Documents = cloneDeep(_dict);
        _Documents = _.pickBy(_Documents, (value: any) => (value?._inTab === "Documents"));
        return _Documents;
    } catch (e) {
        console.log('GetDocuments', e);
        return cloneDeep(_dict);
    }
}
export function GetExpirationList(_Documents: any) {
    try {
        let expirations = [];
        let _IDType = _Documents[EDocumentTypes.IDType];
        let _IDType2 = _Documents[EDocumentTypes.IDType2];
        if (_IDType && _Documents[`ExpiryDate${_IDType}`]) {
            expirations.push({
                Type: EDocumentTypes.IDType,
                ExpiryDate: _Documents[`ExpiryDate${_IDType}`],
                Selected: _IDType
            });
        }
        if (_IDType2 && _Documents[`ExpiryDate2${_IDType2}`]) {
            expirations.push({
                Type: EDocumentTypes.IDType2,
                ExpiryDate: _Documents[`ExpiryDate2${_IDType2}`],
                Selected: _IDType2
            });
        }
        return expirations;
    } catch (e) {
        console.error('GetExpirationList', e);
        return [];
    }
}
export function GetDocumentValues(_Documents: any, key: string, _dict: any) {
    try {
        //_dict[key]?.Data?.isVisible for document check All dict as it is outside
        if (_Documents[key] && _dict[key]?.Data?.isVisible) { //take value for Visible
            return _Documents[key]?.value;
        } else {
            return null;
        }
    } catch (e) {
        console.error('GetDocumentValues', e)
        return {};
    }
}
//#endregion
//#region Enums
//KYC Status
export enum EKYCStatus {
    Pending = '0',
    Completed = '1',
    Rejected = '-1',
    NotCompleted = '2',
}
//Platforms
export enum EPlatforms {
    MT5 = "MT5",
    MT4 = "MT4",
}
//#endRegion
export const GBPrimePayPaymentOptions = [
    { value: 'text', label: 'Text' },
    { value: 'img', label: 'Image' },
];
var _isZendDeskDisplay = "";//locatroge will stay after reload//not our practice
export function DisplayZendDeskChat(isVisble: boolean) {
    //if (window?.zE) {
    //    if (_isZendDeskDisplay !== `${isVisble}`) {
    //        window.zE('messenger:set', 'cookies', isVisble);
    //        _isZendDeskDisplay = `${isVisble}`;
    //    }
    //}
}
export function CheckIfIsExternalPage(href: any): boolean {
    if (!href) return false;
    for (let route of ExternalRoutes) {
        //console.log(href.toLowerCase(), "route.path.toLowerCase()", route.path.toLowerCase(), window.location.pathname)
        //if (href && href.toLowerCase().includes(route.path.toLowerCase())) { /demoaccount /Manage/DemoAccounts wont work 
        if (window?.location?.pathname?.toLowerCase() === route?.path?.toLowerCase()) {
            return true;
        }
    }
    return false;
}
//#region New Permissions
export function GetReportsPerms(ReportsUserPerms: UserPermissionOBjectClass): { BonusReportsPerm: boolean; CRMREports: boolean; IBReports: boolean; DLReports: boolean; BackofficeReports: boolean; MAMReports: boolean; } {
    //BonusReportsPerm Perm as suffix as component named same 
    let BackofficeReports: boolean = CheckIfPermAlllowedByName('Backoffice Reports', ReportsUserPerms.Perms);
    let MAMReports: boolean = CheckIfPermAlllowedByName('MAM Reports', ReportsUserPerms.Perms);
    let BonusReportsPerm: boolean = CheckIfPermAlllowedByName('Bonus Reports', ReportsUserPerms.Perms);
    let CRMREports: boolean = CheckIfPermAlllowedByName('CRM REports', ReportsUserPerms.Perms);
    let IBReports: boolean = CheckIfPermAlllowedByName('IB Reports', ReportsUserPerms.Perms);
    let DLReports: boolean = CheckIfPermAlllowedByName('DL Reports', ReportsUserPerms.Perms);
    return { BonusReportsPerm, CRMREports, IBReports, DLReports, BackofficeReports, MAMReports };
}
export function OneOFReportsEnabled({ BonusReportsPerm, CRMREports, IBReports, DLReports, BackofficeReports, MAMReports }: any) {
    return (BonusReportsPerm || CRMREports || IBReports || DLReports || BackofficeReports || MAMReports);
}
//#endregion
export const groupByCustomValue = (key: any, value: any) => (array: any) => {
    try {
        return array.reduce((item: any, obj: any) => {
            const property = obj[key];
            item[property] = item[property] || [];
            item[property].push(obj[value]?.toString());
            return item;
        }, {});
    } catch (e) {
        console.error('groupBy', e);
        return {};
    }
}
//#region webhooks
export function GenerateKey(length?: number) {//like GUID
    function convertDecimalToHexa(dec: any) {
        return dec.toString(16).padStart(2, "0");
    }
    let arr = new Uint8Array((length || 40) / 2)
    window.crypto.getRandomValues(arr)
    return Array.from(arr, convertDecimalToHexa).join('')
}
export function GenerateRandomKey() {
    let charset = "abcdefghijklmnopqrstuvwxyz",
        Captial = "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
        numeric = '0123456789',
        SpecialSet = "!@#$%^&",
        retVal = "";
    let _nbofChars: number = 0;
    addlowercase(4);
    addCaptial(4);
    addNumeric(4);
    addSpecialCharacters(3);
    return retVal.split('').sort(() => Math.random() - 0.5).join(''); //return them shuffled 


    function addSpecialCharacters(amount: number) {
        for (let i = _nbofChars, n = SpecialSet.length; i < _nbofChars + amount; ++i) {
            retVal += SpecialSet.charAt(Math.floor(Math.random() * n));
        }
    }

    function addNumeric(amount: number) {
        for (let i = _nbofChars, n = numeric.length; i < _nbofChars + amount; ++i) {
            retVal += numeric.charAt(Math.floor(Math.random() * n));
        }
    }

    function addCaptial(amount: number) {
        for (let i = _nbofChars, n = Captial.length; i < _nbofChars + amount; ++i) {
            retVal += Captial.charAt(Math.floor(Math.random() * n));
        }
    }

    function addlowercase(amount: number) {
        for (let i = 0, n = charset.length; i < (_nbofChars + amount); ++i) {
            retVal += charset.charAt(Math.floor(Math.random() * n));
        }
    }
}
///#endregion
export const PRAXIS_LANGUAGES: any = {
    "ar": "ar-SA",
    "cn": "zh-CN",
    "ct": "zh-TW",
    "en": "en-GB",
    "fr": "fr-FR",
    "jp": "ja-JP",
    "pl": "pl-PL",
    "th": "th-TH",
    "vn": "vi-VN",
    "cs": "cs-CZ",
    "nl": "nl-NL",
    "tl": "tl-PH",
    "fi": "fi-FI",
    "de": "de-DE",
    "el": "el-GR",
    "he": "he-IL",
    "hi": "hi-IN",
    "hu": "hu-HU",
    "it": "it-IT",
    "id": "id-ID",
    "ko": "ko-KR",
    "lt": "lt-LT",
    "ms": "ms-MY",
    "pt": "pt-PT",
    "ru": "ru-RU",
    "sk": "sk-SK",
    "es": "es-ES",
    "sv": "sv-SE",
    "tr": "tr-TR",
    "hy": "hy-AM",
    "bg": "bg-BG",
    "kh": "kh-KH",
    "da": "da-DK",
    "et": "et-EE",
    "ka": "ka-GE",
    "lv": "lv-LV",
    "nn": "nn-NO",
    "sr": "sr-RS",
    "sl": "sl-SI",
    "ta": "ta-IN",
    "uk": "uk-UA",
    "sq": "sq-AL",
}

export function getImagesURL_IGain(BannerCDNURL: any, CompanyName: any, DefaultURL: any) {
    if (CompanyName?.toLowerCase() === "igain") return `${BannerCDNURL}igain/themes/greenGrey/`;
    if (CompanyName?.toLowerCase() === "primex") return `${BannerCDNURL}primex/themes/primexOrange/`;
    return `${DefaultURL}imgs/`;
}
export function getImagesURL_LDN(BannerCDNURL: any, CompanyName: any, DefaultURL: any) {
    if (CompanyName?.toLowerCase() === "ldn") return `${BannerCDNURL}ldn/themes/orangeBlack/`;
    if (CompanyName?.toLowerCase() === "primex") return `${BannerCDNURL}primex/themes/primexOrange/`;
    return `${DefaultURL}imgs/`;
}
export function getImagesURL_IGain_LDN(BannerCDNURL: any, CompanyName: any, DefaultURL: any) {
    if (CompanyName?.toLowerCase() === "igain") return `${BannerCDNURL}igain/themes/greenGrey/`;
    if (CompanyName?.toLowerCase() === "ldn") return `${BannerCDNURL}ldn/themes/orangeBlack/`;
    if (CompanyName?.toLowerCase() === "primex") return `${BannerCDNURL}primex/themes/primexOrange/`;
    return `${DefaultURL}imgs/`;
}

//#region Igain images 
export const BTC_BITCOIN = require("../../src/Assets/imgs/BTC(Bitcoin).jpeg") as string;
export const BTC_BITCOIN_txt = "1MJuptJgHs32nXydjTuPnHs2vyEFGCSD3v";
export const ETH_ERC20 = require("../../src/Assets/imgs/ETH(ERC20).jpeg") as string;
export const ETH_ERC20_txt = "0x24a1997ed78a7743765a9390c511430bea0171dc";
export const USDT_ERC20 = require("../../src/Assets/imgs/USDT(ERC20).jpeg") as string;
export const USDT_ERC20_txt = "0x24a1997ed78a7743765a9390c511430bea0171dc";
export const USDT_TRC20 = require("../../src/Assets/imgs/USDT(TRC20).jpeg") as string;
export const USDT_TRC20_txt = "TKefq2rcp1R6Ra7zkww9nxELu6ts8T2i6T";
//#endregion

export function CheckIfCompanyIs(CompanyName: string) {
    return store?.getState()?.CompanyData?.CompanyCode?.toLowerCase() === CompanyName?.toLowerCase();
}
export function ReturnLDNImage(img: string): string {
    if (CheckIfCompanyIs("LDN")) {
        return `${getImagesURL_IGain_LDN(store?.getState()?.CompanyData?.BannerCDNURL, store?.getState()?.CompanyData?.CompanyCode, store?.getState()?.CompanyData?.CDNURL)}NoData.png`;
    }
    return img;
}
//#region Dynamic Margin
export function CheckIFTrenchesIntervalIsValid(MarginTiles: IMarginTiles[]) {//for sessions we must Validate them otherwise no need to build 
    if (!MarginTiles || MarginTiles?.length === 0) return /*ValidateExpLimit(ProfileExpLimit) && +(ProfileExpLimit) > -1 ? true :*/ false;//true as check levels before it
    for (let i = 0; i < MarginTiles?.length; i++) {
        if (i > 0) {
            let _PreviousTrenches = parseFloat(String(MarginTiles[i - 1].Trenches || 0));
            if (_PreviousTrenches >= parseFloat(String(MarginTiles[i].Trenches || 0))) {//must be bigger
                return false;
            }
        }
    }
    return true;
}
function ReturnFromTierDate(_tier: TierClass) {
    const _FromDay = +(_tier.FromDay) > 9 ? _tier.FromDay : `0${_tier.FromDay}`;
    return new Date(`October ${_FromDay}, 2022 ${_tier.FromHour}:${_tier.FromMinute}:00`)
}
function ReturnToTierDate(_tier: TierClass) {
    const ToDay = +(_tier.ToDay) > 9 ? _tier.ToDay : `0${_tier.ToDay}`;
    return new Date(`October ${ToDay}, 2022 ${_tier.ToHour}:${_tier.ToMinute}:00`)
}
export function SortSessions(a: TierClass, b: TierClass): 1 | -1 {
    return ReturnFromTierDate(a)?.getTime() > ReturnFromTierDate(b)?.getTime() ? 1 : -1;
}
export function ConvertMarginIntoDictionary(list: any[]) {//same key will be eliminated
    let _newDict: any = [...list].reduce((obj: any, item: any, index: number) => {
        //console.log("ConvertMarginIntoDictionary: ", item, moment(ReturnFromTierDate(item)).format('MM/DD/YY hh:mm'));
        if (!!obj[moment(ReturnFromTierDate(item)).format('MM/DD/YY hh:mm')]) { //comparator
            obj[`${moment(ReturnFromTierDate(item)).format('MM/DD/YY hh:mm')}_Duplicate`] = item;
        } else {
            obj[moment(ReturnFromTierDate(item)).format('MM/DD/YY hh:mm')] = item;
        };
        return obj
    }, {});
    return _newDict;
}
export function ValidateDMTiers(Tiers: TierClass[]) { // CANT SORET SESSION AS WILL CUZ ISSUE IN INDEX unless use dict
    try {
        let TiersDict = ConvertMarginIntoDictionary(Tiers);//no need as new Structure
        let PrevTier: any = null;
        for (const key in TiersDict) {//validate leverage
            if (key.includes('_Duplicate')) {
                console.log("_Duplicate no valid ", key);
                return false;
            }
            const tier = TiersDict[key];
            if (!CheckIFTrenchesIntervalIsValid(tier.MarginTiles)) {//ProfileExpLimit no need 
                console.log("CHECK_IF_TRENCHES_INTERVAL_IS_VALID ", tier);
                return false;
            }

            if (!ValidateTierDate(tier, PrevTier)) {
                console.log("VALIDATETIER_DATE no valid ", tier, PrevTier)
                return false;
            }
            PrevTier = tier;
        }
        return true;
    } catch (e) {
        console.error("ValidateTiers", e);
        return false;
    }
    //validate Date in loop function for all 
    function ValidateTierDate(_tier: TierClass, PrevTier: TierClass | null) {
        //CREATE Date FROM DATA YOU HAVE and ADD AS Dictionary 

        const _fromDate = ReturnFromTierDate(_tier);
        const _toDate = ReturnToTierDate(_tier);
        _fromDate?.setSeconds(0);
        _toDate?.setSeconds(0);

        if (_fromDate.getTime() >= _toDate.getTime()) {//as same time will not even work 
            console.log("error _fromDate", _fromDate, _toDate);
            return false;
        }
        if (!!PrevTier) {
            const PervFromDate = ReturnFromTierDate(PrevTier);
            const PervToDate = ReturnToTierDate(PrevTier);
            /*if (!(key === index) && //byPass current one
            compare with `October ${item.FromDay}, 2022 ${item.FromHour}:${item.FromMinute}:00`*/
            if (CheckDateInBetween(_fromDate, PervToDate, PervFromDate) || CheckDateInBetween(_toDate, PervToDate, PervFromDate)) {
                console.log("PrevTier: ", PervFromDate, PervToDate, CheckDateInBetween(_fromDate, PervToDate, PervFromDate), CheckDateInBetween(_toDate, PervToDate, PervFromDate));
                return false;
            }
        }
        return true;
        function CheckDateInBetween(check: Date, to: Date, from: Date) {
            check.setSeconds(0);
            to.setSeconds(0);
            from.setSeconds(0);
            return (check.getTime() <= to.getTime() && check.getTime() >= from.getTime());
        }
    }
}

export function ValidateAccountExposureTiers(Tiers: TierClass[]) { // CANT SORET SESSION AS WILL CUZ ISSUE IN INDEX unless use dict
    try {
        let TiersDict = ConvertMarginIntoDictionary(Tiers);//no need as new Structure
        let PrevTier: any = null;
        for (const key in TiersDict) {//validate leverage
            if (key.includes('_Duplicate')) {
                console.log("_Duplicate no valid ", key);
                return false;
            }
            const tier = TiersDict[key];
            if (!CheckIFTrenchesIntervalIsValid(tier.MarginTiles)) {
                console.log("checkIfIntervalIsValid ", tier);
                return false;
            }

            if (!ValidateTierDate(tier, PrevTier)) {
                console.log("ValidateTierDate no valid ", tier, PrevTier)
                return false;
            }
            PrevTier = tier;
        }
        return true;
    } catch (e) {
        console.error("ValidateTiers", e);
        return false;
    }
    //validate Date in loop function for all 
    function ValidateTierDate(_tier: TierClass, PrevTier: TierClass | null) {
        //CREATE Date FROM DATA YOU HAVE and ADD AS Dictionary 

        const _fromDate = ReturnFromTierDate(_tier);
        const _toDate = ReturnToTierDate(_tier);
        _fromDate?.setSeconds(0);
        _toDate?.setSeconds(0);

        if (_fromDate.getTime() >= _toDate.getTime()) {//as same time will not even work 
            console.log("_fromDate");
            return false;
        }
        if (!!PrevTier) {
            const PervFromDate = ReturnFromTierDate(PrevTier);
            const PervToDate = ReturnToTierDate(PrevTier);
            /*if (!(key === index) && //byPass current one
            compare with `October ${item.FromDay}, 2022 ${item.FromHour}:${item.FromMinute}:00`*/
            if (CheckDateInBetween(_fromDate, PervToDate, PervFromDate) || CheckDateInBetween(_toDate, PervToDate, PervFromDate)) {
                console.log("PrevTier: ", PervFromDate, PervToDate, CheckDateInBetween(_fromDate, PervToDate, PervFromDate), CheckDateInBetween(_toDate, PervToDate, PervFromDate));
                return false;
            }
        }
        return true;
        function CheckDateInBetween(check: Date, to: Date, from: Date) {
            check.setSeconds(0);
            to.setSeconds(0);
            from.setSeconds(0);
            return (check.getTime() <= to.getTime() && check.getTime() >= from.getTime());
        }
    }
}
export const DAY_OPTIONS = [
    { value: 0, label: "Sunday" },
    { value: 1, label: "Monday" },
    { value: 2, label: "Tuesday" },
    { value: 3, label: "Wednesday" },
    { value: 4, label: "Thursday" },
    { value: 5, label: "Friday" },
    { value: 6, label: "Saturday" },
];
export const DAY_DICTIONARY: any = {
    0: "Sunday",
    1: "Monday",
    2: "Tuesday",
    3: "Wednesday",
    4: "Thursday",
    5: "Friday",
    6: "Saturday",
};
export function ReturnAccSecTypesIfMarginIsEmpty(AccExpID: number, selectedSecuitries: BasicSelectOption[]) {
    let _AccSecTypesList: any[] = [];
    try {
        let _SecTypes = [...(selectedSecuitries || [])];
        for (let secTypeID of _SecTypes) {
            _AccSecTypesList.push({ AccExpID, SecTypeID: secTypeID.value, MargTiers: '' });
        }
    } catch (e) {
        console.error('GetAccSecTypesIfMarginIsEmpty', e);
    }
    return _AccSecTypesList;
}
export function ReturnAccSecTypesList(MarginTiles: any, selectedSecurities: BasicSelectOption[]) {//_marginTiersList
    let _AccSecTypesList: any[] = [];
    if (selectedSecurities && selectedSecurities?.length > 0 && MarginTiles && MarginTiles.length > 0) {
        for (let i: number = 0; i < selectedSecurities.length; i++) {
            let _ID = +(selectedSecurities[i].value);
            let _margin: any = '';
            for (let k: number = 0; k < MarginTiles.length; k++) {
                _margin += `T${MarginTiles[k].level}=${MarginTiles[k].Trenches || 0}:${MarginTiles[k][selectedSecurities[i].label] || 0};`;
            }
            _AccSecTypesList.push({ AccExpID: 0, SecTypeID: _ID, MargTiers: _margin });
        }
    }
    //LogMessage('GenerateMarginTiers', _marginTiersList);
    return _AccSecTypesList;
}
export function ReturnAccExpMarginTiers(Tier: TierClass, selectedSecurities: BasicSelectOption[]) {// beascue secuirties may change 
    let _margins: any = "";
    let list: any = [...(Tier?.MarginTiles || [])];
    for (let margin of list) {
        _margins += `${margin.Trenches || 0}: `;
        for (let SecuitryType of selectedSecurities) {
            _margins += `${SecuitryType.value || 0}=${margin[SecuitryType.label] || 0},`
        }
        _margins += `;`;
    }
    _margins = _margins.replace(/\s/g, '');
    _margins = _margins.replace(/,;/g, ';');
    return _margins;
}
export function ReDrawMarginTilesForAllList(list: TierClass[], selectedSecurities: BasicSelectOption[]) {//For TiersJson
    let tiers = [...list];
    for (const index in tiers) {
        let currentTier = list?.[index];
        let _list: any[] = [];//dont take old as redraw new 
        for (let i: number = 0; i < parseInt(String(currentTier.levels), 10); i++) {
            let _itemsFromValue: any = selectedSecurities && selectedSecurities?.length > 0 ?
                ConvertIntoDictionaryWithSpecificValue(selectedSecurities, "label", "") : {};// label here check
            _list.push({ level: `${i}`, Trenches: "", ..._itemsFromValue });
        }
        currentTier.MarginTiles = _list;
    }
    return tiers;
}
export function castIntoSessions({ Tiers, ServerID, ProfileID, isAdd, isAccountExp, selectedSecuitries }
    : {
        Tiers: TierClass[], ServerID: number, ProfileID: number,
        isAdd: boolean, isAccountExp?: boolean,
        AccExpID?: number, selectedSecuitries?: BasicSelectOption[]
    }): ProfileSesssions[] | AccExpSesssions[] {
    const NewTiers = isAccountExp ? Tiers : Tiers;
    let newList: any[] = [...(NewTiers || [])];
    newList = newList.map((item: TierClass) => { //PermsLicList not getting same as class
        const ACC_SECTYPES_LIST: AccSecTypeClass[] = ReturnAccSecTypesList(item, selectedSecuitries || []);
        return {
            ServerID: ServerID,
            SessionID: (!isAdd && !!item?.isEdit) ? item.SessionID : 0,//add
            ProfileID: isAccountExp ? undefined : (isAdd ? 0 : ProfileID),
            AccExpID: !isAccountExp ? undefined : (isAdd ? 0 : ProfileID),
            FromDay: +(item.FromDay),
            ToDay: +(item.ToDay),
            FromHour: +(item.FromHour),
            ToHour: +(item.ToHour),
            FromMinute: +(item.FromMinute),
            ToMinute: +(item.ToMinute),
            Tiers: !isAccountExp ? item.MarginTiers : ReturnAccExpMarginTiers(item, selectedSecuitries || []),
            TiersJson: JSON.stringify(item?.MarginTiles || []),
            AccSecType: !isAccountExp ? undefined : (ACC_SECTYPES_LIST && ACC_SECTYPES_LIST?.length > 0 ? ACC_SECTYPES_LIST : ReturnAccSecTypesIfMarginIsEmpty(ProfileID || 0, selectedSecuitries || []))
        };
    });
    return newList;
}
export function ReturnMarginTiersWithTitles(AccSecTypeList: any[], SecurityTypeDict: any) {
    let list: any = "";
    for (let AccSecType of AccSecTypeList) {
        //"CFD-Percentage: T0=1:2;T1=4:5;INX - Percentage: T0=1:3;T1=4:6;"
        list += `${ReturnSecuirtyTypeTitle(SecurityTypeDict?.[AccSecType?.SecTypeID || 0]?.label)} : ${AccSecType?.MargTiers}\n`
    }
    return list;
}
export function castIntoTiers({ PSesssions, isAccountExp, AccSecTypeList, SecurityTypeDict, selectedSecuitries }:
    { PSesssions: DMSessionsResult[], isAccountExp?: boolean, AccSecTypeList?: any[], SecurityTypeDict?: any, selectedSecuitries?: BasicSelectOption[] }): TierClass[] {
    let newList: any[] = [...PSesssions];
    newList = newList.map((item: DMSessionsResult) => { //PermsLicList not getting same as class
        const MARGIN_TILES = JSON.parse(item.TiersJson || "[]");
        const ACC_SECTYPES_LIST: AccSecTypeClass[] = !isAccountExp ? [] : ReturnAccSecTypesList(MARGIN_TILES || [], selectedSecuitries || []);
        return {
            SessionID: item.SessionID,
            FromDay: +(item.FromDay),
            ToDay: +(item.ToDay),
            FromHour: +(item.FromHour),
            ToHour: +(item.ToHour),
            FromMinute: +(item.FromMinute),
            ToMinute: +(item.ToMinute),
            MarginTiers: isAccountExp ? ReturnMarginTiersWithTitles(ACC_SECTYPES_LIST || [], SecurityTypeDict || {}) : item.Tiers,
            MarginTiles: MARGIN_TILES,
            levels: MARGIN_TILES?.length || 0,
            isEdit: true,
        };
    })
    return newList;
}
export function ReturnSymbolMarginTiersData(item: TierClass) { // no need  for casting //as JSON Tiers is enough 
    let _list: IMarginTiles[] = [];
    const LIST_TITLES: any[] = item.MarginTiers ? item.MarginTiers.split(';') : [];
    let _levels: number = LIST_TITLES.length ? LIST_TITLES.length - 1 : 0;
    item.levels = `${_levels}`;
    for (let i: number = 0; i < +(LIST_TITLES.length); i++) {
        if (!!LIST_TITLES?.[i]) {
            let _value: any = LIST_TITLES[i];
            _value = _value.split('=');
            const ELEMENT = _value[1]?.split(':');
            _list.push({ level: `${i}`, Leverage: ELEMENT[1], Trenches: ELEMENT[0] });
        }
    }
    item.MarginTiles = _list;

    return { MarginTiles: _list, levels: `${_levels}` };
}
export function ReturnTimeDisplay(Time: any) {
    if (!Time || +(Time) < 0) return "00";
    if (`${Time}`.length < 2) return `0${Time}`;
    return Time;
}
//#endregion

//#region bonus Excluded Account Types 
export function CheckIfCommaSeparatedList(text: string) {
    if (!text) return false;
    if (text === "*") return true;
    if (text.startsWith(" ") || text.endsWith(" ")) return false;
    const SPLITED_LIST = text.split(',');
    for (let str of SPLITED_LIST) {
        if (!str) return false;
        if (str.startsWith(" ") || str.endsWith(" ")) return false;
    }
    return true;
}
//#endregion
export function ReturnCountriesOptionByTranslatedLabel(label: any, list: any[], t: Function) {
    if (!list || list.length === 0) return { value: -1, label: "No Data" };
    for (let i: number = 0; i < list.length; i++) {
        if (String(t(label))?.toLowerCase() === String(t(list[i]?.CountryCode ? ReturnCountryCode(list[i]?.CountryCode) : list[i].CountryName))?.toLowerCase())
            return list[i];
    }
    return { value: -1, label: "Select" };
}

//#region EasyWire
export const BANK_NAME_EASYWIRE = [
    { label: "FNB", value: "FNB" },
    { label: "ABSA", value: "ABSA" },
    { label: "Standard", value: "Standard" },
    { label: "Nedbank", value: "Nedbank" },
    { label: "Capitec", value: "Capitec" },
    { label: "Investec", value: "Investec" },
    { label: "Mercantile", value: "Mercantile" },
    { label: "Bidvest", value: "Bidvest" },
    { label: "Tyme", value: "Tyme" },
    { label: "Windhoek", value: "Windhoek" },
    { label: "Afribank", value: "Afribank" },
    { label: "Oldmutual", value: "Oldmutual" },
    { label: "Discovery", value: "Discovery" },
    { label: "Grindrod", value: "Grindrod" },
    { label: "Ubank", value: "Ubank" },
    { label: "Imperial", value: "Imperial" },
    { label: "Firstrand", value: "Firstrand" },
    { label: "Hsbc", value: "Hsbc" },
    { label: "Sasfin", value: "Sasfin" },
    { label: "Access", value: "Access" },
];
export const ACCOUNT_TYPES_EASYWIRE = [
    { value: "cheque", label: "cheque" },
    { value: "savings", label: "savings" },
    { value: "transmission", label: "transmission" },
];
export const BANKING_BRANCHS_EASYWIRE = [
    { label: "FNB", value: "250655" },
    { label: "ABSA", value: "632005" },
    { label: "Standard", value: "051001" },
    { label: "Nedbank", value: "198765" },
    { label: "Capitec", value: "470010" },
    { label: "Investec", value: "580105" },
    { label: "Mercantile", value: "450105" },
    { label: "Bidvest", value: "462005" },
    { label: "Tyme", value: "678910" },
    { label: "Windhoek", value: "483872" },
    { label: "Afribank", value: "430000" },
    { label: "Oldmutual", value: "462005" },
    { label: "Discovery", value: "679000" },
    { label: "Grindrod", value: "584000" },
    { label: "Ubank", value: "431010" },
    { label: "Imperial", value: "39001" },
    { label: "Firstrand", value: "201419" },
    { label: "Hsbc", value: "587000" },
    { label: "Sasfin", value: "683000" },
    { label: "Access", value: "410506" }
];
//#endregion
//#region reports
export function GetDayPriorBy(days: number): Date {
    try {
        const _date = new Date();
        _date.setDate(new Date().getDate() - days);
        return _date;
    } catch (e) {
        console.error('GET_DAY_PRIOR_BY', e);
        return new Date()
    }
}

export function ReturnTotalRounded(value: any) {
    const fix = (num: any) => Number(//
        num?.toFixed(2)?.match(/\d+(?:\.\d+)?/)?.[0]
    ).toFixed(2);
    if (value === 0) return value;
    if (!!value) return value > 0 ? fix(+value) : `-${fix(+value)}`;
    return "0.00";
}

export function GetDayPostBy(days: number): Date {
    try {
        const _date = new Date();
        _date.setDate(new Date().getDate() + days);
        return _date;
    } catch (e) {
        console.error('GET_DAY_PRIOR_BY', e);
        return new Date()
    }
}
//#endregion
export function ReturnDateBeforeYears(min: number) {
    let YearsAgo = new Date();
    YearsAgo.setFullYear(YearsAgo.getFullYear() - min);
    //return new Date( YearsAgo, 1, 1, 0, 0, 0); will check year with wrong values 
    YearsAgo.setHours(0);
    YearsAgo.setMinutes(0);
    YearsAgo.setSeconds(0);
    return YearsAgo;
}
export const ZahaPayBank = [
    { value: "-1", label: "-- Select Your Bank --" },
    { value: "BBL", label: "Bangkok Bank (BBL)" },
    { value: "KBANK", label: "Kasikorn Bank (KBANK)" },
    { value: "KTB", label: "Krung Thai Bank (KTB)" },
    { value: "TTB", label: "TMB & Tanachat Bank (TTB)" },
    { value: "SCB", label: "Siam Commercial Bank (SCB)" },
    { value: "CIMBT", label: "CIMB Thai Bank (CIMBT)" },
    { value: "UOBT", label: "United Overseas Bank (Thai) (UOBT)" },
    { value: "BAY", label: "Bank of Ayudhya (KrungSri) (BAY)" },
    { value: "GSB", label: "Goverment Savings Bank (GSB)" },
    { value: "GHB", label: "Goverment Housing Bank (GHB)" },
    { value: "BAAC", label: "Bank for Agriculture and Agricultural Cooperatives (BAAC)" },
];
export const ZahaPayBankDict: any = {
    "-1": "None",
    "BBL": "Bangkok Bank (BBL)",
    "KBANK": "Kasikorn Bank (KBANK)",
    "KTB": "Krung Thai Bank (KTB)",
    "TTB": "TMB & Tanachat Bank (TTB)",
    "SCB": "Siam Commercial Bank (SCB)",
    "CIMBT": "CIMB Thai Bank (CIMBT)",
    "UOBT": "United Overseas Bank (Thai) (UOBT)",
    "BAY": "Bank of Ayudhya (KrungSri) (BAY)",
    "GSB": "Goverment Savings Bank (GSB)",
    "GHB": "Goverment Housing Bank (GHB)",
    "BAAC": "Bank for Agriculture and Agricultural Cooperatives (BAAC)"
};
export const DusuPayMobileMoneyWorks = [
    { value: "-1", label: "-- Select Your Bank --" },
    { value: "KE", label: "Kenya" },
    { value: "TZ", label: "Tanzania" },
    { value: "RW", label: "Rwanda" },
    { value: "BI", label: "Burundi" },
    { value: "GH", label: "Ghana" },
    { value: "UG", label: "Uganda" },
    { value: "CM", label: "Cameroon" },
    { value: "ZM", label: "Zambia" },
];
export const DusuPayBankWorks = [
    { value: "-1", label: "-- Select Your Bank --" },
    { value: "ZA", label: "South Africa" },
    { value: "NG", label: "Nigeria" },
];
export const DusuPayPaymentTypes = [
    { value: "Bank", label: "Bank" },
    { value: "MobileMoney", label: "Mobile Money" },
];
export const CashUSDT = require("../../src/Assets/imgs/CashUSDT.png") as string;
export const SurepayCountries = [
    { value: "Malaysia", label: "Malaysia" },
    { value: "Singapore", label: "Singapore" },
    { value: "Thailand", label: "Thailand" },
    { value: "Vietnam", label: "Vietnam" },
    { value: "Indonesia", label: "Indonesia" },
    { value: "Cambodia", label: "Cambodia" }];
export const SurepayBankCode = [
    { value: "MAYBANK", Type: "DP", label: "Maybank", Country: "Malaysia" },
    { value: "CIMB", Type: "DP", label: "CIMB Group Holdings", Country: "Malaysia" },
    { value: "PBE", Type: "DP", label: "Public Bank Berhad", Country: "Malaysia" },
    { value: "RHB", Type: "DP", label: "RHB Bank", Country: "Malaysia" },
    { value: "HLB", Type: "DP", label: "Hong Leong Bank", Country: "Malaysia" },
    { value: "BSN", Type: "DP", label: "Bank Simpanan Nasional", Country: "Malaysia" },
    { value: "AFFIN", Type: "DP", label: "Affin Bank", Country: "Malaysia" },
    { value: "AMBANK", Type: "DP", label: "AmBank", Country: "Malaysia" },
    { value: "BKRM", Type: "DP", label: "Bank Rakyat Malaysia", Country: "Malaysia" },
    { value: "ALLIANCE", Type: "DP", label: "Alliance Bank MalaysiaBerhad", Country: "Malaysia" },
    { value: "BIMB", Type: "DP", label: "Bank Islam Berhad", Country: "Malaysia" },
    { value: "BMMB", Type: "P", label: "Bank Muamalat", Country: "Malaysia" },
    { value: "AGRO", Type: "P", label: "Bank of Agro", Country: "Malaysia" },
    { value: "HSBC", Type: "P", label: "HongKong And Shanghai Bank", Country: "Malaysia" },
    { value: "UOB", Type: "P", label: "United Overseas Bank", Country: "Malaysia" },
    { value: "OCBC", Type: "P", label: "Oversea-Chinese Banking Corporation", Country: "Malaysia" },

    { value: "DBS", Type: "DP", label: "DBS Bank Limited", Country: "Singapore" },
    { value: "UOB", Type: "DP", label: "United Overseas Bank Limited", Country: "Singapore" },
    { value: "OCBC", Type: "DP", label: "OCBC Bank", Country: "Singapore" },
    { value: "ANZ", Type: "P", label: "Australia And New Zealand Bank (Australia)", Country: "Singapore" },
    { value: "BKCH", Type: "P", label: "Bank Of China", Country: "Singapore" },
    { value: "BNPASG", Type: "P", label: "BNP Paribas", Country: "Singapore" },
    { value: "CIMBSG", Type: "P", label: "CIMB", Country: "Singapore" },
    { value: "CITISG", Type: "P", label: "Citibank Singapore", Country: "Singapore" },
    { value: "DBK", Type: "P", label: "Deutsche Bank AG", Country: "Singapore" },
    { value: "GPAY", Type: "P", label: "GPAY", Country: "Singapore" },
    { value: "HLBBSG", Type: "P", label: "HLB Singapore", Country: "Singapore" },
    { value: "HSBCCORP", Type: "P", label: "HSBC Coorperation", Country: "Singapore" },
    { value: "HSBC", Type: "P", label: "HSBC Singapore - Personal", Country: "Singapore" },
    { value: "ICICIB", Type: "P", label: "ICICI Bank", Country: "Singapore" },
    { value: "ICBKSG", Type: "P", label: "Industrial and Commercial Bank", Country: "Singapore" },
    { value: "JPM", Type: "P", label: "Jpmorgan Chase Bank", Country: "Singapore" },
    { value: "LIQPAY", Type: "P", label: "Liquid Pay", Country: "Singapore" },
    { value: "MBBGB", Type: "P", label: "Malayan Banking Berhad, Singapore Branch", Country: "Singapore" },
    { value: "MMOVEPAY", Type: "P", label: "Match Move Pay", Country: "Singapore" },
    { value: "MBBE", Type: "P", label: "Maybank Singapore (maybank)", Country: "Singapore" },
    { value: "MHCBSG", Type: "P", label: "Mizuho Bank Singapore", Country: "Singapore" },
    { value: "SIVFSG", Type: "P", label: "Singapore Investments & Finance Limited", Country: "Singapore" },
    { value: "SINGCASH", Type: "P", label: "Sing Cash", Country: "Singapore" },
    { value: "SCBLSG", Type: "P", label: "Standard Chartered Bank Singapore", Country: "Singapore" },
    { value: "SMBCSG", Type: "P", label: "Sumitomo Mitsui", Country: "Singapore" },
    { value: "BOTKSG", Type: "P", label: "The Bank Of Tokyo-Mitsubishi", Country: "Singapore" },
    { value: "WISE", Type: "P", label: "Wise Asia Pacific", Country: "Singapore" },

    { value: "PROMPTPAY", Type: "P", label: "PROMPTPAY", Country: "Thailand" },
    { value: "KBANK", Type: "P", label: "KASIKORNBANK", Country: "Thailand" },
    { value: "KTB", Type: "P", label: "KRUNGTHAIBANKPUBLICCOMPANYLTD.", Country: "Thailand" },
    { value: "BBL", Type: "P", label: "BANGKOKBANKPUBLICCOMPANYLTD.", Country: "Thailand" },
    { value: "SCB", Type: "P", label: "SiamCommercialBank", Country: "Thailand" },
    { value: "BAAC", Type: "P", label: "BANKFORAGRICULTUREANDAGRICULTURALCO-OPERATIVES (AGRI)", Country: "Thailand" },
    { value: "BOC", Type: "P", label: "BankofChina(Thai)PublicCompanyLimited", Country: "Thailand" },
    { value: "CITI", Type: "P", label: "CITIBANKN.A.", Country: "Thailand" },
    { value: "CIMBTH", Type: "P", label: "CIMBTHAIBANKPUBLICCOMPANYLIMITED", Country: "Thailand" },
    { value: "GHB", Type: "P", label: "GOVERNMENTHOUSINGBANK", Country: "Thailand" },
    { value: "MHCB", Type: "P", label: "MIZUHOCORPORATEBANK,LTD.", Country: "Thailand" },
    { value: "KKB", Type: "P", label: "KIATNAKINBANKPUBLICCOMPANYLIMITED", Country: "Thailand" },
    { value: "TISCO", Type: "P", label: "TISCOBANKPUBLICCOMPANYLIMITED", Country: "Thailand" },
    { value: "GSB", Type: "P", label: "GOVERNMENTSAVINGBANK", Country: "Thailand" },
    { value: "TMB", Type: "P", label: "TMBThanachartBankPublicCompanyLimited", Country: "Thailand" },
    { value: "SCBT", Type: "P", label: "STANDARDCHARTEREDBANK(THAI)PCL.", Country: "Thailand" },
    { value: "TCRB", Type: "P", label: "THETHAICREDITRETAILBANKPUBLICCOMPANYLIMITED(TCRB)", Country: "Thailand" },
    { value: "SMBC", Type: "P", label: "SUMITOMOMITSUIBANGKINGCORPORATION", Country: "Thailand" },
    { value: "LHBA", Type: "P", label: "LandandHousesBankPublicCompanyLimited", Country: "Thailand" },
    { value: "TIBT", Type: "P", label: "ISLAMICBANKOFTHAILAND", Country: "Thailand" },
    { value: "HSBCTH", Type: "P", label: "HONGKONGANDSHANGHAICORPORATIONLTD.", Country: "Thailand" },
    { value: "DBTH", Type: "P", label: "DEUTSCHEBANKAG,BANGKOKBRANCH", Country: "Thailand" },
    { value: "ICBC", Type: "P", label: "IndustrialandCommercialBankofChina(Thai)Public CompanyLimited", Country: "Thailand" },
    { value: "UOBTH", Type: "P", label: "UNITEDOVERSEASBANK(THAI)PCL.", Country: "Thailand" },
    { value: "BAY", Type: "P", label: "BANKOFAYUDHAYAPUBLICCOMPANYLTD.", Country: "Thailand" },

    { value: "VIETCOM", Type: "DP", label: "Vietcom Bank", Country: "Vietnam" },
    { value: "SACOM", Type: "DP", label: "Sacom Bank", Country: "Vietnam" },
    { value: "TECHCOM", Type: "DP", label: "Techcom Bank", Country: "Vietnam" },
    { value: "VIETIN", Type: "DP", label: "Vietin Bank", Country: "Vietnam" },
    { value: "BIDV", Type: "DP", label: "Bank for Investment and Development of Vietnam", Country: "Vietnam" },

    { value: "BMR", Type: "P", label: "Bank Mandiri", Country: "Indonesia" },
    { value: "BRI", Type: "P", label: "Bank Rakyat Indonesia", Country: "Indonesia" },
    { value: "BCA", Type: "P", label: "Bank Central Asia", Country: "Indonesia" },
    { value: "BNI", Type: "P", label: "Bank Negara Indonesia", Country: "Indonesia" },

    { value: "ACLEDA", Type: "p", label: "ACLEDA Bank", Country: "Cambodia" },
    { value: "CNDBANK", Type: "p", label: "Canadia Bank", Country: "Cambodia" },
    { value: "FTB", Type: "p", label: "The Foreign Trade Bank of Cambodia", Country: "Cambodia" },
    { value: "UCB", Type: "p", label: "Union Commercial Bank", Country: "Cambodia" },
    { value: "JTRUST", Type: "p", label: "Trust Royal Bank", Country: "Cambodia" },
];
export const SurepayBankCodeDict: any = {
    "MAYBANK": { Type: "DP", label: "Maybank", Country: "Malaysia" },
    "CIMB": { Type: "DP", label: "CIMB Group Holdings", Country: "Malaysia" },
    "PBE": { Type: "DP", label: "Public Bank Berhad", Country: "Malaysia" },
    "RHB": { Type: "DP", label: "RHB Bank", Country: "Malaysia" },
    "HLB": { Type: "DP", label: "Hong Leong Bank", Country: "Malaysia" },
    "BSN": { Type: "DP", label: "Bank Simpanan Nasional", Country: "Malaysia" },
    "AFFIN": { Type: "DP", label: "Affin Bank", Country: "Malaysia" },
    "AMBANK": { Type: "DP", label: "AmBank", Country: "Malaysia" },
    "BKRM": { Type: "DP", label: "Bank Rakyat Malaysia", Country: "Malaysia" },
    "ALLIANCE": { Type: "DP", label: "Alliance Bank MalaysiaBerhad", Country: "Malaysia" },
    "BIMB": { Type: "DP", label: "Bank Islam Berhad", Country: "Malaysia" },
    "BMMB": { Type: "P", label: "Bank Muamalat", Country: "Malaysia" },
    "AGRO": { Type: "P", label: "Bank of Agro", Country: "Malaysia" },
    "HSBC": { Type: "P", label: "HongKong And Shanghai Bank", Country: "Malaysia" },
    "UOB": { Type: "P", label: "United Overseas Bank", Country: "Malaysia" },
    "OCBC": { Type: "P", label: "Oversea-Chinese Banking Corporation", Country: "Malaysia" },

    "DBS": { Type: "DP", label: "DBS Bank Limited", Country: "Singapore" },
    //"UOB": { Type: "DP", label: "United Overseas Bank Limited", Country: "Singapore" },
    //"OCBC": { Type: "DP", label: "OCBC Bank", Country: "Singapore" },
    "ANZ": { Type: "P", label: "Australia And New Zealand Bank (Australia)", Country: "Singapore" },
    "BKCH": { Type: "P", label: "Bank Of China", Country: "Singapore" },
    "BNPASG": { Type: "P", label: "BNP Paribas", Country: "Singapore" },
    "CIMBSG": { Type: "P", label: "CIMB", Country: "Singapore" },
    "CITISG": { Type: "P", label: "Citibank Singapore", Country: "Singapore" },
    "DBK": { Type: "P", label: "Deutsche Bank AG", Country: "Singapore" },
    "GPAY": { Type: "P", label: "GPAY", Country: "Singapore" },
    "HLBBSG": { Type: "P", label: "HLB Singapore", Country: "Singapore" },
    "HSBCCORP": { Type: "P", label: "HSBC Coorperation", Country: "Singapore" },
    "HSBCSingapore": { Type: "P", label: "HSBC Singapore - Personal", Country: "Singapore" },
    "ICICIB": { Type: "P", label: "ICICI Bank", Country: "Singapore" },
    "ICBKSG": { Type: "P", label: "Industrial and Commercial Bank", Country: "Singapore" },
    "JPM": { Type: "P", label: "Jpmorgan Chase Bank", Country: "Singapore" },
    "LIQPAY": { Type: "P", label: "Liquid Pay", Country: "Singapore" },
    "MBBGB": { Type: "P", label: "Malayan Banking Berhad, Singapore Branch", Country: "Singapore" },
    "MMOVEPAY": { Type: "P", label: "Match Move Pay", Country: "Singapore" },
    "MBBE": { Type: "P", label: "Maybank Singapore (maybank)", Country: "Singapore" },
    "MHCBSG": { Type: "P", label: "Mizuho Bank Singapore", Country: "Singapore" },
    "SIVFSG": { Type: "P", label: "Singapore Investments & Finance Limited", Country: "Singapore" },
    "SINGCASH": { Type: "P", label: "Sing Cash", Country: "Singapore" },
    "SCBLSG": { Type: "P", label: "Standard Chartered Bank Singapore", Country: "Singapore" },
    "SMBCSG": { Type: "P", label: "Sumitomo Mitsui", Country: "Singapore" },
    "BOTKSG": { Type: "P", label: "The Bank Of Tokyo-Mitsubishi", Country: "Singapore" },
    "WISE": { Type: "P", label: "Wise Asia Pacific", Country: "Singapore" },

    "PROMPTPAY": { Type: "P", label: "PROMPTPAY", Country: "Thailand" },
    "KBANK": { Type: "P", label: "KASIKORNBANK", Country: "Thailand" },
    "KTB": { Type: "P", label: "KRUNGTHAIBANKPUBLICCOMPANYLTD.", Country: "Thailand" },
    "BBL": { Type: "P", label: "BANGKOKBANKPUBLICCOMPANYLTD.", Country: "Thailand" },
    "SCB": { Type: "P", label: "SiamCommercialBank", Country: "Thailand" },
    "BAAC": { Type: "P", label: "BANKFORAGRICULTUREANDAGRICULTURALCO-OPERATIVES (AGRI)", Country: "Thailand" },
    "BOC": { Type: "P", label: "BankofChina(Thai)PublicCompanyLimited", Country: "Thailand" },
    "CITI": { Type: "P", label: "CITIBANKN.A.", Country: "Thailand" },
    "CIMBTH": { Type: "P", label: "CIMBTHAIBANKPUBLICCOMPANYLIMITED", Country: "Thailand" },
    "GHB": { Type: "P", label: "GOVERNMENTHOUSINGBANK", Country: "Thailand" },
    "MHCB": { Type: "P", label: "MIZUHOCORPORATEBANK,LTD.", Country: "Thailand" },
    "KKB": { Type: "P", label: "KIATNAKINBANKPUBLICCOMPANYLIMITED", Country: "Thailand" },
    "TISCO": { Type: "P", label: "TISCOBANKPUBLICCOMPANYLIMITED", Country: "Thailand" },
    "GSB": { Type: "P", label: "GOVERNMENTSAVINGBANK", Country: "Thailand" },
    "TMB": { Type: "P", label: "TMBThanachartBankPublicCompanyLimited", Country: "Thailand" },
    "SCBT": { Type: "P", label: "STANDARDCHARTEREDBANK(THAI)PCL.", Country: "Thailand" },
    "TCRB": { Type: "P", label: "THETHAICREDITRETAILBANKPUBLICCOMPANYLIMITED(TCRB)", Country: "Thailand" },
    "SMBC": { Type: "P", label: "SUMITOMOMITSUIBANGKINGCORPORATION", Country: "Thailand" },
    "LHBA": { Type: "P", label: "LandandHousesBankPublicCompanyLimited", Country: "Thailand" },
    "TIBT": { Type: "P", label: "ISLAMICBANKOFTHAILAND", Country: "Thailand" },
    "HSBCTH": { Type: "P", label: "HONGKONGANDSHANGHAICORPORATIONLTD.", Country: "Thailand" },
    "DBTH": { Type: "P", label: "DEUTSCHEBANKAG,BANGKOKBRANCH", Country: "Thailand" },
    "ICBC": { Type: "P", label: "IndustrialandCommercialBankofChina(Thai)Public CompanyLimited", Country: "Thailand" },
    "UOBTH": { Type: "P", label: "UNITEDOVERSEASBANK(THAI)PCL.", Country: "Thailand" },
    "BAY": { Type: "P", label: "BANKOFAYUDHAYAPUBLICCOMPANYLTD.", Country: "Thailand" },

    "VIETCOM": { Type: "DP", label: "Vietcom Bank", Country: "Vietnam" },
    "SACOM": { Type: "DP", label: "Sacom Bank", Country: "Vietnam" },
    "TECHCOM": { Type: "DP", label: "Techcom Bank", Country: "Vietnam" },
    "VIETIN": { Type: "DP", label: "Vietin Bank", Country: "Vietnam" },
    "BIDV": { Type: "DP", label: "Bank for Investment and Development of Vietnam", Country: "Vietnam" },

    "BMR": { Type: "P", label: "Bank Mandiri", Country: "Indonesia" },
    "BRI": { Type: "P", label: "Bank Rakyat Indonesia", Country: "Indonesia" },
    "BCA": { Type: "P", label: "Bank Central Asia", Country: "Indonesia" },
    "BNI": { Type: "P", label: "Bank Negara Indonesia", Country: "Indonesia" },

    "ACLEDA": { Type: "p", label: "ACLEDA Bank", Country: "Cambodia" },
    "CNDBANK": { Type: "p", label: "Canadia Bank", Country: "Cambodia" },
    "FTB": { Type: "p", label: "The Foreign Trade Bank of Cambodia", Country: "Cambodia" },
    "UCB": { Type: "p", label: "Union Commercial Bank", Country: "Cambodia" },
    "JTRUST": { Type: "p", label: "Trust Royal Bank", Country: "Cambodia" },
};
//#endregion

export function GenerateManagerPassword() {//8 characters
    let charset = "abcdefghijklmnopqrstuvwxyz",
        Captial = "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
        numeric = '0123456789',
        SpecialSet = "!@#$%^&",
        retVal = "";
    //for (var i = 0, n = SpecialSet.length; i < 5; ++i) {
    //    retVal += SpecialSet.charAt(Math.floor(Math.random() * n));
    //}
    for (var i = 0, n = charset.length; i < 4; ++i) {
        retVal += charset.charAt(Math.floor(Math.random() * n));
    }
    for (var i = 4, n = Captial.length; i < 6; ++i) {
        retVal += Captial.charAt(Math.floor(Math.random() * n));
    }
    for (var i = 6, n = numeric.length; i < 8; ++i) {
        retVal += numeric.charAt(Math.floor(Math.random() * n));
    }
    return retVal.split('').sort(() => Math.random() - 0.5).join(''); //return them shuffled 
}
//#region fast2pays
export const FAST2PAYS_DEPOSIT_TYPES = [
    { value: 'CARD', label: 'Card' },
    { value: 'BANK', label: 'Bank' }
];
export const FAST2PAYS_DEPOSIT_BANKCODE = [
    { value: 'VCB', label: 'Joint Stock Commercial Bank for Foreign Trade of Vietnam' },
    { value: 'TECHCOMBANK', label: 'Vietnam Technological and Commercial Joint Stock Bank' },
    { value: 'TPBANK', label: 'TienPhong Commercial Joint Stock Bank' },
    { value: 'VIETINBANK', label: 'Vietnam Joint Stock Commercial Bank of Industry and Trade' },
    { value: 'VIB', label: 'Vietnam International Commercial Joint Stock Bank' },
    { value: 'DAB', label: 'DONG A Commercial Joint Stock Bank' },
    { value: 'HDBANK', label: 'Ho Chi Minh city Development Joint Stock Commercial Bank' },
    { value: 'MB', label: 'Military Commercial Joint Stock Bank' },
    { value: 'VIETABANK', label: 'Vietnam Asia Commercial Joint' },
    { value: 'MARITIMEBANK', label: 'Vietnam Maritime Commercial Joint Stock Bank' },
    { value: 'EXIMBANK', label: 'Vietnam Export Import Commercial Joint Stock' },
    { value: 'SHB', label: 'Saigon-Hanoi Commercial Joint Stock Bank' },
    { value: 'VPBANK', label: 'Vietnam Prosperity Joint Stock Commercial Bank' },
    { value: 'ABBANK', label: 'An Binh Commercial Joint Stock Bank' },
    { value: 'SACOMBANK', label: 'Saigon Thuong Tin Commercial Joint Stock Bank' },
    { value: 'NAMA', label: 'Nam A Commercial Joint Stock Bank' },
    { value: 'OCEANBANK', label: 'Ocean Commercial One Member Limited Liability Bank' },
    { value: 'BIDV', label: 'Joint Stock Commercial Bank for Investment and Development of Vietnam' },
    { value: 'SEABANK', label: 'Southeast Asia Commercial Joint Stock Bank' },
    { value: 'BACA', label: 'BAC A Commercial Joint Stock Bank' },
    { value: 'NAVIBANK', label: 'NaviBank' },
    { value: 'AGRIBANK', label: 'Vietnam Bank for Agriculture and Rural Development' },
    { value: 'SAIGONBANK', label: 'Saigon Bank for Industry and Trade' },
    { value: 'PVBANK', label: 'Vietnam Public Joint Stock Commercial Bank' },
    { value: 'ACB', label: 'Asia Commercial Joint Stock Bank' },
    { value: 'LPB', label: 'Lien Viet Post Joint Stock Commercial Bank' },
    { value: 'BVBANK', label: 'Bao Viet Joint Stock commercial Bank' },
    { value: 'OCB', label: 'Orient Commercial Joint Stock Bank' },
    { value: 'KIENLONGBANK', label: 'Kien Long Commercial Joint Stock Bank' },
    { value: 'VRB', label: 'Vietnam Russia Joint Venture Bank' },
    { value: 'NCB', label: 'National Citizen Commercial Joint Stock Bank' },
    { value: 'PGBANK', label: 'Petrolimex Group Commercial Joint Stock Bank' },
    { value: 'GPBANK', label: 'Global Petro Sole Member Limited Commercial Bank' },
    { value: 'WOORIBANK', label: 'Woori Bank Vietnam Limited' },
    { value: 'VIETCAPITALBANK', label: 'Viet Capital Commercial Joint Stock Bank' },
    { value: 'PVBANK', label: 'PVcombank' },
    { value: 'BIDV', label: 'Joint Stock Commercial Bank for Investment and Development of Vietnam' },
    { value: 'VPBANK', label: 'Vietnam Prosperity Joint Stock Commercial Bank' },
    { value: 'TECHCOMBANK', label: 'Vietnam Technological and Commercial Joint Stock Bank' },
    { value: 'VISA', label: 'Visa' },
    { value: 'MASTERCARD', label: 'Mastercard' },
    { value: 'VCB', label: 'Joint Stock Commercial Bank for Foreign Trade of Vietnam' },
    { value: 'MOMO', label: 'Momo Wallet' },
    { value: 'TECHCOMBANK', label: 'Vietnam Technological and Commercial Joint Stock Bank' },
    { value: 'MB', label: 'Military Commercial Joint Stock Bank' },
    { value: 'VPBANK', label: 'Vietnam Prosperity Joint Stock Commercial Bank' },
    { value: 'BIDV', label: 'Joint Stock Commercial Bank for Investment and Development of Vietnam' },
    { value: 'SCARD_VT', label: 'THẺ VIETTEL' },
    { value: 'SCARD_Vina', label: 'THẺ VINAPHONE' },
    { value: 'SCARD_Mobi', label: 'THẺ MOBIFONE' },
    { value: 'SCARD_GTE', label: 'THẺ GATE' },
    { value: 'SCARD_ISEC', label: 'THẺ ISEC' },
    { value: 'USDT', label: 'Tether USDT' },
    { value: 'BUSD', label: 'Binance USD' },
    { value: 'USDC', label: 'USD Coin' },
];
export const FAST2PAYS_WITHDRAWAL_BANKCODE = [
    { value: 'VCB', label: 'Joint Stock Commercial Bank for Foreign Trade of Vietnam' },
    { value: 'TECHCOMBANK', label: 'Vietnam Technological and Commercial Joint Stock Bank' },
    { value: 'TPBANK', label: 'TienPhong Commercial Joint Stock Bank' },
    { value: 'VIETINBANK', label: 'Vietnam Joint Stock Commercial Bank of Industry and Trade' },
    { value: 'VIB', label: 'Vietnam International Commercial Joint Stock Bank' },
    { value: 'HDBANK', label: 'Ho Chi Minh city Development Joint Stock Commercial Bank' },
    { value: 'MB', label: 'Military Commercial Joint Stock Bank' },
    { value: 'VIETABANK', label: 'Vietnam Asia Commercial Joint' },
    { value: 'MARITIMEBANK', label: 'Vietnam Maritime Commercial Joint Stock Bank' },
    { value: 'EXIMBANK', label: 'Vietnam Export Import Commercial Joint Stock' },
    { value: 'SCB', label: 'Sai Gon Joint Stock Commercial Bank' },
    { value: 'VPBANK', label: 'Vietnam Prosperity Joint Stock Commercial Bank' },
    { value: 'ABBANK', label: 'An Binh Commercial Joint Stock Bank' },
    { value: 'SACOMBANK', label: 'Saigon Thuong Tin Commercial Joint Stock Bank' },
    { value: 'OCEANBANK', label: 'Ocean Commercial One Member Limited Liability Bank' },
    { value: 'BIDV', label: 'Joint Stock Commercial Bank for Investment and Development of Vietnam' },
    { value: 'SEABANK', label: 'Southeast Asia Commercial Joint Stock Bank' },
    { value: 'BACA', label: 'BAC A Commercial Joint Stock Bank' },
    { value: 'AGRIBANK', label: 'Vietnam Bank for Agriculture and Rural Development' },
    { value: 'SAIGONBANK', label: 'Saigon Bank for Industry and Trade' },
    { value: 'PVBANK', label: 'Vietnam Public Joint Stock Commercial Bank' },
    { value: 'ACB', label: 'Asia Commercial Joint Stock Bank' },
    { value: 'BVBANK', label: 'Bao Viet Joint Stock commercial Bank' },
    { value: 'GPBANK', label: 'Global Petro Sole Member Limited Commercial Bank' },
    { value: 'LPB', label: 'Lien Viet Post Joint Stock Commercial Bank' },
    { value: 'NCB', label: 'National Citizen Commercial Joint Stock Bank' },
    { value: 'HONGLEONG', label: 'Hong Leong Bank Vietnam Limited' },
    { value: 'PBVN', label: 'Public Bank Vietnam' },
    { value: 'OCB', label: 'Orient Commercial Joint Stock Bank' },
    { value: 'SHB', label: 'Saigon-Hanoi Commercial Joint Stock Bank' },
    { value: 'SHINHAN', label: 'Shinhan Bank Vietnam Limited' },
    { value: 'VIETBANK', label: 'Vietnam Thuong Tin Commercial Joint Stock Bank' },
    { value: 'VIETCAPITALBANK', label: 'Viet Capital Commercial Joint Stock Bank' },
    { value: 'KIENLONGBANK', label: 'Kien Long Commercial Joint Stock Bank' },
    { value: 'PGBANK', label: 'Petrolimex Group Commercial Joint Stock Bank' },
    { value: 'VRB', label: 'Vietnam Russia Joint Venture Bank' },
    { value: 'NAMABANK', label: 'Nam A Commercial Joint Stock Bank' },
    { value: 'IVB', label: 'Indovina Bank' },
    { value: 'WOORIBANK', label: 'Woori Bank Vietnam Limited' },
    { value: 'UOB', label: 'United Overseas Bank (Vietnam) Limited' },
    { value: 'COOPBANK', label: 'Co-operative Bank of Viet Nam' },
    { value: 'CIMB', label: 'CIMB Bank Vietnam Limited' },
    { value: 'IBK', label: 'Industrial Bank of Korea' },
    { value: 'DAB', label: 'DONG A Commercial Joint Stock Bank' },
];
export const FAST2PAYS_WITHDRAWAL_BANKCODE_DICTIONARY: any = {
    'VCB': 'Joint Stock Commercial Bank for Foreign Trade of Vietnam',
    'TECHCOMBANK': 'Vietnam Technological and Commercial Joint Stock Bank',
    'TPBANK': 'TienPhong Commercial Joint Stock Bank',
    'VIETINBANK': 'Vietnam Joint Stock Commercial Bank of Industry and Trade',
    'VIB': 'Vietnam International Commercial Joint Stock Bank',
    'HDBANK': 'Ho Chi Minh city Development Joint Stock Commercial Bank',
    'MB': 'Military Commercial Joint Stock Bank',
    'VIETABANK': 'Vietnam Asia Commercial Joint',
    'MARITIMEBANK': 'Vietnam Maritime Commercial Joint Stock Bank',
    'EXIMBANK': 'Vietnam Export Import Commercial Joint Stock',
    'SCB': 'Sai Gon Joint Stock Commercial Bank',
    'VPBANK': 'Vietnam Prosperity Joint Stock Commercial Bank',
    'ABBANK': 'An Binh Commercial Joint Stock Bank',
    'SACOMBANK': 'Saigon Thuong Tin Commercial Joint Stock Bank',
    'OCEANBANK': 'Ocean Commercial One Member Limited Liability Bank',
    'BIDV': 'Joint Stock Commercial Bank for Investment and Development of Vietnam',
    'SEABANK': 'Southeast Asia Commercial Joint Stock Bank',
    'BACA': 'BAC A Commercial Joint Stock Bank',
    'AGRIBANK': 'Vietnam Bank for Agriculture and Rural Development',
    'SAIGONBANK': 'Saigon Bank for Industry and Trade',
    'PVBANK': 'Vietnam Public Joint Stock Commercial Bank',
    'ACB': 'Asia Commercial Joint Stock Bank',
    'BVBANK': 'Bao Viet Joint Stock commercial Bank',
    'GPBANK': 'Global Petro Sole Member Limited Commercial Bank',
    'LPB': 'Lien Viet Post Joint Stock Commercial Bank',
    'NCB': 'National Citizen Commercial Joint Stock Bank',
    'HONGLEONG': 'Hong Leong Bank Vietnam Limited',
    'PBVN': 'Public Bank Vietnam',
    'OCB': 'Orient Commercial Joint Stock Bank',
    'SHB': 'Saigon-Hanoi Commercial Joint Stock Bank',
    'SHINHAN': 'Shinhan Bank Vietnam Limited',
    'VIETBANK': 'Vietnam Thuong Tin Commercial Joint Stock Bank',
    'VIETCAPITALBANK': 'Viet Capital Commercial Joint Stock Bank',
    'KIENLONGBANK': 'Kien Long Commercial Joint Stock Bank',
    'PGBANK': 'Petrolimex Group Commercial Joint Stock Bank',
    'VRB': 'Vietnam Russia Joint Venture Bank',
    'NAMABANK': 'Nam A Commercial Joint Stock Bank',
    'IVB': 'Indovina Bank',
    'WOORIBANK': 'Woori Bank Vietnam Limited',
    'UOB': 'United Overseas Bank (Vietnam) Limited',
    'COOPBANK': 'Co-operative Bank of Viet Nam',
    'CIMB': 'CIMB Bank Vietnam Limited',
    'IBK': 'Industrial Bank of Korea',
    'DAB': 'DONG A Commercial Joint Stock Bank',
};
export const FAST2PAYS_WITHDRAWAL_TYPES = [
    { value: 'CARD_NUMBER', label: 'Card' },
    { value: 'BANK_ACCOUNT', label: 'Bank' }
];
export const FAST2PAYS_WITHDRAWAL_TYPES_DICTIONARY: any = {
    'CARD_NUMBER': 'Card',
    'BANK_ACCOUNT': 'Bank'
};
export const FAST2PAYS_TRANSLATIONS: any = {
    "Joint Stock Commercial Bank for Foreign Trade of Vietnam": "Ngân hàng thương mại cổ phần Ngoại thương Việt Nam (VCB)",
    "Vietnam Technological and Commercial Joint Stock Bank": "Ngân hàng Kỹ Thương (Techcombank)",
    "TienPhong Commercial Joint Stock Bank": "Ngân hàng Tiên Phong (TPBank)",
    "Vietnam Joint Stock Commercial Bank of Industry and Trade": "Ngân hàng Công thương Việt Nam (VietinBank)",
    "Vietnam International Commercial Joint Stock Bank": "Ngân hàng Quốc Tế  (VIB)",
    "Ho Chi Minh city Development Joint Stock Commercial Bank": "Ngân hàng Phát triển TPHồ Chí Minh (HDBank)",
    "Military Commercial Joint Stock Bank": "Ngân hàng Quân Đội (MB)",
    "Vietnam Asia Commercial Joint": "Ngân hàng TMCP Việt Á (VAB)",
    "Vietnam Maritime Commercial Joint Stock Bank": "Ngân hàng TMCP Hàng Hải (MSB)",
    "Vietnam Export Import Commercial Joint Stock": "Ngân hàng Xuất Nhập Khẩu (Eximbank)",
    "Sai Gon Joint Stock Commercial Bank": "Ngân hàng Sài Gòn (SCB)",
    "Vietnam Prosperity Joint Stock Commercial Bank": "Ngân hàng TMCP Thịnh Vượng (VPBank)",
    "An Binh Commercial Joint Stock Bank": "Ngân hàng An Bình (ABBANK)",
    "Saigon Thuong Tin Commercial Joint Stock Bank": "Ngân hàng Sài Gòn Thương Tín (Sacombank)",
    "Ocean Commercial One Member Limited Liability Bank": "Ngân hàng Đại Dương (OceanBank)",
    "Joint Stock Commercial Bank for Investment and Development of Vietnam": "Ngân hàng Đầu tư và Phát triển Việt Nam (BIDV)",
    "Southeast Asia Commercial Joint Stock Bank": "Ngân hàng Đông Nam Á (SeABank)",
    "BAC A Commercial Joint Stock Bank": "Ngân hàng Bắc Á (Bac A Bank)",
    "Vietnam Bank for Agriculture and Rural Development": "Ngân hàng NN&PT Nông thôn Việt Nam (Agribank)",
    "Saigon Bank for Industry and Trade": "Ngân hàng Sài Gòn Công Thương (SAIGONBANK)",
    "Vietnam Public Joint Stock Commercial Bank": "Ngân hàng TMCP Đại chúng Việt Nam (PVCombank)",
    "Asia Commercial Joint Stock Bank": "Ngân hàng Á Châu (ACB)",
    "Bao Viet Joint Stock commercial Bank": "Ngân hàng Bảo Việt  (BAOVIET Bank)",
    "Global Petro Sole Member Limited Commercial Bank": "Ngân hàng Dầu khí toàn cầu  (GPBank)",
    "Lien Viet Post Joint Stock Commercial Bank": "Ngân hàng TMCP Liên Việt (LVB)",
    "National Citizen Commercial Joint Stock Bank": "Ngân hàng Thương mại Cổ phần Quốc Dân (NCB)",
    "Hong Leong Bank Vietnam Limited": "Ngân hàng Hong Leong Việt Nam (HLBVN)",
    "Public Vietnam Bank": "Ngân hàng Đại Chúng Việt Nam (PVcomBank)",
    "Orient Commercial Joint Stock Bank": "Ngân hàng Phương Đông (OCB)",
    "Saigon-Hanoi Commercial Joint Stock Bank": "Ngân hàng Sài Gòn – Hà Nội (SHB)",
    "Shinhan Bank Vietnam Limited": "Ngân hàng Shinhan Việt Nam (SHBVN)",
    "Vietnam Thuong Tin Commercial Joint Stock Bank": "Ngân hàng Việt Nam Thương Tín (Vietbank)",
    "Viet Capital Commercial Joint Stock Bank": "Ngân hàng Bản Việt (Viet Capital Bank)",
    "Kien Long Commercial Joint Stock Bank": "Ngân hàng Kiên Long (Kienlongbank)",
    "Petrolimex Group Commercial Joint Stock Bank": "Ngân hàng Xăng dầu Petrolimex (PG Bank)",
    "Vietnam Russia Joint Venture Bank": "Ngân hàng Việt – Nga (VRB)",
    "Nam A Commercial Joint Stock Bank": "Ngân hàng Nam Á (Nam A Bank)",
    "Indovina Bank": "Ngân hàng Indovina (IVB)",
    "Woori Bank Vietnam Limited": "Ngân hàng Woori Việt Nam (Woori)",
    "United Overseas Bank (Vietnam) Limited": "Ngân Hàng United Overseas (Uob)",
    "Co-operative bank of VietNam": "Ngân hàng Hợp tác xã Việt Nam  (Co-opBank)",
    "CIMB Bank Vietnam Limited": "Ngân hàng TNHH MTV CIMB Việt Nam",
    "Industrial Bank of Korea": "Ngân hàng Công nghiệp Hàn Quốc",
    "DONG A Commercial Joint Stock Bank": "Ngân hàng Đông Á (DongA Bank)"
};
export const NinePay_WITHDRAWAL_TYPES = [
    { value: 0, label: 'Account' },
    { value: 1, label: 'Card' }
];
export const NinePay_BANK_ACOUNTS = [
    {
        "No.": 1,
        "value": "9PAY",
        "BankName": "9Pay",
        "label": "9Pay"
    },
    {
        "No.": 2,
        "value": "ABBANK",
        "BankName": "ABBANK - NH An Binh",
        "label": "ABBANK - An Binh Commercial Joint Stock Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },

    {
        "No.": 3,
        "value": "ACB",
        "BankName": "ACB - NH A Chau",
        "label": "ACB - Asia Commercial Joint Stock Bank",
        "SupportToBankAccount": true
    },
    {
        "No.": 4,
        "value": "AGRIBANK",
        "BankName": "AGRIBANK - NH Nong Nghiep va PTNT VN",
        "label": "AGRIBANK - Vietnam Bank for Agriculture and Rural Development",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 5,
        "value": "BAB",
        "BankName": "BAB - NH Bac A",
        "label": "BAB - Bac A Commercial Joint Stock Bank",
        "SupportToBankAccount": true
    },
    {
        "No.": 6,
        "value": "BANVIET",
        "BankName": "BANVIET - VIETCAPITALBA NK - NH Ban Viet",
        "label": "BANVIET - Viet Capital Commercial Joint Stock Bank",
        "SupportToBankAccount": true
    },
    {
        "No.": 7,
        "value": "BAOVIETB ANK",
        "BankName": "BAOVIET BANK - NH Bao Viet",
        "label": "BAOVIET BANK - Bao Viet Joint Stock Commercial Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },

    {
        "No.": 8,
        "value": "BIDV",
        "BankName": "BIDV - NH Dau Tu va Phat Trien VN",
        "label": "BIDV - Bank for Investment and Development of Vietnam",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 9,
        "value": "CBBANK",
        "BankName": "CB BANK - NH Xay Dung VN",
        "label": "CB BANK - Vietnam Construction Bank",
        "SupportToATMCards": true
    },
    {
        "No.": 10,
        "value": "CIMB",
        "BankName": "CIMB - NH CIMB Bank",
        "label": "CIMB - CIMB Bank (Vietnam) Limited",
        "SupportToATMCards": true
    },
    {
        "No.": 11,
        "value": "DONGABA NK",
        "BankName": "DONGA BANK - NH Dong A",
        "label": "DONGA BANK - Dong A Commercial Joint Stock Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 12,
        "value": "EXIMBANK",
        "BankName": "EXIMBANK - NH Xuat Nhap Khau Dau Khi Toan Cau",
        "label": "EXIMBANK - Vietnam Export Import Commercial Joint - Stock Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 13,
        "value": "GPBANK",
        "BankName": "GP BANK - NH",
        "label": "GP BANK - Global Petro Bank Limited",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 14,
        "value": "HDBANK",
        "BankName": "HDBANK - NH Phat Trien Tp HCM",
        "label": "HDBANK - Ho Chi Minh City Development Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 15,
        "value": "HLB",
        "BankName": "HLB - NH Hongleong Bank",
        "label": "HLB - Hong Leong Bank Vietnam Limited",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 16,
        "value": "IVB",
        "BankName": "IVB - NH Indovina",
        "label": "IVB - Indovina Bank Ltd",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 17,
        "value": "KIENLONG BANK",
        "BankName": "KIENLONG BANK - NH Kien Long",
        "label": "KIENLONG BANK - Kien Long Commercial Joint Stock Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 18,
        "value": "LIENVIETP OSTBANK",
        "BankName": "LIENVIETPOSTB ANK - NH Buu Dien Lien Viet",
        "label": "LIENVIETPOSTBANK - Lien Viet Postal Commercial Joint Stock Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 19,
        "value": "MBBANK",
        "BankName": "MBBANK - NH Quan Doi",
        "label": "MBBANK - Military Commercial Joint Stock Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 20,
        "value": "MSB",
        "BankName": "MSB- NH Hang Hai",
        "label": "MSB- Vietnam Maritime Joint - Stock Commercial Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 21,
        "value": "NAMABAN K",
        "BankName": "NAMABANK - NH Nam A",
        "label": "NAMABANK - South East Asia Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 22,
        "value": "NAVIBANK",
        "BankName": "NAVI BANK - NH Nam Viet",
        "label": "NAVI BANK - Nam Viet Commercial Joint Stock Bank",
        "SupportToATMCards": true
    },
    {
        "No.": 23,
        "value": "NCB",
        "BankName": "NCB - NH Quốc Dân",
        "label": "NCB - National Citizen Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 24,
        "value": "OCB",
        "BankName": "OCB - NH Phuong Dong",
        "label": "OCB - Orient Commercial Joint Stock Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 25,
        "value": "OCEANBA NK",
        "BankName": "OCEANBANK - NH Dai Duong",
        "label": "OCEANBANK - Ocean Commercial One Member Limited Liability Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 26,
        "value": "PGBANK",
        "BankName": "PGBANK - NH Xang Dau Petrolimex",
        "label": "PGBANK - Petrolimex Commercial Joint Stock Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 27,
        "value": "PUBLICBA NK",
        "BankName": "PUBLIC BANK - NH MTV Public Viet Nam",
        "label": "PUBLIC BANK - Public Bank Vietnam Limited",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 28,
        "value": "PVCOMBA NK",
        "BankName": "PVCOMBANK - NH Dai Chung Viet Nam",
        "label": "PVCOMBANK - Vietnam Public Joint Stock Commercial Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 29,
        "value": "SACOMBA NK",
        "BankName": "SACOMBANK - NH Sai gon Thuong Tin",
        "label": "SACOMBANK - Sai Gon Thuong Tin Commercial Joint Stock Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 30,
        "value": "SAIGONBA NK",
        "BankName": "SAIGON BANK - NH Sai Gon Cong Thuong",
        "label": "SAIGON BANK - Saigon Bank for Industry and Trade",
        "SupportToBankAccount": true
    },
    {
        "No.": 31,
        "value": "SCB",
        "BankName": "SCB - NH Sai Gon",
        "label": "SCB - Sai Gon Commercial Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 32,
        "value": "SEABANK",
        "BankName": "SEABANK - NH Dong Nam A",
        "label": "SEABANK - Southeast Asia Commercial Joint Stock Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 33,
        "value": "SHB",
        "BankName": "SHB - NH Sai Gon Ha Noi",
        "label": "SHB - Saigon - Hanoi Commercial Joint Stock Bank",
        "SupportToBankAccount": true
    },
    {
        "No.": 34,
        "value": "SHINHANB ANK",
        "BankName": "SHINHAN BANK - NH Shinhan Bank",
        "label": "SHINHAN BANK - Shinhan Bank Vietnam Limited",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 35,
        "value": "STANDAR D CHARTER ED",
        "BankName": "Standard Chartered Viet Nam",
        "label": "Standard Chartered Viet Nam",
        "SupportToATMCards": true
    },
    {
        "No.": 36,
        "value": "TECHCOM BANK",
        "BankName": "TECHCOMBANK - NH Ky Thuong",
        "label": "TECHCOMBANK - VietNam Technological and Commercial Joint Stock Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 37,
        "value": "TPBANK",
        "BankName": "TPBANK - NH Tien Phong",
        "label": "TPBANK - TienPhong Commercial Joint Stock Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 38,
        "value": "UOB",
        "BankName": "UOB - NH UOB Viet Nam",
        "label": "UOB - United Overseas Bank Vietnam Limited",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 39,
        "value": "VBSP",
        "BankName": "VBSP - NH Chinh Sach Xa Hoi",
        "label": "VBSP - Vietnam Bank for Social Policies",
        "SupportToATMCards": true
    },
    {
        "No.": 40,
        "value": "VDB",
        "BankName": "VDB - NH Phat Trien Viet Nam",
        "label": "VDB - Vietnam Development Bank",
        "SupportToATMCards": true
    },
    {
        "No.": 41,
        "value": "VIB",
        "BankName": "VIB - NH Quoc Te",
        "label": "VIB - Vietnam International and Commercial Joint Stock Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 42,
        "value": "VIETABAN K",
        "BankName": "VIETABANK - NH Viet A",
        "label": "VIETABANK - Viet A Commercial Joint Stock Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 43,
        "value": "VIETBANK",
        "BankName": "VIET BANK - NH Viet Nam Thuong Tin",
        "label": "VIET BANK - Vietnam Thuong Tin Commercial Joint Stock Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 44,
        "value": "VIETCOMB ANK",
        "BankName": "VIETCOMBANK - NH Ngoai Thuong Viet Nam",
        "label": "VIETCOMBANK - Bank for Foreign Trade of Vietnam",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 45,
        "value": "VIETINBAN K",
        "BankName": "VIETINBANK - NH Cong Thuong VN",
        "label": "VIETINBANK - Vietnam Joint Stock Commercial Bank for Industry and Trade",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 46,
        "value": "VINASIAM",
        "BankName": "VINASIAM - NH Lien Doanh Viet Thai",
        "label": "VINASIAM - VinaSiam Bank",
        "SupportToATMCards": true
    },
    {
        "No.": 47,
        "value": "VPBANK",
        "BankName": "VPBANK - NH Viet Nam Thinh Vuong",
        "label": "VPBANK - Vietnam Prosperity Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 48,
        "value": "VRB",
        "BankName": "VRB - NH Lien Doanh Viet Nga",
        "label": "VRB - Vietnam Russia Joint Venture Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    {
        "No.": 49,
        "value": "WOORIBA NK",
        "BankName": "WOORI BANK - NH Woori",
        "label": "WOORI BANK - Woori Bank Vietnam Limited",
        "SupportToBankAccount": true
    }
];
export const NINEPAY_WITHDRAWAL_BANKCODE_DICTIONARY: any = {
    "9PAY": {
        "No.": 1,
        "value": "9PAY",
        "BankName": "9Pay",
        "label": "9Pay"
    },
    "ABBANK": {
        "No.": 2,
        "value": "ABBANK",
        "BankName": "ABBANK - NH An Binh",
        "label": "ABBANK - An Binh Commercial Joint Stock Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "ACB": {
        "No.": 3,
        "value": "ACB",
        "BankName": "ACB - NH A Chau",
        "label": "ACB - Asia Commercial Joint Stock Bank",
        "SupportToBankAccount": true
    },
    "AGRIBANK": {
        "No.": 4,
        "value": "AGRIBANK",
        "BankName": "AGRIBANK - NH Nong Nghiep va PTNT VN",
        "label": "AGRIBANK - Vietnam Bank for Agriculture and Rural Development",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "BAB": {
        "No.": 5,
        "value": "BAB",
        "BankName": "BAB - NH Bac A",
        "label": "BAB - Bac A Commercial Joint Stock Bank",
        "SupportToBankAccount": true
    },
    "BANVIET": {
        "No.": 6,
        "value": "BANVIET",
        "BankName": "BANVIET - VIETCAPITALBA NK - NH Ban Viet",
        "label": "BANVIET - Viet Capital Commercial Joint Stock Bank",
        "SupportToBankAccount": true
    },
    "BAOVIETB ANK": {
        "No.": 7,
        "value": "BAOVIETB ANK",
        "BankName": "BAOVIET BANK - NH Bao Viet",
        "label": "BAOVIET BANK - Bao Viet Joint Stock Commercial Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "BIDV": {
        "No.": 8,
        "value": "BIDV",
        "BankName": "BIDV - NH Dau Tu va Phat Trien VN",
        "label": "BIDV - Bank for Investment and Development of Vietnam",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "CBBANK": {
        "No.": 9,
        "value": "CBBANK",
        "BankName": "CB BANK - NH Xay Dung VN",
        "label": "CB BANK - Vietnam Construction Bank",
        "SupportToATMCards": true
    },
    "CIMB": {
        "No.": 10,
        "value": "CIMB",
        "BankName": "CIMB - NH CIMB Bank",
        "label": "CIMB - CIMB Bank (Vietnam) Limited",
        "SupportToATMCards": true
    },
    "DONGABA NK": {
        "No.": 11,
        "value": "DONGABA NK",
        "BankName": "DONGA BANK - NH Dong A",
        "label": "DONGA BANK - Dong A Commercial Joint Stock Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "EXIMBANK": {
        "No.": 12,
        "value": "EXIMBANK",
        "BankName": "EXIMBANK - NH Xuat Nhap Khau Dau Khi Toan Cau",
        "label": "EXIMBANK - Vietnam Export Import Commercial Joint - Stock Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "GPBANK": {
        "No.": 13,
        "value": "GPBANK",
        "BankName": "GP BANK - NH",
        "label": "GP BANK - Global Petro Bank Limited",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "HDBANK": {
        "No.": 14,
        "value": "HDBANK",
        "BankName": "HDBANK - NH Phat Trien Tp HCM",
        "label": "HDBANK - Ho Chi Minh City Development Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "HLB": {
        "No.": 15,
        "value": "HLB",
        "BankName": "HLB - NH Hongleong Bank",
        "label": "HLB - Hong Leong Bank Vietnam Limited",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "IVB": {
        "No.": 16,
        "value": "IVB",
        "BankName": "IVB - NH Indovina",
        "label": "IVB - Indovina Bank Ltd",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "KIENLONG BANK": {
        "No.": 17,
        "value": "KIENLONG BANK",
        "BankName": "KIENLONG BANK - NH Kien Long",
        "label": "KIENLONG BANK - Kien Long Commercial Joint Stock Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "LIENVIETP OSTBANK": {
        "No.": 18,
        "value": "LIENVIETP OSTBANK",
        "BankName": "LIENVIETPOSTB ANK - NH Buu Dien Lien Viet",
        "label": "LIENVIETPOSTBANK - Lien Viet Postal Commercial Joint Stock Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "MBBANK": {
        "No.": 19,
        "value": "MBBANK",
        "BankName": "MBBANK - NH Quan Doi",
        "label": "MBBANK - Military Commercial Joint Stock Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "MSB": {
        "No.": 20,
        "value": "MSB",
        "BankName": "MSB- NH Hang Hai",
        "label": "MSB- Vietnam Maritime Joint - Stock Commercial Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "NAMABAN K": {
        "No.": 21,
        "value": "NAMABAN K",
        "BankName": "NAMABANK - NH Nam A",
        "label": "NAMABANK - South East Asia Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "NAVIBANK": {
        "No.": 22,
        "value": "NAVIBANK",
        "BankName": "NAVI BANK - NH Nam Viet",
        "label": "NAVI BANK - Nam Viet Commercial Joint Stock Bank",
        "SupportToATMCards": true
    },
    "NCB": {
        "No.": 23,
        "value": "NCB",
        "BankName": "NCB - NH Quốc Dân",
        "label": "NCB - National Citizen Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "OCB": {
        "No.": 24,
        "value": "OCB",
        "BankName": "OCB - NH Phuong Dong",
        "label": "OCB - Orient Commercial Joint Stock Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "OCEANBA NK": {
        "No.": 25,
        "value": "OCEANBA NK",
        "BankName": "OCEANBANK - NH Dai Duong",
        "label": "OCEANBANK - Ocean Commercial One Member Limited Liability Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "PGBANK": {
        "No.": 26,
        "value": "PGBANK",
        "BankName": "PGBANK - NH Xang Dau Petrolimex",
        "label": "PGBANK - Petrolimex Commercial Joint Stock Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "PUBLICBA NK": {
        "No.": 27,
        "value": "PUBLICBA NK",
        "BankName": "PUBLIC BANK - NH MTV Public Viet Nam",
        "label": "PUBLIC BANK - Public Bank Vietnam Limited",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "PVCOMBA NK": {
        "No.": 28,
        "value": "PVCOMBA NK",
        "BankName": "PVCOMBANK - NH Dai Chung Viet Nam",
        "label": "PVCOMBANK - Vietnam Public Joint Stock Commercial Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "SACOMBA NK": {
        "No.": 29,
        "value": "SACOMBA NK",
        "BankName": "SACOMBANK - NH Sai gon Thuong Tin",
        "label": "SACOMBANK - Sai Gon Thuong Tin Commercial Joint Stock Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "SAIGONBA NK": {
        "No.": 30,
        "value": "SAIGONBA NK",
        "BankName": "SAIGON BANK - NH Sai Gon Cong Thuong",
        "label": "SAIGON BANK - Saigon Bank for Industry and Trade",
        "SupportToBankAccount": true
    },
    "SCB": {
        "No.": 31,
        "value": "SCB",
        "BankName": "SCB - NH Sai Gon",
        "label": "SCB - Sai Gon Commercial Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "SEABANK": {
        "No.": 32,
        "value": "SEABANK",
        "BankName": "SEABANK - NH Dong Nam A",
        "label": "SEABANK - Southeast Asia Commercial Joint Stock Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "SHB": {
        "No.": 33,
        "value": "SHB",
        "BankName": "SHB - NH Sai Gon Ha Noi",
        "label": "SHB - Saigon - Hanoi Commercial Joint Stock Bank",
        "SupportToBankAccount": true
    },
    "SHINHANB ANK": {
        "No.": 34,
        "value": "SHINHANB ANK",
        "BankName": "SHINHAN BANK - NH Shinhan Bank",
        "label": "SHINHAN BANK - Shinhan Bank Vietnam Limited",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "STANDAR D CHARTER ED": {
        "No.": 35,
        "value": "STANDAR D CHARTER ED",
        "BankName": "Standard Chartered Viet Nam",
        "label": "Standard Chartered Viet Nam",
        "SupportToATMCards": true
    },
    "TECHCOM BANK": {
        "No.": 36,
        "value": "TECHCOM BANK",
        "BankName": "TECHCOMBANK - NH Ky Thuong",
        "label": "TECHCOMBANK - VietNam Technological and Commercial Joint Stock Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "TPBANK": {
        "No.": 37,
        "value": "TPBANK",
        "BankName": "TPBANK - NH Tien Phong",
        "label": "TPBANK - TienPhong Commercial Joint Stock Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "UOB": {
        "No.": 38,
        "value": "UOB",
        "BankName": "UOB - NH UOB Viet Nam",
        "label": "UOB - United Overseas Bank Vietnam Limited",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "VBSP": {
        "No.": 39,
        "value": "VBSP",
        "BankName": "VBSP - NH Chinh Sach Xa Hoi",
        "label": "VBSP - Vietnam Bank for Social Policies",
        "SupportToATMCards": true
    },
    "VDB": {
        "No.": 40,
        "value": "VDB",
        "BankName": "VDB - NH Phat Trien Viet Nam",
        "label": "VDB - Vietnam Development Bank",
        "SupportToATMCards": true
    },
    "VIB": {
        "No.": 41,
        "value": "VIB",
        "BankName": "VIB - NH Quoc Te",
        "label": "VIB - Vietnam International and Commercial Joint Stock Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "VIETABAN K": {
        "No.": 42,
        "value": "VIETABAN K",
        "BankName": "VIETABANK - NH Viet A",
        "label": "VIETABANK - Viet A Commercial Joint Stock Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "VIETBANK": {
        "No.": 43,
        "value": "VIETBANK",
        "BankName": "VIET BANK - NH Viet Nam Thuong Tin",
        "label": "VIET BANK - Vietnam Thuong Tin Commercial Joint Stock Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "VIETCOMB ANK": {
        "No.": 44,
        "value": "VIETCOMB ANK",
        "BankName": "VIETCOMBANK - NH Ngoai Thuong Viet Nam",
        "label": "VIETCOMBANK - Bank for Foreign Trade of Vietnam",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "VIETINBAN K": {
        "No.": 45,
        "value": "VIETINBAN K",
        "BankName": "VIETINBANK - NH Cong Thuong VN",
        "label": "VIETINBANK - Vietnam Joint Stock Commercial Bank for Industry and Trade",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "VINASIAM": {
        "No.": 46,
        "value": "VINASIAM",
        "BankName": "VINASIAM - NH Lien Doanh Viet Thai",
        "label": "VINASIAM - VinaSiam Bank",
        "SupportToATMCards": true
    },
    "VPBANK": {
        "No.": 47,
        "value": "VPBANK",
        "BankName": "VPBANK - NH Viet Nam Thinh Vuong",
        "label": "VPBANK - Vietnam Prosperity Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "VRB": {
        "No.": 48,
        "value": "VRB",
        "BankName": "VRB - NH Lien Doanh Viet Nga",
        "label": "VRB - Vietnam Russia Joint Venture Bank",
        "SupportToATMCards": true,
        "SupportToBankAccount": true
    },
    "WOORIBA NK": {
        "No.": 49,
        "value": "WOORIBA NK",
        "BankName": "WOORI BANK - NH Woori",
        "label": "WOORI BANK - Woori Bank Vietnam Limited",
        "SupportToBankAccount": true
    }
};
//#endregion
//#region PDF
export function downloadPDF(pdf: string, fileName: string) {
    const linkSource = `data:application/pdf;base64,${pdf}`;
    const downloadLink = document.createElement("a");
    const FileName = `${fileName}.pdf`;
    downloadLink.href = linkSource;
    downloadLink.download = FileName;
    downloadLink.click();
}
export const XLTrades_Secure_Client_Area_Payment_Details = `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`;
//#region Match2Pay
export const MATCH2PAY_NETWORKS = [
    { value: "Bitcoin", label: "Bitcoin - BTC" },
    { value: "Ethereum", label: "Ethereum (ERC-20)" },
    { value: "BinanceSmartChain", label: "Binance Smart Chain (BEP-20)" },
    { value: "TRON", label: "TRON (TRC-20)" },
];

export const MATCH2PAY_CRYPTO_CURRENCY = [
    { value: "Tether - USDT ERC20 - UST", label: "Tether - USDT ERC20 - UST", parent: "Ethereum", paymentCurrency: "UST", paymentGatewayName: "USDT ERC20" },
    { value: "USD Coin - USDC ERC20 - UCC", label: "USD Coin - USDC ERC20 - UCC", parent: "Ethereum", paymentCurrency: "UCC", paymentGatewayName: "USDC ERC20" },
    { value: "Ether - ETH", label: "Ether - ETH", parent: "Ethereum", paymentCurrency: "ETH", paymentGatewayName: "ETH" },

    { value: "Tether - USDT BEP20 - USB", label: "Tether - USDT BEP20 - USB", parent: "BinanceSmartChain", paymentCurrency: "USB", paymentGatewayName: "USDT BEP20" },
    { value: "USD Coin - USDC BEP20 - USB", label: "USD Coin - USDC BEP20 - USB", parent: "BinanceSmartChain", paymentCurrency: "USB", paymentGatewayName: "USDC BEP20" },
    { value: "Binance USD - BUSD - USB", label: "Binance USD - BUSD - USB", parent: "BinanceSmartChain", paymentCurrency: "USB", paymentGatewayName: "BUSD BEP20" },
    { value: "Binance Coin - BNB", label: "Binance Coin - BNB", parent: "BinanceSmartChain", paymentCurrency: "BNB", paymentGatewayName: "BNB" },

    { value: "Tether - USDT TRC20 - USX", label: "Tether - USDT TRC20 - USX", parent: "TRON", paymentCurrency: "USX", paymentGatewayName: "USDT TRC20" },
    { value: "USD Coin - USDC TRC20 - UCX (deposits only)", label: "USD Coin - USDC TRC20 - UCX (deposits only)", parent: "TRON", paymentCurrency: "UCX", paymentGatewayName: "USDC TRC20" },
    { value: "Tronix - TRX (deposits only)", label: "Tronix - TRX ", parent: "TRON", paymentCurrency: "TRX", paymentGatewayName: "TRX" },
];
//#endregion
//#region help2Pay 
export const HELP2PAY_DEPOSIT_BANKCODES = [
    { label: "Bangkok Bank", value: "BBL", Currency: "THB", BankCode: "BBL", BankName: "Bangkok Bank" },
    { label: "Bank of Ayudhya (Krungsri)", value: "BOA", Currency: "THB", BankCode: "BOA", BankName: "Bank of Ayudhya (Krungsri)" },
    { label: "CIMB Thai", value: "CIMBT", Currency: "THB", BankCode: "CIMBT", BankName: "CIMB Thai" },
    { label: "Karsikorn Bank (K-Bank)", value: "KKR", Currency: "THB", BankCode: "KKR", BankName: "Karsikorn Bank (K-Bank)" },
    { label: "Kiatnakin Bank", value: "KNK", Currency: "THB", BankCode: "KNK", BankName: "Kiatnakin Bank" },
    { label: "Krung Thai Bank", value: "KTB", Currency: "THB", BankCode: "KTB", BankName: "Krung Thai Bank" },
    { label: "Siam Commercial Bank", value: "SCB", Currency: "THB", BankCode: "SCB", BankName: "Siam Commercial Bank" },
    { label: "TMBThanachart Bank(TTB)", value: "TMB", Currency: "THB", BankCode: "TMB", BankName: "TMBThanachart Bank(TTB)" },
    { label: "Asia Commercial Bank", value: "ACB", Currency: "VND", BankCode: "ACB", BankName: "Asia Commercial Bank" },
    { label: "Agribank", value: "AGB", Currency: "VND", BankCode: "AGB", BankName: "Agribank" },
    { label: "Bank for Investment and Development of Vietnam", value: "BIDV", Currency: "VND", BankCode: "BIDV", BankName: "Bank for Investment and Development of Vietnam" },
    { label: "DongA Bank", value: "DAB", Currency: "VND", BankCode: "DAB", BankName: "DongA Bank" },
    { label: "Eximbank Vietnam", value: "EXIM", Currency: "VND", BankCode: "EXIM", BankName: "Eximbank Vietnam" },
    { label: "Military Commercial Joint Stock Bank", value: "MB", Currency: "VND", BankCode: "MB", BankName: "Military Commercial Joint Stock Bank" },
    { label: "Maritime Bank", value: "MTMB", Currency: "VND", BankCode: "MTMB", BankName: "Maritime Bank" },
    { label: "Sacombank", value: "SACOM", Currency: "VND", BankCode: "SACOM", BankName: "Sacombank" },
    { label: "Techcombank", value: "TCB", Currency: "VND", BankCode: "TCB", BankName: "Techcombank" },
    { label: "Tien Phong Bank", value: "TPB", Currency: "VND", BankCode: "TPB", BankName: "Tien Phong Bank" },
    { label: "Vietcombank", value: "VCB", Currency: "VND", BankCode: "VCB", BankName: "Vietcombank" },
    { label: "Vietnam International Bank", value: "VIB", Currency: "VND", BankCode: "VIB", BankName: "Vietnam International Bank" },
    { label: "VP Bank", value: "VPB", Currency: "VND", BankCode: "VPB", BankName: "VP Bank" },
    { label: "Vietinbank", value: "VTB", Currency: "VND", BankCode: "VTB", BankName: "Vietinbank" },
    { label: "Banco de Oro ", value: "BDO", Currency: "PHP", BankCode: "BDO", BankName: "Banco de Oro " },
    { label: "Bank of the Philippine Islands", value: "BPI", Currency: "PHP", BankCode: "BPI", BankName: "Bank of the Philippine Islands" },
    { label: "Land Bank of the Philippines", value: "LBP", Currency: "PHP", BankCode: "LBP", BankName: "Land Bank of the Philippines" },
    { label: "MetroBank", value: "MTB", Currency: "PHP", BankCode: "MTB", BankName: "MetroBank" },
    { label: "Rizal Commercial Banking Corporation", value: "RCBC", Currency: "PHP", BankCode: "RCBC", BankName: "Rizal Commercial Banking Corporation" },
    { label: "Security Bank Corporation", value: "SBC", Currency: "PHP", BankCode: "SBC", BankName: "Security Bank Corporation" },
    { label: "Promptpay", value: "PPTP", Currency: "THB", BankCode: "PPTP", BankName: "Promptpay" },
];
//#endregion 
export const CHIMARA_ACCOUNT_TYPE_GROUPS = [
    { value: "AMA", label: "AMA" },
    { value: "EVAL", label: "EVAL" },
    { value: "PLUS", label: "PLUS" },
];
export function ReturnImageName() {
    if (CheckIfCompanyIs("Chimara")) {
        return `Chimara_Table_NoData.png`
    }
    if (CheckIfCompanyIs("PureNorth")) {
        return `Empty-PureNorth-NoData.png`
    }
    if (CheckIfCompanyIs("FXOpulence"))
        return "Main-NoData-FXOpulence.png";
    return "NoData.png";
}
export const BIGPAY_BANK_NAMES = [
    { label: "VIETCOMBANK", value: "VIETCOMBANK" },
    { label: "ACB", value: "ACB" },
    { label: "TECHCOMBANK", value: "TECHCOMBANK" },
    { label: "MB", value: "MB" },
];
export const CAPITAL_WALLET_CURRENCIES = [
    {
        "label": "USDT-TRC20",
        "value": "TRXUSDT",
        "keyType": "TRC20"
    },
    {
        "label": "USDT-ERC20",
        "value": "USDT",
        "keyType": "ERC20"
    },
    {
        "label": "USDC-TRC20",
        "value": "TRXUSDC",
        "keyType": "TRC20"
    },
    {
        "label": "USDC-ERC20",
        "value": "USDC",
        "keyType": "ERC20"
    },
    {
        "label": "BitcoinCash",
        "value": "BCH",
        "keyType": ""
    },
    {
        "label": "Bitcoin",
        "value": "BTC",
        "keyType": ""
    },
    {
        "label": "Ethereum",
        "value": "ETH",
        "keyType": "ERC20"
    },
    {
        "label": "Dogecoin",
        "value": "DOGE",
        "keyType": ""
    },
    {
        "label": "MaticToken",
        "value": "MATIC",
        "keyType": "ERC20"
    },
    {
        "label": "TRON",
        "value": "TRX",
        "keyType": ""
    },
    {
        "label": "BinanceUSD",
        "value": "BUSD",
        "keyType": "ERC20"
    },
    {
        "label": "Litecoin",
        "value": "LTC",
        "keyType": ""
    }
];
export const CAPTIAL_WALLET_DICTIONARY: any = {
    "TRXUSDT": {
        "label": "USDT-TRC20",
        "value": "TRXUSDT",
        "keyType": "TRC20"
    },
    "USDT": {
        "label": "USDT-ERC20",
        "value": "USDT",
        "keyType": "ERC20"
    },
    "TRXUSDC": {
        "label": "USDC-TRC20",
        "value": "TRXUSDC",
        "keyType": "TRC20"
    },
    "USDC": {
        "label": "USDC-ERC20",
        "value": "USDC",
        "keyType": "ERC20"
    },
    "BCH": {
        "label": "BitcoinCash",
        "value": "BCH",
        "keyType": ""
    },
    "BTC": {
        "label": "Bitcoin",
        "value": "BTC",
        "keyType": ""
    },
    "ETH": {
        "label": "Ethereum",
        "value": "ETH",
        "keyType": "ERC20"
    },
    "DOGE": {
        "label": "Dogecoin",
        "value": "DOGE",
        "keyType": ""
    },
    "MATIC": {
        "label": "MaticToken",
        "value": "MATIC",
        "keyType": "ERC20"
    },
    "TRX": {
        "label": "TRON",
        "value": "TRX",
        "keyType": ""
    },
    "BUSD": {
        "label": "BinanceUSD",
        "value": "BUSD",
        "keyType": "ERC20"
    },
    "LTC": {
        "label": "Litecoin",
        "value": "LTC",
        "keyType": ""
    }
};
export const OZOW_WITHDRAWAL_BANKS = [
    {
        "value": "42f71bf8-0e09-43d5-a6eb-4f7370cb5b20",
        "label": "Cash Vouchers",
        "universalBranchCode": null
    },
    {
        "value": "155ace7d-eb87-481e-94be-a185215afd48",
        "label": "Direct Deposit",
        "universalBranchCode": null
    },
    {
        "value": "c296d0d8-ad0b-43b4-96c2-de30ad039561",
        "label": "Standard Chartered Bank",
        "universalBranchCode": "730020"
    },
    {
        "value": "3284a0ad-ba78-4838-8c2b-102981286a2b",
        "label": "ABSA",
        "universalBranchCode": "632005"
    },
    {
        "value": "33a0840b-0cf4-4b8c-86e0-ec6c4be8c60e",
        "label": "African Bank",
        "universalBranchCode": "430000"
    },
    {
        "value": "44356c06-1081-4ced-8669-760cf3165712",
        "label": "Albaraka Bank",
        "universalBranchCode": "800000"
    },
    {
        "value": "8d77e501-5990-4cd1-bb08-3d3fe402fb20",
        "label": "BankOfAthens",
        "universalBranchCode": "410506"
    },
    {
        "value": "29c5ee92-46ec-4879-8ad9-5cd3f5502727",
        "label": "Bidvest Bank",
        "universalBranchCode": "462005"
    },
    {
        "value": "913999fa-3a32-4e3d-82f0-a1df7e9e4f7b",
        "label": "Capitec Bank",
        "universalBranchCode": "470010"
    },
    {
        "value": "7fc2d14c-5021-497d-a73e-1788d6ce3ff3",
        "label": "CitiBank",
        "universalBranchCode": "350005"
    },
    {
        "value": "b8f152a2-8bd2-46c4-930f-4cd5b2b37ef9",
        "label": "Discovery Bank",
        "universalBranchCode": "679000"
    },
    {
        "value": "4816019c-3314-4c80-8b6b-b2cd16dcc4ec",
        "label": "FNB",
        "universalBranchCode": "250655"
    },
    {
        "value": "2c7bbd14-cd96-4b4f-96f9-ad9ba228366d",
        "label": "HSBC Bank",
        "universalBranchCode": "587000"
    },
    {
        "value": "4b45be85-b616-4bd1-9027-f8fcf8f9af7b",
        "label": "Investec",
        "universalBranchCode": "580105"
    },
    {
        "value": "9e1917ad-29d1-4d11-80b5-0f6c33ae1083",
        "label": "Mercantile Bank",
        "universalBranchCode": "450105"
    },
    {
        "value": "bf0561fd-4203-4a0c-9174-cb26fcd87a60",
        "label": "Nedbank",
        "universalBranchCode": "198765"
    },
    {
        "value": "c36c2423-8a06-4393-bf2d-f5da82d67bc7",
        "label": "Olympus Mobile",
        "universalBranchCode": "585001"
    },
    {
        "value": "cc08d678-09cb-49c8-bcd8-2ec9e3bd0a82",
        "label": "RMB",
        "universalBranchCode": "250655"
    },
    {
        "value": "54a18018-a9fe-4adb-b752-38004ed735d6",
        "label": "Sasfin Bank",
        "universalBranchCode": "683000"
    },
    {
        "value": "ad7d8da4-1723-4066-94bb-6662d845e483",
        "label": "Standard Bank",
        "universalBranchCode": "051001"
    },
    {
        "value": "28fcc8fa-985b-480b-82fd-7d09bc19c9d0",
        "label": "TymeBank",
        "universalBranchCode": "678910"
    },
    {
        "value": "8ff9fbc7-9e14-47bc-8d91-cbc81cf131e9",
        "label": "Ubank Limited",
        "universalBranchCode": "431010"
    }
];
export function validateCardExpiration(expirationDate: string) {
    if (!expirationDate) return false;
    let regex = /^(0[1-9]|1[0-2])\/\d{2}$/; // Regular expression for MM/YY format
    return regex.test(expirationDate);
}
export const OZOW_WITHDRAWAL_BANKS_DICT: any = {
    "42f71bf8-0e09-43d5-a6eb-4f7370cb5b20": {
        "value": "42f71bf8-0e09-43d5-a6eb-4f7370cb5b20",
        "label": "Cash Vouchers",
        "universalBranchCode": null
    },
    "155ace7d-eb87-481e-94be-a185215afd48": {
        "value": "155ace7d-eb87-481e-94be-a185215afd48",
        "label": "Direct Deposit",
        "universalBranchCode": null
    },
    "c296d0d8-ad0b-43b4-96c2-de30ad039561": {
        "value": "c296d0d8-ad0b-43b4-96c2-de30ad039561",
        "label": "Standard Chartered Bank",
        "universalBranchCode": "730020"
    },
    "3284a0ad-ba78-4838-8c2b-102981286a2b": {
        "value": "3284a0ad-ba78-4838-8c2b-102981286a2b",
        "label": "ABSA",
        "universalBranchCode": "632005"
    },
    "33a0840b-0cf4-4b8c-86e0-ec6c4be8c60e": {
        "value": "33a0840b-0cf4-4b8c-86e0-ec6c4be8c60e",
        "label": "African Bank",
        "universalBranchCode": "430000"
    },
    "44356c06-1081-4ced-8669-760cf3165712": {
        "value": "44356c06-1081-4ced-8669-760cf3165712",
        "label": "Albaraka Bank",
        "universalBranchCode": "800000"
    },
    "8d77e501-5990-4cd1-bb08-3d3fe402fb20": {
        "value": "8d77e501-5990-4cd1-bb08-3d3fe402fb20",
        "label": "BankOfAthens",
        "universalBranchCode": "410506"
    },
    "29c5ee92-46ec-4879-8ad9-5cd3f5502727": {
        "value": "29c5ee92-46ec-4879-8ad9-5cd3f5502727",
        "label": "Bidvest Bank",
        "universalBranchCode": "462005"
    },
    "913999fa-3a32-4e3d-82f0-a1df7e9e4f7b": {
        "value": "913999fa-3a32-4e3d-82f0-a1df7e9e4f7b",
        "label": "Capitec Bank",
        "universalBranchCode": "470010"
    },
    "7fc2d14c-5021-497d-a73e-1788d6ce3ff3": {
        "value": "7fc2d14c-5021-497d-a73e-1788d6ce3ff3",
        "label": "CitiBank",
        "universalBranchCode": "350005"
    },
    "b8f152a2-8bd2-46c4-930f-4cd5b2b37ef9": {
        "value": "b8f152a2-8bd2-46c4-930f-4cd5b2b37ef9",
        "label": "Discovery Bank",
        "universalBranchCode": "679000"
    },
    "4816019c-3314-4c80-8b6b-b2cd16dcc4ec": {
        "value": "4816019c-3314-4c80-8b6b-b2cd16dcc4ec",
        "label": "FNB",
        "universalBranchCode": "250655"
    },
    "2c7bbd14-cd96-4b4f-96f9-ad9ba228366d": {
        "value": "2c7bbd14-cd96-4b4f-96f9-ad9ba228366d",
        "label": "HSBC Bank",
        "universalBranchCode": "587000"
    },
    "4b45be85-b616-4bd1-9027-f8fcf8f9af7b": {
        "value": "4b45be85-b616-4bd1-9027-f8fcf8f9af7b",
        "label": "Investec",
        "universalBranchCode": "580105"
    },
    "9e1917ad-29d1-4d11-80b5-0f6c33ae1083": {
        "value": "9e1917ad-29d1-4d11-80b5-0f6c33ae1083",
        "label": "Mercantile Bank",
        "universalBranchCode": "450105"
    },
    "bf0561fd-4203-4a0c-9174-cb26fcd87a60": {
        "value": "bf0561fd-4203-4a0c-9174-cb26fcd87a60",
        "label": "Nedbank",
        "universalBranchCode": "198765"
    },
    "c36c2423-8a06-4393-bf2d-f5da82d67bc7": {
        "value": "c36c2423-8a06-4393-bf2d-f5da82d67bc7",
        "label": "Olympus Mobile",
        "universalBranchCode": "585001"
    },
    "cc08d678-09cb-49c8-bcd8-2ec9e3bd0a82": {
        "value": "cc08d678-09cb-49c8-bcd8-2ec9e3bd0a82",
        "label": "RMB",
        "universalBranchCode": "250655"
    },
    "54a18018-a9fe-4adb-b752-38004ed735d6": {
        "value": "54a18018-a9fe-4adb-b752-38004ed735d6",
        "label": "Sasfin Bank",
        "universalBranchCode": "683000"
    },
    "ad7d8da4-1723-4066-94bb-6662d845e483": {
        "value": "ad7d8da4-1723-4066-94bb-6662d845e483",
        "label": "Standard Bank",
        "universalBranchCode": "051001"
    },
    "28fcc8fa-985b-480b-82fd-7d09bc19c9d0": {
        "value": "28fcc8fa-985b-480b-82fd-7d09bc19c9d0",
        "label": "TymeBank",
        "universalBranchCode": "678910"
    },
    "8ff9fbc7-9e14-47bc-8d91-cbc81cf131e9": {
        "value": "8ff9fbc7-9e14-47bc-8d91-cbc81cf131e9",
        "label": "Ubank Limited",
        "universalBranchCode": "431010"
    }
};
export const BRIDGER_PAYMENT_OPERATOR_CODE_OPTIONS: any[] = [
    { label: "CN_ABC (Agricultural Bank of China)", value: "CN_ABC (Agricultural Bank of China)", BankCode: "CN_ABC", BankName: "Agricultural Bank of China" },
    { label: "CN_BCOM (Bank of Communications)", value: "CN_BCOM (Bank of Communications)", BankCode: "CN_BCOM", BankName: "Bank of Communications" },
    { label: "CN_BOC (Bank of China)", value: "CN_BOC (Bank of China)", BankCode: "CN_BOC", BankName: "Bank of China" },
    { label: "CN_CCB (China Construction Bank)", value: "CN_CCB (China Construction Bank)", BankCode: "CN_CCB", BankName: "China Construction Bank" },
    { label: "CN_CEB (China Everbright Bank)", value: "CN_CEB (China Everbright Bank)", BankCode: "CN_CEB", BankName: "China Everbright Bank" },
    { label: "CN_CGB (China Guangfa Bank)", value: "CN_CGB (China Guangfa Bank)", BankCode: "CN_CGB", BankName: "China Guangfa Bank" },
    { label: "CN_CIB (China Industrial Bank)", value: "CN_CIB (China Industrial Bank)", BankCode: "CN_CIB", BankName: "China Industrial Bank" },
    { label: "CN_CITIC (China CITIC Bank)", value: "CN_CITIC (China CITIC Bank)", BankCode: "CN_CITIC", BankName: "China CITIC Bank" },
    { label: "CN_CMB (China Merchants Bank)", value: "CN_CMB (China Merchants Bank)", BankCode: "CN_CMB", BankName: "China Merchants Bank" },
    { label: "CN_CMBC (China Minsheng Bank)", value: "CN_CMBC (China Minsheng Bank)", BankCode: "CN_CMBC", BankName: "China Minsheng Bank" },
    { label: "CN_ICBC (Industrial and Commercial Bank of China)", value: "CN_ICBC (Industrial and Commercial Bank of China)", BankCode: "CN_ICBC", BankName: "Industrial and Commercial Bank of China" },
    { label: "CN_PAB (Ping An Bank)", value: "CN_PAB (Ping An Bank)", BankCode: "CN_PAB", BankName: "Ping An Bank" },
    { label: "CN_PSBC (Postal Savings Bank of China)", value: "CN_PSBC (Postal Savings Bank of China)", BankCode: "CN_PSBC", BankName: "Postal Savings Bank of China" },
    { label: "CN_SPDB (Shanghai Pudong Development Bank)", value: "CN_SPDB (Shanghai Pudong Development Bank)", BankCode: "CN_SPDB", BankName: "Shanghai Pudong Development Bank" },
    { label: "IDR_002 (Bank Rakyat Indonesia (BRI))", value: "IDR_002 (Bank Rakyat Indonesia (BRI))", BankCode: "IDR_002", BankName: "Bank Rakyat Indonesia (BRI)" },
    { label: "IDR_003 (Bank Ekspor Indonesia)", value: "IDR_003 (Bank Ekspor Indonesia)", BankCode: "IDR_003", BankName: "Bank Ekspor Indonesia" },
    { label: "IDR_008 (Bank Mandiri)", value: "IDR_008 (Bank Mandiri)", BankCode: "IDR_008", BankName: "Bank Mandiri" },
    { label: "IDR_009 (Bank Negara Indonesia (BNI))", value: "IDR_009 (Bank Negara Indonesia (BNI))", BankCode: "IDR_009", BankName: "Bank Negara Indonesia (BNI)" },
    { label: "IDR_011 (Bank Danamon)", value: "IDR_011 (Bank Danamon)", BankCode: "IDR_011", BankName: "Bank Danamon" },
    { label: "IDR_013 (Bank Permata)", value: "IDR_013 (Bank Permata)", BankCode: "IDR_013", BankName: "Bank Permata" },
    { label: "IDR_014 (Bank Central Asia (BCA))", value: "IDR_014 (Bank Central Asia (BCA))", BankCode: "IDR_014", BankName: "Bank Central Asia (BCA)" },
    { label: "IDR_016 (Maybank Indonesia)", value: "IDR_016 (Maybank Indonesia)", BankCode: "IDR_016", BankName: "Maybank Indonesia" },
    { label: "IDR_019 (Bank Panin)", value: "IDR_019 (Bank Panin)", BankCode: "IDR_019", BankName: "Bank Panin" },
    { label: "IDR_020 (Bank Arta Niaga Kencana)", value: "IDR_020 (Bank Arta Niaga Kencana)", BankCode: "IDR_020", BankName: "Bank Arta Niaga Kencana" },
    { label: "IDR_022 (Bank CIMB Niaga)", value: "IDR_022 (Bank CIMB Niaga)", BankCode: "IDR_022", BankName: "Bank CIMB Niaga" },
    { label: "IDR_023 (Bank UOB Indonesia / Bank Buana Indonesia)", value: "IDR_023 (Bank UOB Indonesia / Bank Buana Indonesia)", BankCode: "IDR_023", BankName: "Bank UOB Indonesia / Bank Buana Indonesia" },
    { label: "IDR_026 (Bank Lippo)", value: "IDR_026 (Bank Lippo)", BankCode: "IDR_026", BankName: "Bank Lippo" },
    { label: "IDR_028 (Bank OCBC NISP)", value: "IDR_028 (Bank OCBC NISP)", BankCode: "IDR_028", BankName: "Bank OCBC NISP" },
    { label: "IDR_030 (American Express Bank LTD)", value: "IDR_030 (American Express Bank LTD)", BankCode: "IDR_030", BankName: "American Express Bank LTD" },
    { label: "IDR_031 (Citibank Indonesia)", value: "IDR_031 (Citibank Indonesia)", BankCode: "IDR_031", BankName: "Citibank Indonesia" },
    { label: "IDR_032 (JP Morgan Chase Bank N.A.)", value: "IDR_032 (JP Morgan Chase Bank N.A.)", BankCode: "IDR_032", BankName: "JP Morgan Chase Bank N.A." },
    { label: "IDR_033 (Bank of America N.A.)", value: "IDR_033 (Bank of America N.A.)", BankCode: "IDR_033", BankName: "Bank of America N.A." },
    { label: "IDR_034 (ING Indonesia Bank)", value: "IDR_034 (ING Indonesia Bank)", BankCode: "IDR_034", BankName: "ING Indonesia Bank" },
    { label: "IDR_036 (Bank Multicor / Bank CCB Indonesia)", value: "IDR_036 (Bank Multicor / Bank CCB Indonesia)", BankCode: "IDR_036", BankName: "Bank Multicor / Bank CCB Indonesia" },
    { label: "IDR_037 (Bank Artha Graha Internasional)", value: "IDR_037 (Bank Artha Graha Internasional)", BankCode: "IDR_037", BankName: "Bank Artha Graha Internasional" },
    { label: "IDR_039 (Bank Credit Agricole Indosuez)", value: "IDR_039 (Bank Credit Agricole Indosuez)", BankCode: "IDR_039", BankName: "Bank Credit Agricole Indosuez" },
    { label: "IDR_040 (Bangkok Bank)", value: "IDR_040 (Bangkok Bank)", BankCode: "IDR_040", BankName: "Bangkok Bank" },
    { label: "IDR_041 (Bank HSBC Indonesia)", value: "IDR_041 (Bank HSBC Indonesia)", BankCode: "IDR_041", BankName: "Bank HSBC Indonesia" },
    { label: "IDR_042 (Bank of Tokyo/MUFG Bank/Mitsubishi UFJ LTD)", value: "IDR_042 (Bank of Tokyo/MUFG Bank/Mitsubishi UFJ LTD)", BankCode: "IDR_042", BankName: "Bank of Tokyo/MUFG Bank/Mitsubishi UFJ LTD" },
    { label: "IDR_045 (Bank Sumitomo Mitsui Indonesia)", value: "IDR_045 (Bank Sumitomo Mitsui Indonesia)", BankCode: "IDR_045", BankName: "Bank Sumitomo Mitsui Indonesia" },
    { label: "IDR_046 (Bank DBS Indonesia)", value: "IDR_046 (Bank DBS Indonesia)", BankCode: "IDR_046", BankName: "Bank DBS Indonesia" },
    { label: "IDR_047 (Bank Resona Perdania)", value: "IDR_047 (Bank Resona Perdania)", BankCode: "IDR_047", BankName: "Bank Resona Perdania" },
    { label: "IDR_048 (Bank Mizuho Indonesia)", value: "IDR_048 (Bank Mizuho Indonesia)", BankCode: "IDR_048", BankName: "Bank Mizuho Indonesia" },
    { label: "IDR_050 (Standard Chartered Bank)", value: "IDR_050 (Standard Chartered Bank)", BankCode: "IDR_050", BankName: "Standard Chartered Bank" },
    { label: "IDR_052 (Bank ABN Amro)", value: "IDR_052 (Bank ABN Amro)", BankCode: "IDR_052", BankName: "Bank ABN Amro" },
    { label: "IDR_053 (Bank Keppel Tatlee Buana)", value: "IDR_053 (Bank Keppel Tatlee Buana)", BankCode: "IDR_053", BankName: "Bank Keppel Tatlee Buana" },
    { label: "IDR_054 (Bank Capital Indonesia)", value: "IDR_054 (Bank Capital Indonesia)", BankCode: "IDR_054", BankName: "Bank Capital Indonesia" },
    { label: "IDR_057 (Bank BNP Paribas Indonesia)", value: "IDR_057 (Bank BNP Paribas Indonesia)", BankCode: "IDR_057", BankName: "Bank BNP Paribas Indonesia" },
    { label: "IDR_059 (Korea Exchange Bank Danamon)", value: "IDR_059 (Korea Exchange Bank Danamon)", BankCode: "IDR_059", BankName: "Korea Exchange Bank Danamon" },
    { label: "IDR_060 (Bank Rabobank International Indonesia)", value: "IDR_060 (Bank Rabobank International Indonesia)", BankCode: "IDR_060", BankName: "Bank Rabobank International Indonesia" },
    { label: "IDR_061 (Bank ANZ Indonesia)", value: "IDR_061 (Bank ANZ Indonesia)", BankCode: "IDR_061", BankName: "Bank ANZ Indonesia" },
    { label: "IDR_067 (Deutsche Bank)", value: "IDR_067 (Deutsche Bank)", BankCode: "IDR_067", BankName: "Deutsche Bank" },
    { label: "IDR_068 (Bank Woori Saudara)", value: "IDR_068 (Bank Woori Saudara)", BankCode: "IDR_068", BankName: "Bank Woori Saudara" },
    { label: "IDR_069 (Bank of China)", value: "IDR_069 (Bank of China)", BankCode: "IDR_069", BankName: "Bank of China" },
    { label: "IDR_076 (Bank Bumi Arta)", value: "IDR_076 (Bank Bumi Arta)", BankCode: "IDR_076", BankName: "Bank Bumi Arta" },
    { label: "IDR_087 (Bank Ekonomi Raharja)", value: "IDR_087 (Bank Ekonomi Raharja)", BankCode: "IDR_087", BankName: "Bank Ekonomi Raharja" },
    { label: "IDR_088 (Bank Antardaerah)", value: "IDR_088 (Bank Antardaerah)", BankCode: "IDR_088", BankName: "Bank Antardaerah" },
    { label: "IDR_089 (Bank Haga)", value: "IDR_089 (Bank Haga)", BankCode: "IDR_089", BankName: "Bank Haga" },
    { label: "IDR_093 (Bank IFI)", value: "IDR_093 (Bank IFI)", BankCode: "IDR_093", BankName: "Bank IFI" },
    { label: "IDR_095 (J Trust Bank / Bank Jtrust Indonesia)", value: "IDR_095 (J Trust Bank / Bank Jtrust Indonesia)", BankCode: "IDR_095", BankName: "J Trust Bank / Bank Jtrust Indonesia" },
    { label: "IDR_097 (Bank Mayapada)", value: "IDR_097 (Bank Mayapada)", BankCode: "IDR_097", BankName: "Bank Mayapada" },
    { label: "IDR_110 (Bank Jabar / Bank BJB)", value: "IDR_110 (Bank Jabar / Bank BJB)", BankCode: "IDR_110", BankName: "Bank Jabar / Bank BJB" },
    { label: "IDR_111 (Bank DKI)", value: "IDR_111 (Bank DKI)", BankCode: "IDR_111", BankName: "Bank DKI" },
    { label: "IDR_112 (BPD Daerah Istimewa Yogyakarta (DIY))", value: "IDR_112 (BPD Daerah Istimewa Yogyakarta (DIY))", BankCode: "IDR_112", BankName: "BPD Daerah Istimewa Yogyakarta (DIY)" },
    { label: "IDR_113 (BPD Jawa Tengah)", value: "IDR_113 (BPD Jawa Tengah)", BankCode: "IDR_113", BankName: "BPD Jawa Tengah" },
    { label: "IDR_114 (BPD Jawa Timur)", value: "IDR_114 (BPD Jawa Timur)", BankCode: "IDR_114", BankName: "BPD Jawa Timur" },
    { label: "IDR_115 (BPD Jambi UUS)", value: "IDR_115 (BPD Jambi UUS)", BankCode: "IDR_115", BankName: "BPD Jambi UUS" },
    { label: "IDR_116 (Bank Aceh Syariah)", value: "IDR_116 (Bank Aceh Syariah)", BankCode: "IDR_116", BankName: "Bank Aceh Syariah" },
    { label: "IDR_117 (BPD Sumatra Utara)", value: "IDR_117 (BPD Sumatra Utara)", BankCode: "IDR_117", BankName: "BPD Sumatra Utara" },
    { label: "IDR_118 (Bank Nagari / Bank Sumbar)", value: "IDR_118 (Bank Nagari / Bank Sumbar)", BankCode: "IDR_118", BankName: "Bank Nagari / Bank Sumbar" },
    { label: "IDR_119 (BPD Riau Dan Kepri)", value: "IDR_119 (BPD Riau Dan Kepri)", BankCode: "IDR_119", BankName: "BPD Riau Dan Kepri" },
    { label: "IDR_120 (BPD Sumsel Dan Babel)", value: "IDR_120 (BPD Sumsel Dan Babel)", BankCode: "IDR_120", BankName: "BPD Sumsel Dan Babel" },
    { label: "IDR_121 (BPD Lampung)", value: "IDR_121 (BPD Lampung)", BankCode: "IDR_121", BankName: "BPD Lampung" },
    { label: "IDR_122 (BPD Kalimantan Selatan)", value: "IDR_122 (BPD Kalimantan Selatan)", BankCode: "IDR_122", BankName: "BPD Kalimantan Selatan" },
    { label: "IDR_123 (BPD Kalimantan Barat)", value: "IDR_123 (BPD Kalimantan Barat)", BankCode: "IDR_123", BankName: "BPD Kalimantan Barat" },
    { label: "IDR_124 (BPD Kalimantan Timur)", value: "IDR_124 (BPD Kalimantan Timur)", BankCode: "IDR_124", BankName: "BPD Kalimantan Timur" },
    { label: "IDR_125 (BPD Kalimantan Tengah)", value: "IDR_125 (BPD Kalimantan Tengah)", BankCode: "IDR_125", BankName: "BPD Kalimantan Tengah" },
    { label: "IDR_126 (Bank Sulawesi Selatan Dan Barat)", value: "IDR_126 (Bank Sulawesi Selatan Dan Barat)", BankCode: "IDR_126", BankName: "Bank Sulawesi Selatan Dan Barat" },
    { label: "IDR_127 (Bank Sulawesi Utara Dan Gorontalo)", value: "IDR_127 (Bank Sulawesi Utara Dan Gorontalo)", BankCode: "IDR_127", BankName: "Bank Sulawesi Utara Dan Gorontalo" },
    { label: "IDR_128 (BPD Nusa Tenggara Barat)", value: "IDR_128 (BPD Nusa Tenggara Barat)", BankCode: "IDR_128", BankName: "BPD Nusa Tenggara Barat" },
    { label: "IDR_129 (BPD Bali)", value: "IDR_129 (BPD Bali)", BankCode: "IDR_129", BankName: "BPD Bali" },
    { label: "IDR_130 (BPD Nusa Tenggara Timur)", value: "IDR_130 (BPD Nusa Tenggara Timur)", BankCode: "IDR_130", BankName: "BPD Nusa Tenggara Timur" },
    { label: "IDR_131 (Bank Maluku Malut)", value: "IDR_131 (Bank Maluku Malut)", BankCode: "IDR_131", BankName: "Bank Maluku Malut" },
    { label: "IDR_132 (Bank Papua)", value: "IDR_132 (Bank Papua)", BankCode: "IDR_132", BankName: "Bank Papua" },
    { label: "IDR_133 (BPD Bengkulu)", value: "IDR_133 (BPD Bengkulu)", BankCode: "IDR_133", BankName: "BPD Bengkulu" },
    { label: "IDR_134 (BPD Sulawesi Tengah)", value: "IDR_134 (BPD Sulawesi Tengah)", BankCode: "IDR_134", BankName: "BPD Sulawesi Tengah" },
    { label: "IDR_135 (BPD Sulawesi Tenggara)", value: "IDR_135 (BPD Sulawesi Tenggara)", BankCode: "IDR_135", BankName: "BPD Sulawesi Tenggara" },
    { label: "IDR_137 (BPD Banten)", value: "IDR_137 (BPD Banten)", BankCode: "IDR_137", BankName: "BPD Banten" },
    { label: "IDR_145 (Bank Nusantara Parahyangan / BNP)", value: "IDR_145 (Bank Nusantara Parahyangan / BNP)", BankCode: "IDR_145", BankName: "Bank Nusantara Parahyangan / BNP" },
    { label: "IDR_146 (Bank Swadesi (Bank of India Indonesia))", value: "IDR_146 (Bank Swadesi (Bank of India Indonesia))", BankCode: "IDR_146", BankName: "Bank Swadesi (Bank of India Indonesia)" },
    { label: "IDR_147 (Bank Muamalat Indonesia)", value: "IDR_147 (Bank Muamalat Indonesia)", BankCode: "IDR_147", BankName: "Bank Muamalat Indonesia" },
    { label: "IDR_151 (Bank Mestika Dharma)", value: "IDR_151 (Bank Mestika Dharma)", BankCode: "IDR_151", BankName: "Bank Mestika Dharma" },
    { label: "IDR_152 (Bank Metro Express / Shinhan)", value: "IDR_152 (Bank Metro Express / Shinhan)", BankCode: "IDR_152", BankName: "Bank Metro Express / Shinhan" },
    { label: "IDR_153 (Bank Sinarmas)", value: "IDR_153 (Bank Sinarmas)", BankCode: "IDR_153", BankName: "Bank Sinarmas" },
    { label: "IDR_157 (Bank Maspion Indonesia)", value: "IDR_157 (Bank Maspion Indonesia)", BankCode: "IDR_157", BankName: "Bank Maspion Indonesia" },
    { label: "IDR_159 (Bank Hagakita)", value: "IDR_159 (Bank Hagakita)", BankCode: "IDR_159", BankName: "Bank Hagakita" },
    { label: "IDR_161 (Bank Ganesha)", value: "IDR_161 (Bank Ganesha)", BankCode: "IDR_161", BankName: "Bank Ganesha" },
    { label: "IDR_162 (Bank of Windu Kentjana)", value: "IDR_162 (Bank of Windu Kentjana)", BankCode: "IDR_162", BankName: "Bank of Windu Kentjana" },
    { label: "IDR_164 (Bank ICBC Indonesia)", value: "IDR_164 (Bank ICBC Indonesia)", BankCode: "IDR_164", BankName: "Bank ICBC Indonesia" },
    { label: "IDR_166 (Bank Harmoni International)", value: "IDR_166 (Bank Harmoni International)", BankCode: "IDR_166", BankName: "Bank Harmoni International" },
    { label: "IDR_167 (Bank QNB Indonesia)", value: "IDR_167 (Bank QNB Indonesia)", BankCode: "IDR_167", BankName: "Bank QNB Indonesia" },
    { label: "IDR_200 (Bank BTN)", value: "IDR_200 (Bank BTN)", BankCode: "IDR_200", BankName: "Bank BTN" },
    { label: "IDR_212 (Bank Himpunan Saudara 1906)", value: "IDR_212 (Bank Himpunan Saudara 1906)", BankCode: "IDR_212", BankName: "Bank Himpunan Saudara 1906" },
    { label: "IDR_213 (Bank BTPN)", value: "IDR_213 (Bank BTPN)", BankCode: "IDR_213", BankName: "Bank BTPN" },
    { label: "IDR_333 (Koperasi Intidana)", value: "IDR_333 (Koperasi Intidana)", BankCode: "IDR_333", BankName: "Koperasi Intidana" },
    { label: "IDR_405 (Bank Victoria Syariah / Bank Swaguna)", value: "IDR_405 (Bank Victoria Syariah / Bank Swaguna)", BankCode: "IDR_405", BankName: "Bank Victoria Syariah / Bank Swaguna" },
    { label: "IDR_422 (Bank BRI Syariah (BRIS))", value: "IDR_422 (Bank BRI Syariah (BRIS))", BankCode: "IDR_422", BankName: "Bank BRI Syariah (BRIS)" },
    { label: "IDR_425 (Bank BJB Syariah)", value: "IDR_425 (Bank BJB Syariah)", BankCode: "IDR_425", BankName: "Bank BJB Syariah" },
    { label: "IDR_426 (Bank Mega)", value: "IDR_426 (Bank Mega)", BankCode: "IDR_426", BankName: "Bank Mega" },
    { label: "IDR_427 (Bank BNI Syariah)", value: "IDR_427 (Bank BNI Syariah)", BankCode: "IDR_427", BankName: "Bank BNI Syariah" },
    { label: "IDR_441 (Bank Bukopin)", value: "IDR_441 (Bank Bukopin)", BankCode: "IDR_441", BankName: "Bank Bukopin" },
    { label: "IDR_451 (Bank Syariah Indonesia (BSI))", value: "IDR_451 (Bank Syariah Indonesia (BSI))", BankCode: "IDR_451", BankName: "Bank Syariah Indonesia (BSI)" },
    { label: "IDR_459 (Bank Bisnis Internasional)", value: "IDR_459 (Bank Bisnis Internasional)", BankCode: "IDR_459", BankName: "Bank Bisnis Internasional" },
    { label: "IDR_466 (Bank Sri Partha / Bank Andara)", value: "IDR_466 (Bank Sri Partha / Bank Andara)", BankCode: "IDR_466", BankName: "Bank Sri Partha / Bank Andara" },
    { label: "IDR_472 (Bank Jasa Jakarta)", value: "IDR_472 (Bank Jasa Jakarta)", BankCode: "IDR_472", BankName: "Bank Jasa Jakarta" },
    { label: "IDR_484 (Bank KEB Hana Indonesia / Bank Bintang Manunggal)", value: "IDR_484 (Bank KEB Hana Indonesia / Bank Bintang Manunggal)", BankCode: "IDR_484", BankName: "Bank KEB Hana Indonesia / Bank Bintang Manunggal" },
    { label: "IDR_485 (Bank MNC Internasional / Bank Bumiputera)", value: "IDR_485 (Bank MNC Internasional / Bank Bumiputera)", BankCode: "IDR_485", BankName: "Bank MNC Internasional / Bank Bumiputera" },
    { label: "IDR_490 (Bank Yudha Bhakti (BYB))", value: "IDR_490 (Bank Yudha Bhakti (BYB))", BankCode: "IDR_490", BankName: "Bank Yudha Bhakti (BYB)" },
    { label: "IDR_491 (Bank Mitra Niaga)", value: "IDR_491 (Bank Mitra Niaga)", BankCode: "IDR_491", BankName: "Bank Mitra Niaga" },
    { label: "IDR_494 (Bank Agroniaga / Bank BRI Agro Niaga)", value: "IDR_494 (Bank Agroniaga / Bank BRI Agro Niaga)", BankCode: "IDR_494", BankName: "Bank Agroniaga / Bank BRI Agro Niaga" },
    { label: "IDR_498 (Bank SBI Indonesia / Bank Indo Monex)", value: "IDR_498 (Bank SBI Indonesia / Bank Indo Monex)", BankCode: "IDR_498", BankName: "Bank SBI Indonesia / Bank Indo Monex" },
    { label: "IDR_503 (Bank National NOBU / Bank Alfindo)", value: "IDR_503 (Bank National NOBU / Bank Alfindo)", BankCode: "IDR_503", BankName: "Bank National NOBU / Bank Alfindo" },
    { label: "IDR_506 (Bank Mega Syariah)", value: "IDR_506 (Bank Mega Syariah)", BankCode: "IDR_506", BankName: "Bank Mega Syariah" },
    { label: "IDR_513 (Bank Ina Perdana)", value: "IDR_513 (Bank Ina Perdana)", BankCode: "IDR_513", BankName: "Bank Ina Perdana" },
    { label: "IDR_517 (Panin Dubai Syariah Bank / Bank Harfa)", value: "IDR_517 (Panin Dubai Syariah Bank / Bank Harfa)", BankCode: "IDR_517", BankName: "Panin Dubai Syariah Bank / Bank Harfa" },
    { label: "IDR_520 (Prima Master Bank)", value: "IDR_520 (Prima Master Bank)", BankCode: "IDR_520", BankName: "Prima Master Bank" },
    { label: "IDR_521 (Bank Syariah Bukopin)", value: "IDR_521 (Bank Syariah Bukopin)", BankCode: "IDR_521", BankName: "Bank Syariah Bukopin" },
    { label: "IDR_523 (Bank Sahabat Sampoerna)", value: "IDR_523 (Bank Sahabat Sampoerna)", BankCode: "IDR_523", BankName: "Bank Sahabat Sampoerna" },
    { label: "IDR_525 (Bank Barclays / Bank Akita)", value: "IDR_525 (Bank Barclays / Bank Akita)", BankCode: "IDR_525", BankName: "Bank Barclays / Bank Akita" },
    { label: "IDR_526 (Bank Dinar / Liman International Bank)", value: "IDR_526 (Bank Dinar / Liman International Bank)", BankCode: "IDR_526", BankName: "Bank Dinar / Liman International Bank" },
    { label: "IDR_531 (Anglomas International Bank)", value: "IDR_531 (Anglomas International Bank)", BankCode: "IDR_531", BankName: "Anglomas International Bank" },
    { label: "IDR_535 (Bank Kesejahteraan Ekonomi)", value: "IDR_535 (Bank Kesejahteraan Ekonomi)", BankCode: "IDR_535", BankName: "Bank Kesejahteraan Ekonomi" },
    { label: "IDR_536 (Bank Central Asia (BCA) Syariah)", value: "IDR_536 (Bank Central Asia (BCA) Syariah)", BankCode: "IDR_536 (Bank Central Asia", BankName: "BCA) Syariah" },
    { label: "IDR_542 (Bank Artos Indonesia)", value: "IDR_542 (Bank Artos Indonesia)", BankCode: "IDR_542", BankName: "Bank Artos Indonesia" },
    { label: "IDR_547 (BANK BTPN SYARIAH / BANK PURBA DANARTA)", value: "IDR_547 (BANK BTPN SYARIAH / BANK PURBA DANARTA)", BankCode: "IDR_547", BankName: "BANK BTPN SYARIAH / BANK PURBA DANARTA" },
    { label: "IDR_548 (Bank Multiarta Sentosa)", value: "IDR_548 (Bank Multiarta Sentosa)", BankCode: "IDR_548", BankName: "Bank Multiarta Sentosa" },
    { label: "IDR_553 (Bank Mayora Indonesia)", value: "IDR_553 (Bank Mayora Indonesia)", BankCode: "IDR_553", BankName: "Bank Mayora Indonesia" },
    { label: "IDR_555 (Bank Index Selindo)", value: "IDR_555 (Bank Index Selindo)", BankCode: "IDR_555", BankName: "Bank Index Selindo" },
    { label: "IDR_558 (Bank Eksekutif)", value: "IDR_558 (Bank Eksekutif)", BankCode: "IDR_558", BankName: "Bank Eksekutif" },
    { label: "IDR_559 (Centratama Nasional Bank)", value: "IDR_559 (Centratama Nasional Bank)", BankCode: "IDR_559", BankName: "Centratama Nasional Bank" },
    { label: "IDR_562 (Bank Fama Internasional)", value: "IDR_562 (Bank Fama Internasional)", BankCode: "IDR_562", BankName: "Bank Fama Internasional" },
    { label: "IDR_564 (Bank Sinar Harapan Bali / Bank Mandiri Taspen Pos)", value: "IDR_564 (Bank Sinar Harapan Bali / Bank Mandiri Taspen Pos)", BankCode: "IDR_564", BankName: "Bank Sinar Harapan Bali / Bank Mandiri Taspen Pos" },
    { label: "IDR_566 (Bank Victoria Internasional)", value: "IDR_566 (Bank Victoria Internasional)", BankCode: "IDR_566", BankName: "Bank Victoria Internasional" },
    { label: "IDR_567 (Bank Harda Internasional)", value: "IDR_567 (Bank Harda Internasional)", BankCode: "IDR_567", BankName: "Bank Harda Internasional" },
    { label: "IDR_688 (BPR KS (Karyajatnika Sedaya))", value: "IDR_688 (BPR KS (Karyajatnika Sedaya))", BankCode: "IDR_688", BankName: "BPR KS (Karyajatnika Sedaya)" },
    { label: "IDR_770 (ALTO Pay)", value: "IDR_770 (ALTO Pay)", BankCode: "IDR_770", BankName: "ALTO Pay" },
    { label: "IDR_775 (SGDO Pay)", value: "IDR_775 (SGDO Pay)", BankCode: "IDR_775", BankName: "SGDO Pay" },
    { label: "IDR_777 (Finnet)", value: "IDR_777 (Finnet)", BankCode: "IDR_777", BankName: "Finnet" },
    { label: "IDR_778 (Bank DKI UUS)", value: "IDR_778 (Bank DKI UUS)", BankCode: "IDR_778", BankName: "Bank DKI UUS" },
    { label: "IDR_789 (Indosat (dompetku))", value: "IDR_789 (Indosat (dompetku))", BankCode: "IDR_789", BankName: "Indosat (dompetku)" },
    { label: "IDR_867 (Bank Eka Bumi Artha)", value: "IDR_867 (Bank Eka Bumi Artha)", BankCode: "IDR_867", BankName: "Bank Eka Bumi Artha" },
    { label: "IDR_899 (Doku)", value: "IDR_899 (Doku)", BankCode: "IDR_899", BankName: "Doku" },
    { label: "IDR_911 (Linkaja / Telcomsel (Tcash))", value: "IDR_911 (Linkaja / Telcomsel (Tcash))", BankCode: "IDR_911", BankName: "Linkaja / Telcomsel (Tcash)" },
    { label: "IDR_945 (IBK Bank Indonesia / Bank Finconesia)", value: "IDR_945 (IBK Bank Indonesia / Bank Finconesia)", BankCode: "IDR_945", BankName: "IBK Bank Indonesia / Bank Finconesia" },
    { label: "IDR_946 (Bank Merincorp)", value: "IDR_946 (Bank Merincorp)", BankCode: "IDR_946", BankName: "Bank Merincorp" },
    { label: "IDR_947 (Bank Maybank Syariah Indonesia)", value: "IDR_947 (Bank Maybank Syariah Indonesia)", BankCode: "IDR_947", BankName: "Bank Maybank Syariah Indonesia" },
    { label: "IDR_948 (Bank OCBC Indonesia)", value: "IDR_948 (Bank OCBC Indonesia)", BankCode: "IDR_948", BankName: "Bank OCBC Indonesia" },
    { label: "IDR_949 (Bank CTBC Indonesia)", value: "IDR_949 (Bank CTBC Indonesia)", BankCode: "IDR_949", BankName: "Bank CTBC Indonesia" },
    { label: "IDR_950 (Bank Commonwealth)", value: "IDR_950 (Bank Commonwealth)", BankCode: "IDR_950", BankName: "Bank Commonwealth" },
    { label: "ALHB (Allahabad Bank)", value: "ALHB (Allahabad Bank)", BankCode: "ALHB", BankName: "Allahabad Bank" },
    { label: "ANDB (Andhra Bank)", value: "ANDB (Andhra Bank)", BankCode: "ANDB", BankName: "Andhra Bank" },
    { label: "AXIS (Axis Bank)", value: "AXIS (Axis Bank)", BankCode: "AXIS", BankName: "Axis Bank" },
    { label: "BOIN (Bank of India)", value: "BOIN (Bank of India)", BankCode: "BOIN", BankName: "Bank of India" },
    { label: "BRDA (Bank of Baroda)", value: "BRDA (Bank of Baroda)", BankCode: "BRDA", BankName: "Bank of Baroda" },
    { label: "CANBK (Canara Bank)", value: "CANBK (Canara Bank)", BankCode: "CANBK", BankName: "Canara Bank" },
    { label: "CBOI (Central Bank of India)", value: "CBOI (Central Bank of India)", BankCode: "CBOI", BankName: "Central Bank of India" },
    { label: "CITI (Citi Bank)", value: "CITI (Citi Bank)", BankCode: "CITI", BankName: "Citi Bank" },
    { label: "CORB (Corporation Bank)", value: "CORB (Corporation Bank)", BankCode: "CORB", BankName: "Corporation Bank" },
    { label: "CSYB (Catholic Syrian Bank)", value: "CSYB (Catholic Syrian Bank)", BankCode: "CSYB", BankName: "Catholic Syrian Bank" },
    { label: "DENB (Dena Bank)", value: "DENB (Dena Bank)", BankCode: "DENB", BankName: "Dena Bank" },
    { label: "DNLM (Dhanlaxmi Bank)", value: "DNLM (Dhanlaxmi Bank)", BankCode: "DNLM", BankName: "Dhanlaxmi Bank" },
    { label: "FEDB (Federal Bank)", value: "FEDB (Federal Bank)", BankCode: "FEDB", BankName: "Federal Bank" },
    { label: "HDFC (HDFC Bank)", value: "HDFC (HDFC Bank)", BankCode: "HDFC", BankName: "HDFC Bank" },
    { label: "ICICI (ICICI Bank)", value: "ICICI (ICICI Bank)", BankCode: "ICICI", BankName: "ICICI Bank" },
    { label: "IDBI (IDBI Bank)", value: "IDBI (IDBI Bank)", BankCode: "IDBI", BankName: "IDBI Bank" },
    { label: "INDNB (Indian Bank)", value: "INDNB (Indian Bank)", BankCode: "INDNB", BankName: "Indian Bank" },
    { label: "INDU (IndusInd Bank)", value: "INDU (IndusInd Bank)", BankCode: "INDU", BankName: "IndusInd Bank" },
    { label: "INOB (Indian Overseas Bank)", value: "INOB (Indian Overseas Bank)", BankCode: "INOB", BankName: "Indian Overseas Bank" },
    { label: "IN_APGVB (Andhra Pradesh Grameena Vikas Bank)", value: "IN_APGVB (Andhra Pradesh Grameena Vikas Bank)", BankCode: "IN_APGVB", BankName: "Andhra Pradesh Grameena Vikas Bank" },
    { label: "IN_CUB (City Union Bank)", value: "IN_CUB (City Union Bank)", BankCode: "IN_CUB", BankName: "City Union Bank" },
    { label: "IN_HSBC (Hongkong and Shanghai Banking Corporation Limited India)", value: "IN_HSBC (Hongkong and Shanghai Banking Corporation Limited India)", BankCode: "IN_HSBC", BankName: "Hongkong and Shanghai Banking Corporation Limited India" },
    { label: "IN_IDFC (IDFC First Bank)", value: "IN_IDFC (IDFC First Bank)", BankCode: "IN_IDFC", BankName: "IDFC First Bank" },
    { label: "IN_KVB (Karur Vysya Bank)", value: "IN_KVB (Karur Vysya Bank)", BankCode: "IN_KVB", BankName: "Karur Vysya Bank" },
    { label: "IN_LVB (Lakshmi Vilas Bank)", value: "IN_LVB (Lakshmi Vilas Bank)", BankCode: "IN_LVB", BankName: "Lakshmi Vilas Bank" },
    { label: "IN_PMCB (Punjab and Maharashtra Co-operative Bank Limited)", value: "IN_PMCB (Punjab and Maharashtra Co-operative Bank Limited)", BankCode: "IN_PMCB", BankName: "Punjab and Maharashtra Co-operative Bank Limited" },
    { label: "IN_USFB (Ujjivan Small Finance Bank)", value: "IN_USFB (Ujjivan Small Finance Bank)", BankCode: "IN_USFB", BankName: "Ujjivan Small Finance Bank" },
    { label: "JAKB (Jammu and Kashmir Bank)", value: "JAKB (Jammu and Kashmir Bank)", BankCode: "JAKB", BankName: "Jammu and Kashmir Bank" },
    { label: "KARBK (Karnataka Bank)", value: "KARBK (Karnataka Bank)", BankCode: "KARBK", BankName: "Karnataka Bank" },
    { label: "KOTBK (Kotak Mahindra Bank)", value: "KOTBK (Kotak Mahindra Bank)", BankCode: "KOTBK", BankName: "Kotak Mahindra Bank" },
    { label: "MHRT (Bank of Maharashtra)", value: "MHRT (Bank of Maharashtra)", BankCode: "MHRT", BankName: "Bank of Maharashtra" },
    { label: "OBOC (Oriental Bank of Commerce)", value: "OBOC (Oriental Bank of Commerce)", BankCode: "OBOC", BankName: "Oriental Bank of Commerce" },
    { label: "PASB (Punjab and Sind Bank)", value: "PASB (Punjab and Sind Bank)", BankCode: "PASB", BankName: "Punjab and Sind Bank" },
    { label: "PNJB (Punjab National Bank)", value: "PNJB (Punjab National Bank)", BankCode: "PNJB", BankName: "Punjab National Bank" },
    { label: "SBBJ (State Bank of Bikaner and Jaipur)", value: "SBBJ (State Bank of Bikaner and Jaipur)", BankCode: "SBBJ", BankName: "State Bank of Bikaner and Jaipur" },
    { label: "SBIN (State Bank)", value: "SBIN (State Bank)", BankCode: "SBIN", BankName: "State Bank" },
    { label: "SBOH (State Bank of Hyderabad)", value: "SBOH (State Bank of Hyderabad)", BankCode: "SBOH", BankName: "State Bank of Hyderabad" },
    { label: "SBOT (State Bank of Travancore)", value: "SBOT (State Bank of Travancore)", BankCode: "SBOT", BankName: "State Bank of Travancore" },
    { label: "SCTRD (Standard Chartered Bank)", value: "SCTRD (Standard Chartered Bank)", BankCode: "SCTRD", BankName: "Standard Chartered Bank" },
    { label: "SIBK (South Indian Bank)", value: "SIBK (South Indian Bank)", BankCode: "SIBK", BankName: "South Indian Bank" },
    { label: "SYNB (Syndicate Bank)", value: "SYNB (Syndicate Bank)", BankCode: "SYNB", BankName: "Syndicate Bank" },
    { label: "TAMB (Tamilnadu Mercantile Bank)", value: "TAMB (Tamilnadu Mercantile Bank)", BankCode: "TAMB", BankName: "Tamilnadu Mercantile Bank" },
    { label: "UCOB (UCO Bank)", value: "UCOB (UCO Bank)", BankCode: "UCOB", BankName: "UCO Bank" },
    { label: "UNBOI (Union Bank of India)", value: "UNBOI (Union Bank of India)", BankCode: "UNBOI", BankName: "Union Bank of India" },
    { label: "VJYB (Vijaya Bank)", value: "VJYB (Vijaya Bank)", BankCode: "VJYB", BankName: "Vijaya Bank" },
    { label: "YESB (YES Bank)", value: "YESB (YES Bank)", BankCode: "YESB", BankName: "YES Bank" },
    { label: "JP_BOF (Bank of Fukuoka)", value: "JP_BOF (Bank of Fukuoka)", BankCode: "JP_BOF", BankName: "Bank of Fukuoka" },
    { label: "JP_BOY (Bank of Yokohama)", value: "JP_BOY (Bank of Yokohama)", BankCode: "JP_BOY", BankName: "Bank of Yokohama" },
    { label: "JP_CBB (Chiba Bank)", value: "JP_CBB (Chiba Bank)", BankCode: "JP_CBB", BankName: "Chiba Bank" },
    { label: "JP_HKB (Hokkaido Bank)", value: "JP_HKB (Hokkaido Bank)", BankCode: "JP_HKB", BankName: "Hokkaido Bank" },
    { label: "JP_HNB (Higashi-Nippon Bank)", value: "JP_HNB (Higashi-Nippon Bank)", BankCode: "JP_HNB", BankName: "Higashi-Nippon Bank" },
    { label: "JP_HRB (Hokuriku Bank)", value: "JP_HRB (Hokuriku Bank)", BankCode: "JP_HRB", BankName: "Hokuriku Bank" },
    { label: "JP_JPB (Japan Post Bank)", value: "JP_JPB (Japan Post Bank)", BankCode: "JP_JPB", BankName: "Japan Post Bank" },
    { label: "JP_KMB (Kansai Mirai Bank Ltd)", value: "JP_KMB (Kansai Mirai Bank Ltd)", BankCode: "JP_KMB", BankName: "Kansai Mirai Bank Ltd" },
    { label: "JP_MNB (Minna Bank)", value: "JP_MNB (Minna Bank)", BankCode: "JP_MNB", BankName: "Minna Bank" },
    { label: "JP_MUFG (MUFG Bank)", value: "JP_MUFG (MUFG Bank)", BankCode: "JP_MUFG", BankName: "MUFG Bank" },
    { label: "JP_MZB (Mizuho Bank)", value: "JP_MZB (Mizuho Bank)", BankCode: "JP_MZB", BankName: "Mizuho Bank" },
    { label: "JP_RSB (Resona Bank)", value: "JP_RSB (Resona Bank)", BankCode: "JP_RSB", BankName: "Resona Bank" },
    { label: "JP_SMFC (Sumitomo Mitsui Banking Corporation)", value: "JP_SMFC (Sumitomo Mitsui Banking Corporation)", BankCode: "JP_SMFC", BankName: "Sumitomo Mitsui Banking Corporation" },
    { label: "JP_TJSB (The Juhachi-Shinwa Bank Ltd)", value: "JP_TJSB (The Juhachi-Shinwa Bank Ltd)", BankCode: "JP_TJSB", BankName: "The Juhachi-Shinwa Bank Ltd" },
    { label: "JP_TKB (The Kumamoto Bank Ltd)", value: "JP_TKB (The Kumamoto Bank Ltd)", BankCode: "JP_TKB", BankName: "The Kumamoto Bank Ltd" },
    { label: "JP_TNB (The Norinchukin Bank)", value: "JP_TNB (The Norinchukin Bank)", BankCode: "JP_TNB", BankName: "The Norinchukin Bank" },
    { label: "KR_BANKOFCOREA (Bank of Korea)", value: "KR_BANKOFCOREA (Bank of Korea)", BankCode: "KR_BANKOFCOREA", BankName: "Bank of Korea" },
    { label: "KR_BNK (Busan Bank)", value: "KR_BNK (Busan Bank)", BankCode: "KR_BNK", BankName: "Busan Bank" },
    { label: "KR_CTK (Citibank Korea)", value: "KR_CTK (Citibank Korea)", BankCode: "KR_CTK", BankName: "Citibank Korea" },
    { label: "KR_DGB (DAEGU Bank)", value: "KR_DGB (DAEGU Bank)", BankCode: "KR_DGB", BankName: "DAEGU Bank" },
    { label: "KR_HBG (KEB Hana Bank)", value: "KR_HBG (KEB Hana Bank)", BankCode: "KR_HBG", BankName: "KEB Hana Bank" },
    { label: "KR_IBK (Industrial Bank of Korea)", value: "KR_IBK (Industrial Bank of Korea)", BankCode: "KR_IBK", BankName: "Industrial Bank of Korea" },
    { label: "KR_KDB (Korea Development Bank)", value: "KR_KDB (Korea Development Bank)", BankCode: "KR_KDB", BankName: "Korea Development Bank" },
    { label: "KR_KKB (KB Kookmin Bank)", value: "KR_KKB (KB Kookmin Bank)", BankCode: "KR_KKB", BankName: "KB Kookmin Bank" },
    { label: "KR_KWB (Kwangju Bank)", value: "KR_KWB (Kwangju Bank)", BankCode: "KR_KWB", BankName: "Kwangju Bank" },
    { label: "KR_NOB (Nonghyup Bank)", value: "KR_NOB (Nonghyup Bank)", BankCode: "KR_NOB", BankName: "Nonghyup Bank" },
    { label: "KR_SHB (Shinhan Bank)", value: "KR_SHB (Shinhan Bank)", BankCode: "KR_SHB", BankName: "Shinhan Bank" },
    { label: "KR_WOB (Woori Bank)", value: "KR_WOB (Woori Bank)", BankCode: "KR_WOB", BankName: "Woori Bank" },
    { label: "MY_AMB (AmBank)", value: "MY_AMB (AmBank)", BankCode: "MY_AMB", BankName: "AmBank" },
    { label: "MY_CIMB (CIMB Bank)", value: "MY_CIMB (CIMB Bank)", BankCode: "MY_CIMB", BankName: "CIMB Bank" },
    { label: "MY_HLB (Hong Leong Bank)", value: "MY_HLB (Hong Leong Bank)", BankCode: "MY_HLB", BankName: "Hong Leong Bank" },
    { label: "MY_HSBC (HSBC Bank)", value: "MY_HSBC (HSBC Bank)", BankCode: "MY_HSBC", BankName: "HSBC Bank" },
    { label: "MY_MAYB (Maybank)", value: "MY_MAYB (Maybank)", BankCode: "MY_MAYB", BankName: "Maybank" },
    { label: "MY_OCBC (OCBC Bank)", value: "MY_OCBC (OCBC Bank)", BankCode: "MY_OCBC", BankName: "OCBC Bank" },
    { label: "MY_PUBLIC (Public Bank)", value: "MY_PUBLIC (Public Bank)", BankCode: "MY_PUBLIC", BankName: "Public Bank" },
    { label: "MY_RHB (RHB Bank)", value: "MY_RHB (RHB Bank)", BankCode: "MY_RHB", BankName: "RHB Bank" },
    { label: "MY_UOBIB (United Overseas Bank (UOB))", value: "MY_UOBIB (United Overseas Bank (UOB))", BankCode: "MY_UOBIB", BankName: "United Overseas Bank (UOB)" },
    { label: "TH_BANGKOK (Bangkok Bank)", value: "TH_BANGKOK (Bangkok Bank)", BankCode: "TH_BANGKOK", BankName: "Bangkok Bank" },
    { label: "TH_CIMB (CIMB THAI Bank)", value: "TH_CIMB (CIMB THAI Bank)", BankCode: "TH_CIMB", BankName: "CIMB THAI Bank" },
    { label: "TH_GOVERNMENTSAVINGS (Government Savings Bank)", value: "TH_GOVERNMENTSAVINGS (Government Savings Bank)", BankCode: "TH_GOVERNMENTSAVINGS", BankName: "Government Savings Bank" },
    { label: "TH_KASIKORN (Kasikorn Bank)", value: "TH_KASIKORN (Kasikorn Bank)", BankCode: "TH_KASIKORN", BankName: "Kasikorn Bank" },
    { label: "TH_KRUNGSRI (Bank of Ayudhya (Krungsri))", value: "TH_KRUNGSRI (Bank of Ayudhya (Krungsri))", BankCode: "TH_KRUNGSRI", BankName: "Bank of Ayudhya (Krungsri)" },
    { label: "TH_KRUNGTHAI (Krungthai Bank)", value: "TH_KRUNGTHAI (Krungthai Bank)", BankCode: "TH_KRUNGTHAI", BankName: "Krungthai Bank" },
    { label: "TH_SIAM (Siam Commercial Bank)", value: "TH_SIAM (Siam Commercial Bank)", BankCode: "TH_SIAM", BankName: "Siam Commercial Bank" },
    { label: "TH_TTBDIRECT (TMBThanachart Bank (ttb))", value: "TH_TTBDIRECT (TMBThanachart Bank (ttb))", BankCode: "TH_TTBDIRECT", BankName: "TMBThanachart Bank (ttb)" },
    { label: "TH_UOBT (United Overseas Bank (UOB))", value: "TH_UOBT (United Overseas Bank (UOB))", BankCode: "TH_UOBT", BankName: "United Overseas Bank (UOB))" },
    { label: "VN_ACB (Asia Commercial Bank)", value: "VN_ACB (Asia Commercial Bank)", BankCode: "VN_ACB", BankName: "Asia Commercial Bank" },
    { label: "VN_BIDV (BIDV)", value: "VN_BIDV (BIDV)", BankCode: "VN_BIDV", BankName: "BIDV" },
    { label: "VN_DONGA (DongA Bank)", value: "VN_DONGA (DongA Bank)", BankCode: "VN_DONGA", BankName: "DongA Bank" },
    { label: "VN_EXIM (Eximbank)", value: "VN_EXIM (Eximbank)", BankCode: "VN_EXIM", BankName: "Eximbank" },
    { label: "VN_SACOM (Sacombank)", value: "VN_SACOM (Sacombank)", BankCode: "VN_SACOM", BankName: "Sacombank" },
    { label: "VN_TECHCOM (Techcombank)", value: "VN_TECHCOM (Techcombank)", BankCode: "VN_TECHCOM", BankName: "Techcombank" },
    { label: "VN_TP (TPBank)", value: "VN_TP (TPBank)", BankCode: "VN_TP", BankName: "TPBank" },
    { label: "VN_VIETCOM (Vietcombank)", value: "VN_VIETCOM (Vietcombank)", BankCode: "VN_VIETCOM", BankName: "Vietcombank" },
    { label: "VN_VIETIN (VietinBank)", value: "VN_VIETIN (VietinBank)", BankCode: "VN_VIETIN", BankName: "VietinBank" },
    { label: "VN_VP (VPBank)", value: "VN_VP (VPBank)", BankCode: "VN_VP", BankName: "VPBank" },
];
export const BRIDGER_PAYMENT_OPERATOR_CODE_DICT: any = {
    "CN_ABC (Agricultural Bank of China)": {
        "label": "CN_ABC (Agricultural Bank of China)",
        "value": "CN_ABC (Agricultural Bank of China)"
    },
    "CN_BCOM (Bank of Communications)": {
        "label": "CN_BCOM (Bank of Communications)",
        "value": "CN_BCOM (Bank of Communications)"
    },
    "CN_BOC (Bank of China)": {
        "label": "CN_BOC (Bank of China)",
        "value": "CN_BOC (Bank of China)"
    },
    "CN_CCB (China Construction Bank)": {
        "label": "CN_CCB (China Construction Bank)",
        "value": "CN_CCB (China Construction Bank)"
    },
    "CN_CEB (China Everbright Bank)": {
        "label": "CN_CEB (China Everbright Bank)",
        "value": "CN_CEB (China Everbright Bank)"
    },
    "CN_CGB (China Guangfa Bank)": {
        "label": "CN_CGB (China Guangfa Bank)",
        "value": "CN_CGB (China Guangfa Bank)"
    },
    "CN_CIB (China Industrial Bank)": {
        "label": "CN_CIB (China Industrial Bank)",
        "value": "CN_CIB (China Industrial Bank)"
    },
    "CN_CITIC (China CITIC Bank)": {
        "label": "CN_CITIC (China CITIC Bank)",
        "value": "CN_CITIC (China CITIC Bank)"
    },
    "CN_CMB (China Merchants Bank)": {
        "label": "CN_CMB (China Merchants Bank)",
        "value": "CN_CMB (China Merchants Bank)"
    },
    "CN_CMBC (China Minsheng Bank)": {
        "label": "CN_CMBC (China Minsheng Bank)",
        "value": "CN_CMBC (China Minsheng Bank)"
    },
    "CN_ICBC (Industrial and Commercial Bank of China)": {
        "label": "CN_ICBC (Industrial and Commercial Bank of China)",
        "value": "CN_ICBC (Industrial and Commercial Bank of China)"
    },
    "CN_PAB (Ping An Bank)": {
        "label": "CN_PAB (Ping An Bank)",
        "value": "CN_PAB (Ping An Bank)"
    },
    "CN_PSBC (Postal Savings Bank of China)": {
        "label": "CN_PSBC (Postal Savings Bank of China)",
        "value": "CN_PSBC (Postal Savings Bank of China)"
    },
    "CN_SPDB (Shanghai Pudong Development Bank)": {
        "label": "CN_SPDB (Shanghai Pudong Development Bank)",
        "value": "CN_SPDB (Shanghai Pudong Development Bank)"
    },
    "IDR_002 (Bank Rakyat Indonesia (BRI))": {
        "label": "IDR_002 (Bank Rakyat Indonesia (BRI))",
        "value": "IDR_002 (Bank Rakyat Indonesia (BRI))"
    },
    "IDR_003 (Bank Ekspor Indonesia)": {
        "label": "IDR_003 (Bank Ekspor Indonesia)",
        "value": "IDR_003 (Bank Ekspor Indonesia)"
    },
    "IDR_008 (Bank Mandiri)": {
        "label": "IDR_008 (Bank Mandiri)",
        "value": "IDR_008 (Bank Mandiri)"
    },
    "IDR_009 (Bank Negara Indonesia (BNI))": {
        "label": "IDR_009 (Bank Negara Indonesia (BNI))",
        "value": "IDR_009 (Bank Negara Indonesia (BNI))"
    },
    "IDR_011 (Bank Danamon)": {
        "label": "IDR_011 (Bank Danamon)",
        "value": "IDR_011 (Bank Danamon)"
    },
    "IDR_013 (Bank Permata)": {
        "label": "IDR_013 (Bank Permata)",
        "value": "IDR_013 (Bank Permata)"
    },
    "IDR_014 (Bank Central Asia (BCA))": {
        "label": "IDR_014 (Bank Central Asia (BCA))",
        "value": "IDR_014 (Bank Central Asia (BCA))"
    },
    "IDR_016 (Maybank Indonesia)": {
        "label": "IDR_016 (Maybank Indonesia)",
        "value": "IDR_016 (Maybank Indonesia)"
    },
    "IDR_019 (Bank Panin)": {
        "label": "IDR_019 (Bank Panin)",
        "value": "IDR_019 (Bank Panin)"
    },
    "IDR_020 (Bank Arta Niaga Kencana)": {
        "label": "IDR_020 (Bank Arta Niaga Kencana)",
        "value": "IDR_020 (Bank Arta Niaga Kencana)"
    },
    "IDR_022 (Bank CIMB Niaga)": {
        "label": "IDR_022 (Bank CIMB Niaga)",
        "value": "IDR_022 (Bank CIMB Niaga)"
    },
    "IDR_023 (Bank UOB Indonesia / Bank Buana Indonesia)": {
        "label": "IDR_023 (Bank UOB Indonesia / Bank Buana Indonesia)",
        "value": "IDR_023 (Bank UOB Indonesia / Bank Buana Indonesia)"
    },
    "IDR_026 (Bank Lippo)": {
        "label": "IDR_026 (Bank Lippo)",
        "value": "IDR_026 (Bank Lippo)"
    },
    "IDR_028 (Bank OCBC NISP)": {
        "label": "IDR_028 (Bank OCBC NISP)",
        "value": "IDR_028 (Bank OCBC NISP)"
    },
    "IDR_030 (American Express Bank LTD)": {
        "label": "IDR_030 (American Express Bank LTD)",
        "value": "IDR_030 (American Express Bank LTD)"
    },
    "IDR_031 (Citibank Indonesia)": {
        "label": "IDR_031 (Citibank Indonesia)",
        "value": "IDR_031 (Citibank Indonesia)"
    },
    "IDR_032 (JP Morgan Chase Bank N.A.)": {
        "label": "IDR_032 (JP Morgan Chase Bank N.A.)",
        "value": "IDR_032 (JP Morgan Chase Bank N.A.)"
    },
    "IDR_033 (Bank of America N.A.)": {
        "label": "IDR_033 (Bank of America N.A.)",
        "value": "IDR_033 (Bank of America N.A.)"
    },
    "IDR_034 (ING Indonesia Bank)": {
        "label": "IDR_034 (ING Indonesia Bank)",
        "value": "IDR_034 (ING Indonesia Bank)"
    },
    "IDR_036 (Bank Multicor / Bank CCB Indonesia)": {
        "label": "IDR_036 (Bank Multicor / Bank CCB Indonesia)",
        "value": "IDR_036 (Bank Multicor / Bank CCB Indonesia)"
    },
    "IDR_037 (Bank Artha Graha Internasional)": {
        "label": "IDR_037 (Bank Artha Graha Internasional)",
        "value": "IDR_037 (Bank Artha Graha Internasional)"
    },
    "IDR_039 (Bank Credit Agricole Indosuez)": {
        "label": "IDR_039 (Bank Credit Agricole Indosuez)",
        "value": "IDR_039 (Bank Credit Agricole Indosuez)"
    },
    "IDR_040 (Bangkok Bank)": {
        "label": "IDR_040 (Bangkok Bank)",
        "value": "IDR_040 (Bangkok Bank)"
    },
    "IDR_041 (Bank HSBC Indonesia)": {
        "label": "IDR_041 (Bank HSBC Indonesia)",
        "value": "IDR_041 (Bank HSBC Indonesia)"
    },
    "IDR_042 (Bank of Tokyo/MUFG Bank/Mitsubishi UFJ LTD)": {
        "label": "IDR_042 (Bank of Tokyo/MUFG Bank/Mitsubishi UFJ LTD)",
        "value": "IDR_042 (Bank of Tokyo/MUFG Bank/Mitsubishi UFJ LTD)"
    },
    "IDR_045 (Bank Sumitomo Mitsui Indonesia)": {
        "label": "IDR_045 (Bank Sumitomo Mitsui Indonesia)",
        "value": "IDR_045 (Bank Sumitomo Mitsui Indonesia)"
    },
    "IDR_046 (Bank DBS Indonesia)": {
        "label": "IDR_046 (Bank DBS Indonesia)",
        "value": "IDR_046 (Bank DBS Indonesia)"
    },
    "IDR_047 (Bank Resona Perdania)": {
        "label": "IDR_047 (Bank Resona Perdania)",
        "value": "IDR_047 (Bank Resona Perdania)"
    },
    "IDR_048 (Bank Mizuho Indonesia)": {
        "label": "IDR_048 (Bank Mizuho Indonesia)",
        "value": "IDR_048 (Bank Mizuho Indonesia)"
    },
    "IDR_050 (Standard Chartered Bank)": {
        "label": "IDR_050 (Standard Chartered Bank)",
        "value": "IDR_050 (Standard Chartered Bank)"
    },
    "IDR_052 (Bank ABN Amro)": {
        "label": "IDR_052 (Bank ABN Amro)",
        "value": "IDR_052 (Bank ABN Amro)"
    },
    "IDR_053 (Bank Keppel Tatlee Buana)": {
        "label": "IDR_053 (Bank Keppel Tatlee Buana)",
        "value": "IDR_053 (Bank Keppel Tatlee Buana)"
    },
    "IDR_054 (Bank Capital Indonesia)": {
        "label": "IDR_054 (Bank Capital Indonesia)",
        "value": "IDR_054 (Bank Capital Indonesia)"
    },
    "IDR_057 (Bank BNP Paribas Indonesia)": {
        "label": "IDR_057 (Bank BNP Paribas Indonesia)",
        "value": "IDR_057 (Bank BNP Paribas Indonesia)"
    },
    "IDR_059 (Korea Exchange Bank Danamon)": {
        "label": "IDR_059 (Korea Exchange Bank Danamon)",
        "value": "IDR_059 (Korea Exchange Bank Danamon)"
    },
    "IDR_060 (Bank Rabobank International Indonesia)": {
        "label": "IDR_060 (Bank Rabobank International Indonesia)",
        "value": "IDR_060 (Bank Rabobank International Indonesia)"
    },
    "IDR_061 (Bank ANZ Indonesia)": {
        "label": "IDR_061 (Bank ANZ Indonesia)",
        "value": "IDR_061 (Bank ANZ Indonesia)"
    },
    "IDR_067 (Deutsche Bank)": {
        "label": "IDR_067 (Deutsche Bank)",
        "value": "IDR_067 (Deutsche Bank)"
    },
    "IDR_068 (Bank Woori Saudara)": {
        "label": "IDR_068 (Bank Woori Saudara)",
        "value": "IDR_068 (Bank Woori Saudara)"
    },
    "IDR_069 (Bank of China)": {
        "label": "IDR_069 (Bank of China)",
        "value": "IDR_069 (Bank of China)"
    },
    "IDR_076 (Bank Bumi Arta)": {
        "label": "IDR_076 (Bank Bumi Arta)",
        "value": "IDR_076 (Bank Bumi Arta)"
    },
    "IDR_087 (Bank Ekonomi Raharja)": {
        "label": "IDR_087 (Bank Ekonomi Raharja)",
        "value": "IDR_087 (Bank Ekonomi Raharja)"
    },
    "IDR_088 (Bank Antardaerah)": {
        "label": "IDR_088 (Bank Antardaerah)",
        "value": "IDR_088 (Bank Antardaerah)"
    },
    "IDR_089 (Bank Haga)": {
        "label": "IDR_089 (Bank Haga)",
        "value": "IDR_089 (Bank Haga)"
    },
    "IDR_093 (Bank IFI)": {
        "label": "IDR_093 (Bank IFI)",
        "value": "IDR_093 (Bank IFI)"
    },
    "IDR_095 (J Trust Bank / Bank Jtrust Indonesia)": {
        "label": "IDR_095 (J Trust Bank / Bank Jtrust Indonesia)",
        "value": "IDR_095 (J Trust Bank / Bank Jtrust Indonesia)"
    },
    "IDR_097 (Bank Mayapada)": {
        "label": "IDR_097 (Bank Mayapada)",
        "value": "IDR_097 (Bank Mayapada)"
    },
    "IDR_110 (Bank Jabar / Bank BJB)": {
        "label": "IDR_110 (Bank Jabar / Bank BJB)",
        "value": "IDR_110 (Bank Jabar / Bank BJB)"
    },
    "IDR_111 (Bank DKI)": {
        "label": "IDR_111 (Bank DKI)",
        "value": "IDR_111 (Bank DKI)"
    },
    "IDR_112 (BPD Daerah Istimewa Yogyakarta (DIY))": {
        "label": "IDR_112 (BPD Daerah Istimewa Yogyakarta (DIY))",
        "value": "IDR_112 (BPD Daerah Istimewa Yogyakarta (DIY))"
    },
    "IDR_113 (BPD Jawa Tengah)": {
        "label": "IDR_113 (BPD Jawa Tengah)",
        "value": "IDR_113 (BPD Jawa Tengah)"
    },
    "IDR_114 (BPD Jawa Timur)": {
        "label": "IDR_114 (BPD Jawa Timur)",
        "value": "IDR_114 (BPD Jawa Timur)"
    },
    "IDR_115 (BPD Jambi UUS)": {
        "label": "IDR_115 (BPD Jambi UUS)",
        "value": "IDR_115 (BPD Jambi UUS)"
    },
    "IDR_116 (Bank Aceh Syariah)": {
        "label": "IDR_116 (Bank Aceh Syariah)",
        "value": "IDR_116 (Bank Aceh Syariah)"
    },
    "IDR_117 (BPD Sumatra Utara)": {
        "label": "IDR_117 (BPD Sumatra Utara)",
        "value": "IDR_117 (BPD Sumatra Utara)"
    },
    "IDR_118 (Bank Nagari / Bank Sumbar)": {
        "label": "IDR_118 (Bank Nagari / Bank Sumbar)",
        "value": "IDR_118 (Bank Nagari / Bank Sumbar)"
    },
    "IDR_119 (BPD Riau Dan Kepri)": {
        "label": "IDR_119 (BPD Riau Dan Kepri)",
        "value": "IDR_119 (BPD Riau Dan Kepri)"
    },
    "IDR_120 (BPD Sumsel Dan Babel)": {
        "label": "IDR_120 (BPD Sumsel Dan Babel)",
        "value": "IDR_120 (BPD Sumsel Dan Babel)"
    },
    "IDR_121 (BPD Lampung)": {
        "label": "IDR_121 (BPD Lampung)",
        "value": "IDR_121 (BPD Lampung)"
    },
    "IDR_122 (BPD Kalimantan Selatan)": {
        "label": "IDR_122 (BPD Kalimantan Selatan)",
        "value": "IDR_122 (BPD Kalimantan Selatan)"
    },
    "IDR_123 (BPD Kalimantan Barat)": {
        "label": "IDR_123 (BPD Kalimantan Barat)",
        "value": "IDR_123 (BPD Kalimantan Barat)"
    },
    "IDR_124 (BPD Kalimantan Timur)": {
        "label": "IDR_124 (BPD Kalimantan Timur)",
        "value": "IDR_124 (BPD Kalimantan Timur)"
    },
    "IDR_125 (BPD Kalimantan Tengah)": {
        "label": "IDR_125 (BPD Kalimantan Tengah)",
        "value": "IDR_125 (BPD Kalimantan Tengah)"
    },
    "IDR_126 (Bank Sulawesi Selatan Dan Barat)": {
        "label": "IDR_126 (Bank Sulawesi Selatan Dan Barat)",
        "value": "IDR_126 (Bank Sulawesi Selatan Dan Barat)"
    },
    "IDR_127 (Bank Sulawesi Utara Dan Gorontalo)": {
        "label": "IDR_127 (Bank Sulawesi Utara Dan Gorontalo)",
        "value": "IDR_127 (Bank Sulawesi Utara Dan Gorontalo)"
    },
    "IDR_128 (BPD Nusa Tenggara Barat)": {
        "label": "IDR_128 (BPD Nusa Tenggara Barat)",
        "value": "IDR_128 (BPD Nusa Tenggara Barat)"
    },
    "IDR_129 (BPD Bali)": {
        "label": "IDR_129 (BPD Bali)",
        "value": "IDR_129 (BPD Bali)"
    },
    "IDR_130 (BPD Nusa Tenggara Timur)": {
        "label": "IDR_130 (BPD Nusa Tenggara Timur)",
        "value": "IDR_130 (BPD Nusa Tenggara Timur)"
    },
    "IDR_131 (Bank Maluku Malut)": {
        "label": "IDR_131 (Bank Maluku Malut)",
        "value": "IDR_131 (Bank Maluku Malut)"
    },
    "IDR_132 (Bank Papua)": {
        "label": "IDR_132 (Bank Papua)",
        "value": "IDR_132 (Bank Papua)"
    },
    "IDR_133 (BPD Bengkulu)": {
        "label": "IDR_133 (BPD Bengkulu)",
        "value": "IDR_133 (BPD Bengkulu)"
    },
    "IDR_134 (BPD Sulawesi Tengah)": {
        "label": "IDR_134 (BPD Sulawesi Tengah)",
        "value": "IDR_134 (BPD Sulawesi Tengah)"
    },
    "IDR_135 (BPD Sulawesi Tenggara)": {
        "label": "IDR_135 (BPD Sulawesi Tenggara)",
        "value": "IDR_135 (BPD Sulawesi Tenggara)"
    },
    "IDR_137 (BPD Banten)": {
        "label": "IDR_137 (BPD Banten)",
        "value": "IDR_137 (BPD Banten)"
    },
    "IDR_145 (Bank Nusantara Parahyangan / BNP)": {
        "label": "IDR_145 (Bank Nusantara Parahyangan / BNP)",
        "value": "IDR_145 (Bank Nusantara Parahyangan / BNP)"
    },
    "IDR_146 (Bank Swadesi (Bank of India Indonesia))": {
        "label": "IDR_146 (Bank Swadesi (Bank of India Indonesia))",
        "value": "IDR_146 (Bank Swadesi (Bank of India Indonesia))"
    },
    "IDR_147 (Bank Muamalat Indonesia)": {
        "label": "IDR_147 (Bank Muamalat Indonesia)",
        "value": "IDR_147 (Bank Muamalat Indonesia)"
    },
    "IDR_151 (Bank Mestika Dharma)": {
        "label": "IDR_151 (Bank Mestika Dharma)",
        "value": "IDR_151 (Bank Mestika Dharma)"
    },
    "IDR_152 (Bank Metro Express / Shinhan)": {
        "label": "IDR_152 (Bank Metro Express / Shinhan)",
        "value": "IDR_152 (Bank Metro Express / Shinhan)"
    },
    "IDR_153 (Bank Sinarmas)": {
        "label": "IDR_153 (Bank Sinarmas)",
        "value": "IDR_153 (Bank Sinarmas)"
    },
    "IDR_157 (Bank Maspion Indonesia)": {
        "label": "IDR_157 (Bank Maspion Indonesia)",
        "value": "IDR_157 (Bank Maspion Indonesia)"
    },
    "IDR_159 (Bank Hagakita)": {
        "label": "IDR_159 (Bank Hagakita)",
        "value": "IDR_159 (Bank Hagakita)"
    },
    "IDR_161 (Bank Ganesha)": {
        "label": "IDR_161 (Bank Ganesha)",
        "value": "IDR_161 (Bank Ganesha)"
    },
    "IDR_162 (Bank of Windu Kentjana)": {
        "label": "IDR_162 (Bank of Windu Kentjana)",
        "value": "IDR_162 (Bank of Windu Kentjana)"
    },
    "IDR_164 (Bank ICBC Indonesia)": {
        "label": "IDR_164 (Bank ICBC Indonesia)",
        "value": "IDR_164 (Bank ICBC Indonesia)"
    },
    "IDR_166 (Bank Harmoni International)": {
        "label": "IDR_166 (Bank Harmoni International)",
        "value": "IDR_166 (Bank Harmoni International)"
    },
    "IDR_167 (Bank QNB Indonesia)": {
        "label": "IDR_167 (Bank QNB Indonesia)",
        "value": "IDR_167 (Bank QNB Indonesia)"
    },
    "IDR_200 (Bank BTN)": {
        "label": "IDR_200 (Bank BTN)",
        "value": "IDR_200 (Bank BTN)"
    },
    "IDR_212 (Bank Himpunan Saudara 1906)": {
        "label": "IDR_212 (Bank Himpunan Saudara 1906)",
        "value": "IDR_212 (Bank Himpunan Saudara 1906)"
    },
    "IDR_213 (Bank BTPN)": {
        "label": "IDR_213 (Bank BTPN)",
        "value": "IDR_213 (Bank BTPN)"
    },
    "IDR_333 (Koperasi Intidana)": {
        "label": "IDR_333 (Koperasi Intidana)",
        "value": "IDR_333 (Koperasi Intidana)"
    },
    "IDR_405 (Bank Victoria Syariah / Bank Swaguna)": {
        "label": "IDR_405 (Bank Victoria Syariah / Bank Swaguna)",
        "value": "IDR_405 (Bank Victoria Syariah / Bank Swaguna)"
    },
    "IDR_422 (Bank BRI Syariah (BRIS))": {
        "label": "IDR_422 (Bank BRI Syariah (BRIS))",
        "value": "IDR_422 (Bank BRI Syariah (BRIS))"
    },
    "IDR_425 (Bank BJB Syariah)": {
        "label": "IDR_425 (Bank BJB Syariah)",
        "value": "IDR_425 (Bank BJB Syariah)"
    },
    "IDR_426 (Bank Mega)": {
        "label": "IDR_426 (Bank Mega)",
        "value": "IDR_426 (Bank Mega)"
    },
    "IDR_427 (Bank BNI Syariah)": {
        "label": "IDR_427 (Bank BNI Syariah)",
        "value": "IDR_427 (Bank BNI Syariah)"
    },
    "IDR_441 (Bank Bukopin)": {
        "label": "IDR_441 (Bank Bukopin)",
        "value": "IDR_441 (Bank Bukopin)"
    },
    "IDR_451 (Bank Syariah Indonesia (BSI))": {
        "label": "IDR_451 (Bank Syariah Indonesia (BSI))",
        "value": "IDR_451 (Bank Syariah Indonesia (BSI))"
    },
    "IDR_459 (Bank Bisnis Internasional)": {
        "label": "IDR_459 (Bank Bisnis Internasional)",
        "value": "IDR_459 (Bank Bisnis Internasional)"
    },
    "IDR_466 (Bank Sri Partha / Bank Andara)": {
        "label": "IDR_466 (Bank Sri Partha / Bank Andara)",
        "value": "IDR_466 (Bank Sri Partha / Bank Andara)"
    },
    "IDR_472 (Bank Jasa Jakarta)": {
        "label": "IDR_472 (Bank Jasa Jakarta)",
        "value": "IDR_472 (Bank Jasa Jakarta)"
    },
    "IDR_484 (Bank KEB Hana Indonesia / Bank Bintang Manunggal)": {
        "label": "IDR_484 (Bank KEB Hana Indonesia / Bank Bintang Manunggal)",
        "value": "IDR_484 (Bank KEB Hana Indonesia / Bank Bintang Manunggal)"
    },
    "IDR_485 (Bank MNC Internasional / Bank Bumiputera)": {
        "label": "IDR_485 (Bank MNC Internasional / Bank Bumiputera)",
        "value": "IDR_485 (Bank MNC Internasional / Bank Bumiputera)"
    },
    "IDR_490 (Bank Yudha Bhakti (BYB))": {
        "label": "IDR_490 (Bank Yudha Bhakti (BYB))",
        "value": "IDR_490 (Bank Yudha Bhakti (BYB))"
    },
    "IDR_491 (Bank Mitra Niaga)": {
        "label": "IDR_491 (Bank Mitra Niaga)",
        "value": "IDR_491 (Bank Mitra Niaga)"
    },
    "IDR_494 (Bank Agroniaga / Bank BRI Agro Niaga)": {
        "label": "IDR_494 (Bank Agroniaga / Bank BRI Agro Niaga)",
        "value": "IDR_494 (Bank Agroniaga / Bank BRI Agro Niaga)"
    },
    "IDR_498 (Bank SBI Indonesia / Bank Indo Monex)": {
        "label": "IDR_498 (Bank SBI Indonesia / Bank Indo Monex)",
        "value": "IDR_498 (Bank SBI Indonesia / Bank Indo Monex)"
    },
    "IDR_503 (Bank National NOBU / Bank Alfindo)": {
        "label": "IDR_503 (Bank National NOBU / Bank Alfindo)",
        "value": "IDR_503 (Bank National NOBU / Bank Alfindo)"
    },
    "IDR_506 (Bank Mega Syariah)": {
        "label": "IDR_506 (Bank Mega Syariah)",
        "value": "IDR_506 (Bank Mega Syariah)"
    },
    "IDR_513 (Bank Ina Perdana)": {
        "label": "IDR_513 (Bank Ina Perdana)",
        "value": "IDR_513 (Bank Ina Perdana)"
    },
    "IDR_517 (Panin Dubai Syariah Bank / Bank Harfa)": {
        "label": "IDR_517 (Panin Dubai Syariah Bank / Bank Harfa)",
        "value": "IDR_517 (Panin Dubai Syariah Bank / Bank Harfa)"
    },
    "IDR_520 (Prima Master Bank)": {
        "label": "IDR_520 (Prima Master Bank)",
        "value": "IDR_520 (Prima Master Bank)"
    },
    "IDR_521 (Bank Syariah Bukopin)": {
        "label": "IDR_521 (Bank Syariah Bukopin)",
        "value": "IDR_521 (Bank Syariah Bukopin)"
    },
    "IDR_523 (Bank Sahabat Sampoerna)": {
        "label": "IDR_523 (Bank Sahabat Sampoerna)",
        "value": "IDR_523 (Bank Sahabat Sampoerna)"
    },
    "IDR_525 (Bank Barclays / Bank Akita)": {
        "label": "IDR_525 (Bank Barclays / Bank Akita)",
        "value": "IDR_525 (Bank Barclays / Bank Akita)"
    },
    "IDR_526 (Bank Dinar / Liman International Bank)": {
        "label": "IDR_526 (Bank Dinar / Liman International Bank)",
        "value": "IDR_526 (Bank Dinar / Liman International Bank)"
    },
    "IDR_531 (Anglomas International Bank)": {
        "label": "IDR_531 (Anglomas International Bank)",
        "value": "IDR_531 (Anglomas International Bank)"
    },
    "IDR_535 (Bank Kesejahteraan Ekonomi)": {
        "label": "IDR_535 (Bank Kesejahteraan Ekonomi)",
        "value": "IDR_535 (Bank Kesejahteraan Ekonomi)"
    },
    "IDR_536 (Bank Central Asia (BCA) Syariah)": {
        "label": "IDR_536 (Bank Central Asia (BCA) Syariah)",
        "value": "IDR_536 (Bank Central Asia (BCA) Syariah)"
    },
    "IDR_542 (Bank Artos Indonesia)": {
        "label": "IDR_542 (Bank Artos Indonesia)",
        "value": "IDR_542 (Bank Artos Indonesia)"
    },
    "IDR_547 (BANK BTPN SYARIAH / BANK PURBA DANARTA)": {
        "label": "IDR_547 (BANK BTPN SYARIAH / BANK PURBA DANARTA)",
        "value": "IDR_547 (BANK BTPN SYARIAH / BANK PURBA DANARTA)"
    },
    "IDR_548 (Bank Multiarta Sentosa)": {
        "label": "IDR_548 (Bank Multiarta Sentosa)",
        "value": "IDR_548 (Bank Multiarta Sentosa)"
    },
    "IDR_553 (Bank Mayora Indonesia)": {
        "label": "IDR_553 (Bank Mayora Indonesia)",
        "value": "IDR_553 (Bank Mayora Indonesia)"
    },
    "IDR_555 (Bank Index Selindo)": {
        "label": "IDR_555 (Bank Index Selindo)",
        "value": "IDR_555 (Bank Index Selindo)"
    },
    "IDR_558 (Bank Eksekutif)": {
        "label": "IDR_558 (Bank Eksekutif)",
        "value": "IDR_558 (Bank Eksekutif)"
    },
    "IDR_559 (Centratama Nasional Bank)": {
        "label": "IDR_559 (Centratama Nasional Bank)",
        "value": "IDR_559 (Centratama Nasional Bank)"
    },
    "IDR_562 (Bank Fama Internasional)": {
        "label": "IDR_562 (Bank Fama Internasional)",
        "value": "IDR_562 (Bank Fama Internasional)"
    },
    "IDR_564 (Bank Sinar Harapan Bali / Bank Mandiri Taspen Pos)": {
        "label": "IDR_564 (Bank Sinar Harapan Bali / Bank Mandiri Taspen Pos)",
        "value": "IDR_564 (Bank Sinar Harapan Bali / Bank Mandiri Taspen Pos)"
    },
    "IDR_566 (Bank Victoria Internasional)": {
        "label": "IDR_566 (Bank Victoria Internasional)",
        "value": "IDR_566 (Bank Victoria Internasional)"
    },
    "IDR_567 (Bank Harda Internasional)": {
        "label": "IDR_567 (Bank Harda Internasional)",
        "value": "IDR_567 (Bank Harda Internasional)"
    },
    "IDR_688 (BPR KS (Karyajatnika Sedaya))": {
        "label": "IDR_688 (BPR KS (Karyajatnika Sedaya))",
        "value": "IDR_688 (BPR KS (Karyajatnika Sedaya))"
    },
    "IDR_770 (ALTO Pay)": {
        "label": "IDR_770 (ALTO Pay)",
        "value": "IDR_770 (ALTO Pay)"
    },
    "IDR_775 (SGDO Pay)": {
        "label": "IDR_775 (SGDO Pay)",
        "value": "IDR_775 (SGDO Pay)"
    },
    "IDR_777 (Finnet)": {
        "label": "IDR_777 (Finnet)",
        "value": "IDR_777 (Finnet)"
    },
    "IDR_778 (Bank DKI UUS)": {
        "label": "IDR_778 (Bank DKI UUS)",
        "value": "IDR_778 (Bank DKI UUS)"
    },
    "IDR_789 (Indosat (dompetku))": {
        "label": "IDR_789 (Indosat (dompetku))",
        "value": "IDR_789 (Indosat (dompetku))"
    },
    "IDR_867 (Bank Eka Bumi Artha)": {
        "label": "IDR_867 (Bank Eka Bumi Artha)",
        "value": "IDR_867 (Bank Eka Bumi Artha)"
    },
    "IDR_899 (Doku)": {
        "label": "IDR_899 (Doku)",
        "value": "IDR_899 (Doku)"
    },
    "IDR_911 (Linkaja / Telcomsel (Tcash))": {
        "label": "IDR_911 (Linkaja / Telcomsel (Tcash))",
        "value": "IDR_911 (Linkaja / Telcomsel (Tcash))"
    },
    "IDR_945 (IBK Bank Indonesia / Bank Finconesia)": {
        "label": "IDR_945 (IBK Bank Indonesia / Bank Finconesia)",
        "value": "IDR_945 (IBK Bank Indonesia / Bank Finconesia)"
    },
    "IDR_946 (Bank Merincorp)": {
        "label": "IDR_946 (Bank Merincorp)",
        "value": "IDR_946 (Bank Merincorp)"
    },
    "IDR_947 (Bank Maybank Syariah Indonesia)": {
        "label": "IDR_947 (Bank Maybank Syariah Indonesia)",
        "value": "IDR_947 (Bank Maybank Syariah Indonesia)"
    },
    "IDR_948 (Bank OCBC Indonesia)": {
        "label": "IDR_948 (Bank OCBC Indonesia)",
        "value": "IDR_948 (Bank OCBC Indonesia)"
    },
    "IDR_949 (Bank CTBC Indonesia)": {
        "label": "IDR_949 (Bank CTBC Indonesia)",
        "value": "IDR_949 (Bank CTBC Indonesia)"
    },
    "IDR_950 (Bank Commonwealth)": {
        "label": "IDR_950 (Bank Commonwealth)",
        "value": "IDR_950 (Bank Commonwealth)"
    },
    "ALHB (Allahabad Bank)": {
        "label": "ALHB (Allahabad Bank)",
        "value": "ALHB (Allahabad Bank)"
    },
    "ANDB (Andhra Bank)": {
        "label": "ANDB (Andhra Bank)",
        "value": "ANDB (Andhra Bank)"
    },
    "AXIS (Axis Bank)": {
        "label": "AXIS (Axis Bank)",
        "value": "AXIS (Axis Bank)"
    },
    "BOIN (Bank of India)": {
        "label": "BOIN (Bank of India)",
        "value": "BOIN (Bank of India)"
    },
    "BRDA (Bank of Baroda)": {
        "label": "BRDA (Bank of Baroda)",
        "value": "BRDA (Bank of Baroda)"
    },
    "CANBK (Canara Bank)": {
        "label": "CANBK (Canara Bank)",
        "value": "CANBK (Canara Bank)"
    },
    "CBOI (Central Bank of India)": {
        "label": "CBOI (Central Bank of India)",
        "value": "CBOI (Central Bank of India)"
    },
    "CITI (Citi Bank)": {
        "label": "CITI (Citi Bank)",
        "value": "CITI (Citi Bank)"
    },
    "CORB (Corporation Bank)": {
        "label": "CORB (Corporation Bank)",
        "value": "CORB (Corporation Bank)"
    },
    "CSYB (Catholic Syrian Bank)": {
        "label": "CSYB (Catholic Syrian Bank)",
        "value": "CSYB (Catholic Syrian Bank)"
    },
    "DENB (Dena Bank)": {
        "label": "DENB (Dena Bank)",
        "value": "DENB (Dena Bank)"
    },
    "DNLM (Dhanlaxmi Bank)": {
        "label": "DNLM (Dhanlaxmi Bank)",
        "value": "DNLM (Dhanlaxmi Bank)"
    },
    "FEDB (Federal Bank)": {
        "label": "FEDB (Federal Bank)",
        "value": "FEDB (Federal Bank)"
    },
    "HDFC (HDFC Bank)": {
        "label": "HDFC (HDFC Bank)",
        "value": "HDFC (HDFC Bank)"
    },
    "ICICI (ICICI Bank)": {
        "label": "ICICI (ICICI Bank)",
        "value": "ICICI (ICICI Bank)"
    },
    "IDBI (IDBI Bank)": {
        "label": "IDBI (IDBI Bank)",
        "value": "IDBI (IDBI Bank)"
    },
    "INDNB (Indian Bank)": {
        "label": "INDNB (Indian Bank)",
        "value": "INDNB (Indian Bank)"
    },
    "INDU (IndusInd Bank)": {
        "label": "INDU (IndusInd Bank)",
        "value": "INDU (IndusInd Bank)"
    },
    "INOB (Indian Overseas Bank)": {
        "label": "INOB (Indian Overseas Bank)",
        "value": "INOB (Indian Overseas Bank)"
    },
    "IN_APGVB (Andhra Pradesh Grameena Vikas Bank)": {
        "label": "IN_APGVB (Andhra Pradesh Grameena Vikas Bank)",
        "value": "IN_APGVB (Andhra Pradesh Grameena Vikas Bank)"
    },
    "IN_CUB (City Union Bank)": {
        "label": "IN_CUB (City Union Bank)",
        "value": "IN_CUB (City Union Bank)"
    },
    "IN_HSBC (Hongkong and Shanghai Banking Corporation Limited India)": {
        "label": "IN_HSBC (Hongkong and Shanghai Banking Corporation Limited India)",
        "value": "IN_HSBC (Hongkong and Shanghai Banking Corporation Limited India)"
    },
    "IN_IDFC (IDFC First Bank)": {
        "label": "IN_IDFC (IDFC First Bank)",
        "value": "IN_IDFC (IDFC First Bank)"
    },
    "IN_KVB (Karur Vysya Bank)": {
        "label": "IN_KVB (Karur Vysya Bank)",
        "value": "IN_KVB (Karur Vysya Bank)"
    },
    "IN_LVB (Lakshmi Vilas Bank)": {
        "label": "IN_LVB (Lakshmi Vilas Bank)",
        "value": "IN_LVB (Lakshmi Vilas Bank)"
    },
    "IN_PMCB (Punjab and Maharashtra Co-operative Bank Limited)": {
        "label": "IN_PMCB (Punjab and Maharashtra Co-operative Bank Limited)",
        "value": "IN_PMCB (Punjab and Maharashtra Co-operative Bank Limited)"
    },
    "IN_USFB (Ujjivan Small Finance Bank)": {
        "label": "IN_USFB (Ujjivan Small Finance Bank)",
        "value": "IN_USFB (Ujjivan Small Finance Bank)"
    },
    "JAKB (Jammu and Kashmir Bank)": {
        "label": "JAKB (Jammu and Kashmir Bank)",
        "value": "JAKB (Jammu and Kashmir Bank)"
    },
    "KARBK (Karnataka Bank)": {
        "label": "KARBK (Karnataka Bank)",
        "value": "KARBK (Karnataka Bank)"
    },
    "KOTBK (Kotak Mahindra Bank)": {
        "label": "KOTBK (Kotak Mahindra Bank)",
        "value": "KOTBK (Kotak Mahindra Bank)"
    },
    "MHRT (Bank of Maharashtra)": {
        "label": "MHRT (Bank of Maharashtra)",
        "value": "MHRT (Bank of Maharashtra)"
    },
    "OBOC (Oriental Bank of Commerce)": {
        "label": "OBOC (Oriental Bank of Commerce)",
        "value": "OBOC (Oriental Bank of Commerce)"
    },
    "PASB (Punjab and Sind Bank)": {
        "label": "PASB (Punjab and Sind Bank)",
        "value": "PASB (Punjab and Sind Bank)"
    },
    "PNJB (Punjab National Bank)": {
        "label": "PNJB (Punjab National Bank)",
        "value": "PNJB (Punjab National Bank)"
    },
    "SBBJ (State Bank of Bikaner and Jaipur)": {
        "label": "SBBJ (State Bank of Bikaner and Jaipur)",
        "value": "SBBJ (State Bank of Bikaner and Jaipur)"
    },
    "SBIN (State Bank)": {
        "label": "SBIN (State Bank)",
        "value": "SBIN (State Bank)"
    },
    "SBOH (State Bank of Hyderabad)": {
        "label": "SBOH (State Bank of Hyderabad)",
        "value": "SBOH (State Bank of Hyderabad)"
    },
    "SBOT (State Bank of Travancore)": {
        "label": "SBOT (State Bank of Travancore)",
        "value": "SBOT (State Bank of Travancore)"
    },
    "SCTRD (Standard Chartered Bank)": {
        "label": "SCTRD (Standard Chartered Bank)",
        "value": "SCTRD (Standard Chartered Bank)"
    },
    "SIBK (South Indian Bank)": {
        "label": "SIBK (South Indian Bank)",
        "value": "SIBK (South Indian Bank)"
    },
    "SYNB (Syndicate Bank)": {
        "label": "SYNB (Syndicate Bank)",
        "value": "SYNB (Syndicate Bank)"
    },
    "TAMB (Tamilnadu Mercantile Bank)": {
        "label": "TAMB (Tamilnadu Mercantile Bank)",
        "value": "TAMB (Tamilnadu Mercantile Bank)"
    },
    "UCOB (UCO Bank)": {
        "label": "UCOB (UCO Bank)",
        "value": "UCOB (UCO Bank)"
    },
    "UNBOI (Union Bank of India)": {
        "label": "UNBOI (Union Bank of India)",
        "value": "UNBOI (Union Bank of India)"
    },
    "VJYB (Vijaya Bank)": {
        "label": "VJYB (Vijaya Bank)",
        "value": "VJYB (Vijaya Bank)"
    },
    "YESB (YES Bank)": {
        "label": "YESB (YES Bank)",
        "value": "YESB (YES Bank)"
    },
    "JP_BOF (Bank of Fukuoka)": {
        "label": "JP_BOF (Bank of Fukuoka)",
        "value": "JP_BOF (Bank of Fukuoka)"
    },
    "JP_BOY (Bank of Yokohama)": {
        "label": "JP_BOY (Bank of Yokohama)",
        "value": "JP_BOY (Bank of Yokohama)"
    },
    "JP_CBB (Chiba Bank)": {
        "label": "JP_CBB (Chiba Bank)",
        "value": "JP_CBB (Chiba Bank)"
    },
    "JP_HKB (Hokkaido Bank)": {
        "label": "JP_HKB (Hokkaido Bank)",
        "value": "JP_HKB (Hokkaido Bank)"
    },
    "JP_HNB (Higashi-Nippon Bank)": {
        "label": "JP_HNB (Higashi-Nippon Bank)",
        "value": "JP_HNB (Higashi-Nippon Bank)"
    },
    "JP_HRB (Hokuriku Bank)": {
        "label": "JP_HRB (Hokuriku Bank)",
        "value": "JP_HRB (Hokuriku Bank)"
    },
    "JP_JPB (Japan Post Bank)": {
        "label": "JP_JPB (Japan Post Bank)",
        "value": "JP_JPB (Japan Post Bank)"
    },
    "JP_KMB (Kansai Mirai Bank Ltd)": {
        "label": "JP_KMB (Kansai Mirai Bank Ltd)",
        "value": "JP_KMB (Kansai Mirai Bank Ltd)"
    },
    "JP_MNB (Minna Bank)": {
        "label": "JP_MNB (Minna Bank)",
        "value": "JP_MNB (Minna Bank)"
    },
    "JP_MUFG (MUFG Bank)": {
        "label": "JP_MUFG (MUFG Bank)",
        "value": "JP_MUFG (MUFG Bank)"
    },
    "JP_MZB (Mizuho Bank)": {
        "label": "JP_MZB (Mizuho Bank)",
        "value": "JP_MZB (Mizuho Bank)"
    },
    "JP_RSB (Resona Bank)": {
        "label": "JP_RSB (Resona Bank)",
        "value": "JP_RSB (Resona Bank)"
    },
    "JP_SMFC (Sumitomo Mitsui Banking Corporation)": {
        "label": "JP_SMFC (Sumitomo Mitsui Banking Corporation)",
        "value": "JP_SMFC (Sumitomo Mitsui Banking Corporation)"
    },
    "JP_TJSB (The Juhachi-Shinwa Bank Ltd)": {
        "label": "JP_TJSB (The Juhachi-Shinwa Bank Ltd)",
        "value": "JP_TJSB (The Juhachi-Shinwa Bank Ltd)"
    },
    "JP_TKB (The Kumamoto Bank Ltd)": {
        "label": "JP_TKB (The Kumamoto Bank Ltd)",
        "value": "JP_TKB (The Kumamoto Bank Ltd)"
    },
    "JP_TNB (The Norinchukin Bank)": {
        "label": "JP_TNB (The Norinchukin Bank)",
        "value": "JP_TNB (The Norinchukin Bank)"
    },
    "KR_BANKOFCOREA (Bank of Korea)": {
        "label": "KR_BANKOFCOREA (Bank of Korea)",
        "value": "KR_BANKOFCOREA (Bank of Korea)"
    },
    "KR_BNK (Busan Bank)": {
        "label": "KR_BNK (Busan Bank)",
        "value": "KR_BNK (Busan Bank)"
    },
    "KR_CTK (Citibank Korea)": {
        "label": "KR_CTK (Citibank Korea)",
        "value": "KR_CTK (Citibank Korea)"
    },
    "KR_DGB (DAEGU Bank)": {
        "label": "KR_DGB (DAEGU Bank)",
        "value": "KR_DGB (DAEGU Bank)"
    },
    "KR_HBG (KEB Hana Bank)": {
        "label": "KR_HBG (KEB Hana Bank)",
        "value": "KR_HBG (KEB Hana Bank)"
    },
    "KR_IBK (Industrial Bank of Korea)": {
        "label": "KR_IBK (Industrial Bank of Korea)",
        "value": "KR_IBK (Industrial Bank of Korea)"
    },
    "KR_KDB (Korea Development Bank)": {
        "label": "KR_KDB (Korea Development Bank)",
        "value": "KR_KDB (Korea Development Bank)"
    },
    "KR_KKB (KB Kookmin Bank)": {
        "label": "KR_KKB (KB Kookmin Bank)",
        "value": "KR_KKB (KB Kookmin Bank)"
    },
    "KR_KWB (Kwangju Bank)": {
        "label": "KR_KWB (Kwangju Bank)",
        "value": "KR_KWB (Kwangju Bank)"
    },
    "KR_NOB (Nonghyup Bank)": {
        "label": "KR_NOB (Nonghyup Bank)",
        "value": "KR_NOB (Nonghyup Bank)"
    },
    "KR_SHB (Shinhan Bank)": {
        "label": "KR_SHB (Shinhan Bank)",
        "value": "KR_SHB (Shinhan Bank)"
    },
    "KR_WOB (Woori Bank)": {
        "label": "KR_WOB (Woori Bank)",
        "value": "KR_WOB (Woori Bank)"
    },
    "MY_AMB (AmBank)": {
        "label": "MY_AMB (AmBank)",
        "value": "MY_AMB (AmBank)"
    },
    "MY_CIMB (CIMB Bank)": {
        "label": "MY_CIMB (CIMB Bank)",
        "value": "MY_CIMB (CIMB Bank)"
    },
    "MY_HLB (Hong Leong Bank)": {
        "label": "MY_HLB (Hong Leong Bank)",
        "value": "MY_HLB (Hong Leong Bank)"
    },
    "MY_HSBC (HSBC Bank)": {
        "label": "MY_HSBC (HSBC Bank)",
        "value": "MY_HSBC (HSBC Bank)"
    },
    "MY_MAYB (Maybank)": {
        "label": "MY_MAYB (Maybank)",
        "value": "MY_MAYB (Maybank)"
    },
    "MY_OCBC (OCBC Bank)": {
        "label": "MY_OCBC (OCBC Bank)",
        "value": "MY_OCBC (OCBC Bank)"
    },
    "MY_PUBLIC (Public Bank)": {
        "label": "MY_PUBLIC (Public Bank)",
        "value": "MY_PUBLIC (Public Bank)"
    },
    "MY_RHB (RHB Bank)": {
        "label": "MY_RHB (RHB Bank)",
        "value": "MY_RHB (RHB Bank)"
    },
    "MY_UOBIB (United Overseas Bank (UOB))": {
        "label": "MY_UOBIB (United Overseas Bank (UOB))",
        "value": "MY_UOBIB (United Overseas Bank (UOB))"
    },
    "TH_BANGKOK (Bangkok Bank)": {
        "label": "TH_BANGKOK (Bangkok Bank)",
        "value": "TH_BANGKOK (Bangkok Bank)"
    },
    "TH_CIMB (CIMB THAI Bank)": {
        "label": "TH_CIMB (CIMB THAI Bank)",
        "value": "TH_CIMB (CIMB THAI Bank)"
    },
    "TH_GOVERNMENTSAVINGS (Government Savings Bank)": {
        "label": "TH_GOVERNMENTSAVINGS (Government Savings Bank)",
        "value": "TH_GOVERNMENTSAVINGS (Government Savings Bank)"
    },
    "TH_KASIKORN (Kasikorn Bank)": {
        "label": "TH_KASIKORN (Kasikorn Bank)",
        "value": "TH_KASIKORN (Kasikorn Bank)"
    },
    "TH_KRUNGSRI (Bank of Ayudhya (Krungsri))": {
        "label": "TH_KRUNGSRI (Bank of Ayudhya (Krungsri))",
        "value": "TH_KRUNGSRI (Bank of Ayudhya (Krungsri))"
    },
    "TH_KRUNGTHAI (Krungthai Bank)": {
        "label": "TH_KRUNGTHAI (Krungthai Bank)",
        "value": "TH_KRUNGTHAI (Krungthai Bank)"
    },
    "TH_SIAM (Siam Commercial Bank)": {
        "label": "TH_SIAM (Siam Commercial Bank)",
        "value": "TH_SIAM (Siam Commercial Bank)"
    },
    "TH_TTBDIRECT (TMBThanachart Bank (ttb))": {
        "label": "TH_TTBDIRECT (TMBThanachart Bank (ttb))",
        "value": "TH_TTBDIRECT (TMBThanachart Bank (ttb))"
    },
    "TH_UOBT (United Overseas Bank (UOB))": {
        "label": "TH_UOBT (United Overseas Bank (UOB))",
        "value": "TH_UOBT (United Overseas Bank (UOB))"
    },
    "VN_ACB (Asia Commercial Bank)": {
        "label": "VN_ACB (Asia Commercial Bank)",
        "value": "VN_ACB (Asia Commercial Bank)"
    },
    "VN_BIDV (BIDV)": {
        "label": "VN_BIDV (BIDV)",
        "value": "VN_BIDV (BIDV)"
    },
    "VN_DONGA (DongA Bank)": {
        "label": "VN_DONGA (DongA Bank)",
        "value": "VN_DONGA (DongA Bank)"
    },
    "VN_EXIM (Eximbank)": {
        "label": "VN_EXIM (Eximbank)",
        "value": "VN_EXIM (Eximbank)"
    },
    "VN_SACOM (Sacombank)": {
        "label": "VN_SACOM (Sacombank)",
        "value": "VN_SACOM (Sacombank)"
    },
    "VN_TECHCOM (Techcombank)": {
        "label": "VN_TECHCOM (Techcombank)",
        "value": "VN_TECHCOM (Techcombank)"
    },
    "VN_TP (TPBank)": {
        "label": "VN_TP (TPBank)",
        "value": "VN_TP (TPBank)"
    },
    "VN_VIETCOM (Vietcombank)": {
        "label": "VN_VIETCOM (Vietcombank)",
        "value": "VN_VIETCOM (Vietcombank)"
    },
    "VN_VIETIN (VietinBank)": {
        "label": "VN_VIETIN (VietinBank)",
        "value": "VN_VIETIN (VietinBank)"
    },
    "VN_VP (VPBank)": {
        "label": "VN_VP (VPBank)",
        "value": "VN_VP (VPBank)"
    }
};
export const BRIDGER_PAYMENT_ACCOUNT_TYPE_OPTIONS: any[] = [
    { label: "savings", value: "savings" },
    { label: "current", value: "current" },
    { label: "cheque", value: "cheque" },
    { label: "transmission", value: "transmission" },
    { label: "checking", value: "checking" },
    { label: "general", value: "general" },
    { label: "private", value: "private" },
    { label: "corporate", value: "corporate" },
];
export const BRIDGER_PAYMENT_ACCOUNT_TYPE_DICT: any = {
    "savings": {
        "label": "savings",
        "value": "savings"
    },
    "current": {
        "label": "current",
        "value": "current"
    },
    "cheque": {
        "label": "cheque",
        "value": "cheque"
    },
    "transmission": {
        "label": "transmission",
        "value": "transmission"
    },
    "checking": {
        "label": "checking",
        "value": "checking"
    },
    "general": {
        "label": "general",
        "value": "general"
    },
    "private": {
        "label": "private",
        "value": "private"
    },
    "corporate": {
        "label": "corporate",
        "value": "corporate"
    }
};
export function validateBridgerCurrencyAmount({ currency, amount }: { currency: string; amount: number; }): boolean {
    switch (currency.toUpperCase()) {
        case "CNY":
            return amount >= 10000 && amount <= 50000;
        case "IDR":
            return amount >= 500000 && amount <= 25000000;
        case "INR":
            return amount >= 1000 && amount <= 500000;
        case "JPY":
            return amount >= 5000 && amount <= 1000000;
        case "KRW":
            return amount >= 10000 && amount <= 6000000;
        case "MYR":
            return amount >= 50 && amount <= 20000;
        case "THB":
            return amount >= 100 && amount <= 100000;
        case "VND":
            return amount >= 100000 && amount <= 100000000;
        default:
            return false; // Currency not supported
    }
}
export function ReturnBridgerCurrencyAmount({ currency }: { currency: string; }): string {
    switch (currency.toUpperCase()) {
        case "CNY":
            return "amount should be between 10,000 and 50,000";
        case "IDR":
            return "amount should be between 500,000 and 25,000,000";
        case "INR":
            return "amount should be between 1,000 and 500,000";
        case "JPY":
            return "amount should be between 5,000 and 1,000,000";
        case "KRW":
            return "amount should be between 10,000 and 6,000,000";
        case "MYR":
            return "amount should be between 50 and 20,000";
        case "THB":
            return "amount should be between 100 and 100,000";
        case "VND":
            return "amount should be between 100000 and 100,000,000";
        default:
            return ""; // Currency not supported
    }
}
export function validateNamesRegex(text: string) {
    if (!text || text === "") return false;

    var _regexComma = /^([\\D\\-\\.,']*[^0-9]*)+$/g;
    return text.match(_regexComma) ? true : false;
}
export const NACE_CRYPTO_CURRENCIES = [
    {
        "label": "BTC",
        "value": "btc",
        "BTCBlockchain": "mainnet"
    },
    {
        "label": "BCH",
        "value": "bch",
        "BTCBlockchain": "mainnet"
    },
    {
        "label": "ETH",
        "value": "eth",
        "BTCBlockchain": "mainnet"
    },
    {
        "label": "LTC",
        "value": "ltc",
        "BTCBlockchain": "mainnet"
    },
    {
        "label": "DODGE",
        "value": "doge",
        "BTCBlockchain": "mainnet"
    },
    {
        "label": "USDT",
        "value": "erc20/usdt",
        "BTCBlockchain": "mainnet"
    },
    {
        "label": "XRP",
        "value": "xrp",
        "BTCBlockchain": "mainnet"
    },
    {
        "label": "USDC",
        "value": "erc20/usdc",
        "BTCBlockchain": "mainnet"
    },
    {
        "label": "USDT (TRC20)",
        "value": "usdt_tron",
        "BTCBlockchain": "mainnet"
    },
    {
        "label": "SOL",
        "value": "sol",
        "BTCBlockchain": "mainnet"
    },
    {
        "label": "BNB",
        "value": "bnb",
        "BTCBlockchain": "mainnet"
    },
    {
        "label": "DASH",
        "value": "dash",
        "BTCBlockchain": "mainnet"
    },
    {
        "label": "ADA Cardano",
        "value": "ada",
        "BTCBlockchain": "mainnet"
    },
    {
        "label": "AVAX Avalanche",
        "value": "avax",
        "BTCBlockchain": "mainnet"
    },
    {
        "label": "Polygon (Matic)",
        "value": "matic_poly",
        "BTCBlockchain": "mainnet"
    },
    {
        "label": "SHIB",
        "value": "erc20/shib",
        "BTCBlockchain": "mainnet"
    }
];
export function isMarketEquityPaymentVisible(PoolID: number, PaymentName:string) {
    if (PoolID === EMARKET_EQUITY_POOLS.DefaultPool) {
        return MARKET_EQUITY_PAYMENT_POOLS.DefaultPool.find((item: string) => item === PaymentName.toLowerCase());
    }
    if (PoolID === EMARKET_EQUITY_POOLS.DefaultWG) {
        return MARKET_EQUITY_PAYMENT_POOLS.DefaultWG.find((item: string) => item === PaymentName.toLowerCase());
    }
    if (PoolID === EMARKET_EQUITY_POOLS.ROW) {
        return MARKET_EQUITY_PAYMENT_POOLS.ROW.find((item: string) => item === PaymentName.toLowerCase());
    }
    if (PoolID === EMARKET_EQUITY_POOLS.IB_USER) return false;
    if (PoolID === EMARKET_EQUITY_POOLS.Bonus) return false;

    return false;
}